(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';
window.ancestry = window.ancestry || {};
module.exports = window.ancestry;

},{}],2:[function(require,module,exports){
'use strict';

module.exports = function(namespace){
	return {
		getValue: function (key) {
			try {
				return localStorage.getItem(namespace + key);
			} catch (err) {
				return null;
			}
		},
		setValue: function (key, val) {
			try {
				localStorage.setItem(namespace + key, val);
			} catch (err) { }
		}
	};
};
},{}],3:[function(require,module,exports){
'use strict';

var _ = window._;
var popStateListeners = [];

module.exports = {
	getUrl: function(){
		return window.location.href;
	},
	getTitle: function(){
		return document.title;
	},
	replaceState: function(data, title, url){
		history.replaceState(data, title, url);
	},
	registerPopStateListener: function(callback){
		if (!_.includes(popStateListeners, callback)) {
			popStateListeners.push(callback);
		}
	},
	unregisterPopStateListener: function(callback){
		_.remove(popStateListeners, function(listener){ return listener === callback; });
	}
};

window.onpopstate = function(event){
	popStateListeners.forEach(function(callback){
		callback(window.location.href, event);
	});
};

},{}],4:[function(require,module,exports){
'use strict';

var $ = window.$;
var angular = window.angular;
window.Promise = require('es6-promise-polyfill').Promise;  // Polyfill Promise
window.urlCanonicalizer = require('url-canonicalizer');

angular.module('SliderApp', []);  /* Define "SliderApp" in case sliders fails to load */
angular.module('SearchFormServiceUI', []);   /* Define "SearchFormServiceUI" in case SearchForms fails to load */
angular.module('SearchResults', ['SliderApp', 'SearchFormServiceUI']);  /* Define primary angular App dependent on SlidersApp & SearchFormServiceUI */

$(function(){
	angular.bootstrap($('#SearchResultsPage'), ["SearchResults"]);
});

},{"es6-promise-polyfill":39,"url-canonicalizer":69}],5:[function(require,module,exports){
var log = require('../../lib/logging');

module.exports = {
	clusterView: {
		trackPersonClick:               function(modalName) { return trackAction("tree person clicked", modalName);            },
		trackContactTreeOwnerClick:     function(modalName) { return trackAction("contact tree owner clicked", modalName);     },
		trackFamilyMemberClick:         function(modalName) { return trackAction("family member clicked", modalName);          },
		trackSeeAllFamilyMembersClick:  function(modalName) { return trackAction("see all family members clicked", modalName); },
		trackClusterClick:              function(modalName) { return trackAction("tree cluster clicked", modalName);           },
		trackTreeLinkClick:             function(isPrivateTree, modalName) {
			var parsedIsPrivateTree = isPrivateTree === 'true'? true : false;
			return parsedIsPrivateTree
				? trackAction("private tree link clicked", modalName)
				: trackAction("public tree link clicked", modalName);
		}
	}
};

function trackAction(eventName, modalName) {
	try {
		var omnitureLinkFunctionExists = window.utag && typeof(window.utag.link) === 'function';
		var omniturePageNameExists = window.utag && window.utag.data && window.utag.data.page_name;
		var actionName = !!modalName ?
			window.utag.data.page_name + " : " + modalName + " : " + eventName :
			window.utag.data.page_name + " : " + eventName;

		if (omnitureLinkFunctionExists && omniturePageNameExists) {
			var payload = {
				"link_name": eventName,
				"action": actionName
			};
			window.utag.link(payload);
		} else {
			log.warn("Tealium", "utag.link or utag.data.page_name not found on the page");
		}
	} catch (err) {
		log.error("Tealium", err, null, null, payload);
	}
	return true;
}

},{"../../lib/logging":9}],6:[function(require,module,exports){
'use strict';
var facetFieldsService = require('../../lib/proxies/facetFieldsServiceProxy');
var lastSearchProxy = require('../../lib/proxies/lastSearchProxy');
var searchResultsService = require('../../lib/proxies/searchResultsServiceProxy');
var browseCollectionServiceProxy = require('../../lib/proxies/browseCollectionServiceProxy');

lastSearchProxy.init({ urlPrefix: '/api/search-results' });
searchResultsService.init({ urlPrefix: '/api/search-results' });
facetFieldsService.init({ urlPrefix: '/api/facet-fields' });
browseCollectionServiceProxy.init({ urlPrefix: '/api/browse-collection' });

},{"../../lib/proxies/browseCollectionServiceProxy":27,"../../lib/proxies/facetFieldsServiceProxy":28,"../../lib/proxies/lastSearchProxy":29,"../../lib/proxies/searchResultsServiceProxy":31}],7:[function(require,module,exports){
require('./lib/common');
require('./lib/serviceDiscovery');
var $ = window.$;
var _ = window._;
var dust = require('dust');
var urlCanonicalizer = require('url-canonicalizer');
var ancestryData = require('./browserAbstractions/ancestryData');
var localStorage = require('./browserAbstractions/localStorage')('searchui-resultsui.');
var urlManager = require('./browserAbstractions/urlManager');
var pub = require('../lib/pubRepository');
var searchResultsProvider = require('../lib/searchResultsProvider');
var searchRecordServiceProxy = require('../lib/proxies/searchRecordServiceProxy');
var log = require('../lib/logging');
var lastSearchProxy = require('../lib/proxies/lastSearchProxy');
var tracking = require('./lib/omnitureTracking');
var shortcutKeysController = require('./widgets/shortcutKeysController');
var calendar = require('./widgets/calendarWidget');
var browseWidget = require('./widgets/browseWidget');
var bookWidget = require('./widgets/bookWidget');
var TreeSelectionModal = require('./widgets/TreeSelectionModal');

ancestryData.searchResults = ancestryData.searchResults || {};
ancestryData.searchResults.createTreeSelectionModal = TreeSelectionModal;

$(function() {
	var isResultsView = $("#searchResults").length > 0;
	var hasSlidersWidget = $("form[name='SliderForm']").length > 0;

	var dataModel = ancestryData.search.dataModel;
	var pageModel = ancestryData.search.pageModel;

	if (isResultsView || hasSlidersWidget) {
		configureRefineDialog();
		shortcutKeysController.init();
	}

	ancestryData.searchResults.tracking = tracking;

	$('#searchResultActivityIndicator').fixedsticky();

	function initializeCategoryViewSortDropDown () {
		$('#sortByCallout').callout({
			classes: 'calloutMenu',
			content: '#categoryViewSortMenu'
		});
	}

	function initializeSmartFiltering () {
		$('#smartFilterCalloutTrigger').callout({
			'content': '#recordJudgmentCallout',
			'type': 'hover'
		});

		$('#smartFilteringWhy').click(function() {
			$('#smartFilteringWhy').addClass('noDisplay');
			$('#smartFilteringWhyText').removeClass('noDisplay');
		});

		$('#smartFilteringToggle').click(onSmartFilteringToggle);
	}

	function onSmartFilteringToggle () {
		$('#smartFilterCalloutTrigger').callout('close');

		var url = 'https://' + ancestryData.domains.ancestry + '/api/search-results/smart-filtering';

		var data = {
			isEnabled: !ancestryData.search.isSmartFilteringEnabled,
			treePerson: {
				treeId: dataModel.treePerson.treeId,
				personId: dataModel.treePerson.personId
			}
		};

		$.ajax({
			type: 'POST',
			contentType: 'application/json; charset=UTF-8',
			url: url,
			data: JSON.stringify(data),
			timeout: 1000,
			success: reloadPage,
			dataType: 'json'
		});
	}

	function reloadPage () {
		dataModel.page.number = 1;
		dataModel.page.cursor = null;

		var queryParams = urlCanonicalizer.queryParamNormalizer.toQueryParams(dataModel, 'searchResults');
		window.location.href = window.location.href.split('?')[0] + '?' + queryParams.queryString;
	}

	if (isResultsView) {
		initializeSmartFiltering();
		initializeCategoryViewSortDropDown();
	}

	function onPageSizeChanged () {
		dataModel.page.number = 1;
		dataModel.page.size = parseInt(this.value);
		dataModel.page.cursor = null;

		saveUserPreferences({resultsPageSize: dataModel.page.size});

		var queryParams = urlCanonicalizer.queryParamNormalizer.toQueryParams(dataModel, 'searchResults');
		window.location.href = window.location.href.split('?')[0] + '?' + queryParams.queryString;
	}

	function initializePaging () {
		if (!$('#pagingInfo').length) {
			return;
		}

		$('#pagingInfo').paging({
			total: pageModel.max,
			current: dataModel.page.number,
			allowedPages: pageModel.allowedPages,
			onChange: function(page) {
				dataModel.page.number = page;
				loadSearchResults();

				// Removes focus from paging dropdown (last selected element) after change made
				window.document.activeElement.blur();
			},
			display: 'select'
		});
		$('#searchPageSize').val(dataModel.page.size.toString());
	}

	if (isResultsView) {
		initializePaging();
		if ($('#searchPageSize').length) {
			$('#searchPageSize').change(onPageSizeChanged);
		}

		if ($('#pagingPer').length) {
			$('#pagingPer').change(onPageSizeChanged);
		}

		dataModel.page = pageModel;
	}

	function getViewModeUrl (dataModel, viewMode) {
		var dataModelClone = _.cloneDeep(dataModel);
		dataModelClone.page.number = 1;
		dataModelClone.page.cursor = null;
		dataModelClone.viewMode = viewMode;
		var queryParams = urlCanonicalizer.queryParamNormalizer.toQueryParams(dataModelClone, 'searchResults');
		return '?' + queryParams.queryString;
	}

	if (isResultsView) {
		urlManager.replaceState(dataModel, urlManager.getTitle(), urlManager.getUrl());
		urlManager.registerPopStateListener(function(location, event) {
			var savedQueryModel = event.state;
			_.assign(dataModel, savedQueryModel);
			initializePaging();
			loadSearchResults(false);
		});
	}

	function setLastSearch (queryParams) {
		if (!queryParams) {
			queryParams = urlCanonicalizer.queryParamNormalizer.toQueryParams(dataModel, 'searchResults');
		}
		lastSearchProxy.saveLastSearch(window.location.pathname + '?' + queryParams.queryString);
	}

	function getCookie (cname) {
		var name = cname + '=';
		var decodedCookie = decodeURIComponent(window.document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length);
			}
		}
		return '';
	}

	var lastSearchToken = null;

	function loadSearchResults (updateUrl) {
		// Let's close any open callouts, otherwise they may not appear after next/page is loaded
		$.callout.close();

		updateUrl = updateUrl !== false;
		var queryParams = urlCanonicalizer.queryParamNormalizer.toQueryParams(dataModel, 'searchResults');

		setLastSearch(queryParams);

		var recordViewUrl = getViewModeUrl(dataModel, 'record');
		var categoryViewUrl = getViewModeUrl(dataModel, 'category');
		lastSearchToken = queryParams;
		$("html, body").animate({scrollTop: 0}, 250);
		$('#searchResultActivityIndicatorContainer').removeClass('hideVisibility');

		var viewModelOptions = {
			dataModel: dataModel,
			partnerId: ancestryData.partner,
			domain: ancestryData.domains.ancestry,
			attCookie: null,
			req: {
				cookies: {
					"ExperimentOverrides": getCookie("ExperimentOverrides")
				}
			},
			debug: false,
			cultureId: $('html').attr('lang') || 'en-US',
			baseUrl: window.location.protocol + '//' + window.location.hostname + window.location.pathname,
			useClusterView: ancestryData.search.useClusterView,
			searchState: 'Pagination'
		};

		if (updateUrl) {
			history.pushState(dataModel, urlManager.getTitle(), '?' + queryParams.queryString);
		}

		return searchResultsProvider.getSearchResultsViewModel(viewModelOptions).then(function(searchModel) {

			// Only last search request performed updates results
			if (queryParams !== lastSearchToken) {
				return Promise.reject(new Error('Error: Only last search request performed updates results'));
			}

			lastSearchToken = null;
			pageModel = searchModel.results.page;
			dataModel.page = pageModel;

			$('#pagingInfo').paging('replaceDropdown', pageModel.allowedPages);
			var isOnlyTreesType = dataModel.types.trees && !dataModel.types.records && !dataModel.types.stories && !dataModel.types.photos;
			var isTreesCategory = dataModel.categories.length === 1 && dataModel.categories[0].id === '42';
			var viewModel = {
				results: searchModel.results,
				isCollectionResults: dataModel.collections.length === 1,
				viewModeModel: {
					isRecordView: dataModel.viewMode !== 'category',
					reviewViewUrl: recordViewUrl,
					categoryViewUrl: categoryViewUrl
				},
				isLoggedIn: ancestryData.search.isLoggedIn,
				isTreeResults: isOnlyTreesType || isTreesCategory
			};

			var renderHeaderPromise = dust.renderPromise('partials/resultsHeader', viewModel).then(function(htmlStr) {
				$("#searchResultsContainer .conHeader").html(htmlStr);
			});
			var renderFooterPromise = dust.renderPromise('partials/resultsFooter', viewModel).then(function(htmlStr) {
				$("#footerHitCount").html(htmlStr);
			});
			var resultsPartial = searchModel.results.items.length ? 'partials/results' : 'partials/genericError';
			var renderSearchResultsPromise = dust.renderPromise(resultsPartial, viewModel).then(function (htmlStr) {
				$('#searchResultActivityIndicatorContainer').addClass('hideVisibility');
				$("#searchResults").html(htmlStr);
			});
			if (_.has(window, ['ancestry', 'search', 'debug', 'renderDebugPanel'])) {
				window.ancestry.search.debug.renderDebugPanel(searchModel.debug);
			}

			return Promise.all([renderHeaderPromise, renderFooterPromise, renderSearchResultsPromise]);
		}).then(function() {
			// Instantiate callouts for family member cards (only do this if user not logged in)
			if (!ancestryData.search.isLoggedIn) {
				var userCardsLoggedOut = $('#searchResults').find('div.userCardLoggedOut');
				userCardsLoggedOut.callout({
					content: userCardsLoggedOut.attr('data-callout'),
					type: 'hover',
					style: 'dark',
					calloutClasses: 'smallLineHeight'
				});
			}

			shortcutKeysController.reset();
		}).catch(function(err) {
			$('#searchResultActivityIndicatorContainer').addClass('hideVisibility');
			// TODO: Render error web page or inline error message
			log.error("SearchResults", err);
			return Promise.reject(err);
		});
	}

	ancestryData.searchResults.load = loadSearchResults;

	/* Record preview (hover) */
	var PREVIEW_DELAY = 300;
	ancestryData.searchResults.doRecordPreview = function(doDelay, element, collectionId, recordId, queryId) {
		if (!doDelay) {
			showRecordPreview(element, collectionId, recordId, queryId);
			return;
		}

		var timeout = setTimeout(function() {
			showRecordPreview(element, collectionId, recordId, queryId);
		}, PREVIEW_DELAY);

		$(element).on('mouseleave.recordHover', function() {
			clearTimeout(timeout);
		});
	};

	function showRecordPreview (element, collectionId, recordId, queryId) {
		// TODO: Localize url --- make page name specific to market/partner - old stack pulls this from site setting "Omniture_PageName_SiteName"
		var pageName = "ancestry us : search : results"; //TODO: figure out correct page name here
		var getRecordOptions = {
			partner: ancestryData.partner,
			dataModel: dataModel,
			pub: pub,
			collectionId: collectionId,
			recordId: recordId,
			environmentDomainStr: ancestryData.environmentDomainStr,
			domain: ancestryData.domains.ancestry,
			client: "searchui-resultsui",
			usage: "Hover",
			pageName: pageName,
			req: null,
			queryId: queryId
		};
		searchRecordServiceProxy.getRecord(getRecordOptions, function(err, record) {
			if (err) {
				log.error("RecordPreview", err);
				return;
			}
			//TODO: add any additional properties to record for hover
			if ($(element).data('previewInitialized')) {
				return;
			}

			if (record) {
				record.queryId = queryId;
			}

			// Localize the hit count.
			if (record && record.results) {
				if (record.results.hitCount) {
					record.results.hitCount = record.results.hitCount.toLocaleString();
				}
				else if (record.results.totalResults) {
					record.results.totalResults = record.results.totalResults.toLocaleString();
				}
			}
			dust.renderPromise('partials/result-preview', {record: record}).then(function(htmlStr) {
				var options = {
					content: htmlStr,
					classes: 'recordPreviewContainer',
					type: 'hover',
					showDelay: 0,
					position: 'right',
					onOpen: function() {
						var preview = $('.recordPreview');
						var dataHeight = $(window).height() - 200;
						preview.find('.previewData').css({"max-height": dataHeight});
					},
					onClose: function() {
						// Ensure click and mouse events are removed from the shared callout element
						$('#calloutContent').off('click.searchui.recordhover mouseover.searchui.recordhover mouseout.searchui.recordhover');
					},
					onAfterOpen: function() {
						//Probate Table of Contents
						$('.toc-hover-moretext').on('click', function(e) {
							var $event = $.Event(e);
							var srcElem = $event.target || e.srcElement || e.target;

							var tocId = $(srcElem).attr('data-tocid');

							var $hidden = $('#' + tocId + ' .hideVisually');
							$hidden.removeClass('hideVisually');
							$(srcElem).hide();

							$event.stopPropagation();
							$event.stopImmediatePropagation();
							$event.preventDefault();
						});

						// Make entire hover callout go to link on click and show hover
						//TODO: can we get rid of this somehow?
						$('#calloutContent').on('click.searchui.recordhover', function() {
							var actionUrl = $('div[data-primary-action]').attr("data-primary-action");
							//TODO: can we do this without an onclick handler?
							window.location.href = actionUrl;
						}).on('mouseover.searchui.recordhover', function() {
							$('#calloutPointerShadow').css('background-color', '#f3f0e9');
						}).on('mouseout.searchui.recordhover', function() {
							$('#calloutPointerShadow').css('background-color', '#fff');
						});
					}
				};
				$(element).callout(options);
				$(element).data('previewInitialized', true);
				$(element).callout('open');
			});
		});
	}

	if (dataModel.treePerson.treeId && dataModel.treePerson.personId) {
		var filteringClosed;
		var filteringClosedKey = 'smartFilteringHide' + dataModel.treePerson.treeId + '-' + dataModel.treePerson.personId;
		var toggleShowSmartFiltering = function() {
			$('#recordJudgments').animate({'max-height': filteringClosed ? 230 : 0}, 200,
				function() {
					setFilteringUi(filteringClosed);
					localStorage.setValue(filteringClosedKey, filteringClosed);
				});
			filteringClosed = !filteringClosed;
		};
		$('.filterVisibilityToggle')
			.on('click', function() {
				toggleShowSmartFiltering();
			});

		if (localStorage.getValue(filteringClosedKey) === "true") {
			filteringClosed = true;
			setFilteringUi(filteringClosed);
			$('#recordJudgments').css('max-height', 0);
		}
	}

	function setFilteringUi (filteringClosed) {
		var button = $('.filterVisibilityToggle');
		var openCaption = button.data('openCaption');
		var closeCaption = button.data('closeCaption');

		button.text(filteringClosed ? openCaption : closeCaption)
			.removeClass(filteringClosed ? 'iconArrowSmallUpAfter' : 'iconArrowSmallDownAfter')
			.addClass(filteringClosed ? 'iconArrowSmallDownAfter' : 'iconArrowSmallUpAfter');
	}

	function navDropDown (thisJQElm) {
		var $el = $(thisJQElm),
			tempLIElm = $el.parent().closest('li'),
			tempElm = tempLIElm.find('.subNavList');
		tempElm.toggleClass('noDisplay');
		if ($el.hasClass('iconArrowSmallRight')) {
			$el.addClass('iconArrowSmallDown').removeClass('iconArrowSmallRight');
		}
		else {
			$el.addClass('iconArrowSmallRight').removeClass('iconArrowSmallDown');
		}
	}

	function configureRefineDialog () {
		// Define behavior for the "Edit" button so that it opens a modal that has the search form in it.
		window.ancestry.search.editSearch = function() {
			$('#RefineSearchWindow').modal({
				width: 600,
				onClose: function() {
					/* When the modal with the search form closes, give focus to the "Edit" button that caused the modal to open */
					$(".searchRefined button.editSearch").focus();
				}
			});
		};

		// Logic for centering the Modal with the Search Form as the user expands / collapses more options on a global search form.
		// Note: This initialization needs to run after AngularJS bootstrap call, so have it sleep 1ms to push this execution past
		// all other DOM Ready event handlers
		window.setTimeout(function() {
			var showOptions = $('#RefineSearchWindow button.sfsShowMoreOptionsBtn');
			showOptions.bind('click', function() {
				$.modal.center();
			});
		});
	}

	$('.facetDropDown')
		.off('click')
		.off('keyup')
		.on('click', function(event) {
			if (event.target) {
				navDropDown(event.target);
			}
		})
		.on('keyup', function(event) {
			if (event.keyCode == 13) {
				navDropDown(event.target);
			}
		});

	ancestryData.searchResults.logAndNavigate = function(element, queryId, collectionId, recordId, imageId, intentType, intentOrigin) {
		var data = {
			"GroupName": "searchui",
			"ServiceName": "resultsui",
			"Host": "Browser",
			"QueryId": queryId,
			"DatabaseId": collectionId,
			"RecordId": recordId,
			"ImageId": imageId,
			"IntentType": intentType,
			"IntentOrigin": intentOrigin
		};
		$.post({
			url: '/fel/webapi/v2/avro/SearchResults_ViewIntent_Clicks',
			data: JSON.stringify(data),
			contentType: "text/plain",
			xhrFields: {
				withCredentials: true
			},
			headers: {
				"Ancestry-CultureId": $('html').attr('lang')
			},
			timeout: ancestryData.environmentDomainStr !== "" ? 1000 : 250
		}).always(function() {
			window.location.href = element.href;
		});
	};

	/**
	 * Instantiates or shows the singleton TreeSelectionModal with appropriate data, attaching it to ancestryData.searchResults.
	 * The first time it is called, it instantiates the TreeSelectionModal.
	 * Subsequent calls just repopulate the rows of data and show the hidden modal.
	 *
	 * @method showTreeSelectionModal
	 * @async
	 * @callback searchResults#btn_clusterModal~onClick
	 * @param {Number} startIndex - A non-negative integer, representing the index of the first of the ten records to include in the TreeSelectionModal list
	 * @param {Number} clusterTreeCount - A positive integer, representing the number of trees in the cluster, accessible in SearchResults
	 * @param {String} treePersonName - The name of the search person in the primary tree of a given cluster
	 * @returns {Object} - a Promise which resolves to a rendered TreeSelectionModal, or to an Error if the data is not structured as expected
	 */
	ancestryData.searchResults.showTreeSelectionModal = function(clusterId, clusterTreeCount, treePersonName) {
		tracking.clusterView.trackClusterClick();

		/**
		 * We don't instantiate/update the TreeSelectionModal if clusterTreeCount is NaN or less than 1, or if clusterId is not a string or a :9009: clusterId.
		 */
		if (isNaN(clusterTreeCount) || clusterTreeCount < 1 || typeof clusterId !== 'string' || clusterId.indexOf(':9009:') === -1) {
			return Promise.reject(new Error('Error: invalid arguments. clusterTreeCount: ' + clusterTreeCount + ', clusterId: ' + clusterId));
		}

		// Being an event handler, the link-styled button element is the "this" context by default.
		// We use this to disable/enable and return focus to the link upon closing the modal, for accessibility reasons.
		var closeFocusTargetElement = this;

		var config = {
			containerElementSelector: '#clusterTreeModalContainer',
			closeFocusTargetElement: closeFocusTargetElement,
			clusterId: clusterId,
			clusterTreeCount: clusterTreeCount,
			pageSize: 10,
			width: 800,
			treePersonName: treePersonName
		};

		if (!ancestryData.searchResults.treeSelectionModal) {
			// Note no "new" keyword here; this is a singleton Object, so we don't need to waste memory.
			// As per Crockford, "By using new to invoke the function, the object holds onto a worthless prototype object."
			return ancestryData.searchResults.createTreeSelectionModal(config)
				.then(function(treeSelectionModal) {
					ancestryData.searchResults.treeSelectionModal = treeSelectionModal;
				});
		}
		else {
			ancestryData.searchResults.treeSelectionModal.show();
			return ancestryData.searchResults.treeSelectionModal.updateClusterTreeModalList(config);
		}
	};

	var $calendar = $('#CalendarSpot');
	if ($calendar.length > 0) {
		calendar.buildCalendar($calendar, window.dbid);
		$calendar.on('click', '.reloadCalendar', function(e) {
			e.preventDefault();
			calendar.buildCalendar($calendar, window.dbid);
		});
	}

	if ($('#standardCollectionWidget').length > 0) {
		browseWidget.init();
	}

	if ($('#bookCollectionWidget').length > 0) {
		bookWidget.init();
	}

	function saveUserPreferences (preferences) {
		$.ajax({
			type: 'POST',
			url: '/api/search-preferences',
			contentType: 'application/json; charset=UTF-8',
			data: JSON.stringify(preferences),
			processData: false,
			dataType: 'json',
			timeout: 1000
		});
	}

	// group page census preview image modal
	window.AddSampleImage = function(src, cacheDomain) {
		src = src.replace("/affiliate", "");
		var legacyAssetUrlPrefix = "https://www.ancestrycdn.com/legacy";
		var imgSrc = legacyAssetUrlPrefix + src;
		$("#overlaySampleImage").attr("src", imgSrc);
		$('#overlaySampleImageModal').modal();
	};
	window.SampleImageFull = window.AddSampleImage;
});

},{"../lib/logging":9,"../lib/proxies/lastSearchProxy":29,"../lib/proxies/searchRecordServiceProxy":30,"../lib/pubRepository":10,"../lib/searchResultsProvider":32,"./browserAbstractions/ancestryData":1,"./browserAbstractions/localStorage":2,"./browserAbstractions/urlManager":3,"./lib/common":4,"./lib/omnitureTracking":5,"./lib/serviceDiscovery":6,"./widgets/TreeSelectionModal":14,"./widgets/bookWidget":15,"./widgets/browseWidget":16,"./widgets/calendarWidget":17,"./widgets/shortcutKeysController":18,"dust":13,"url-canonicalizer":69}],8:[function(require,module,exports){
const ancestryI18n = window.ui.i18n;
const i18n = ancestryI18n(window.ancestry.search.resourceFileLocations);
const listFormatterFactory = require('../../lib/i18n-list-formatter');
const abbrMonthFormatterFactory = require('../../lib/i18n-abbreviated-month-formatter');

i18n.registerFormatter('list', listFormatterFactory(i18n));
i18n.registerFormatter('abbrMonth', abbrMonthFormatterFactory(i18n));

module.exports = i18n;
},{"../../lib/i18n-abbreviated-month-formatter":24,"../../lib/i18n-list-formatter":25}],9:[function(require,module,exports){
'use strict';
var console = window.console;
function stubFunc() { }
function consoleLog(logGrouping, err) { console.error(logGrouping + ': ' + err); }
module.exports = {
	debug: stubFunc,
	info: stubFunc,
	warn: stubFunc,
	fatal: stubFunc,
	error: consoleLog,
	getDependencyErrorHandler: function(){ 
		return function(err) { 
			return Promise.reject(err);
		};
	},
	logDependencyError: stubFunc
};

},{}],10:[function(require,module,exports){
'use strict';
module.exports = window.ancestry.pubInternal;
window.ancestry.pubInternal.getContext = function() {
	return {
		getUrl: function() {
			return window.location.href;
		},
		getPartnerId: function () {
			return (window.ancestry||{}).partner || '0';
		},
		getQueryParam: function (key) {
			var params = decodeQueryParams(window.location.search.substring(1));
			return (key in params) ? params[key] : null;
		}
	};
};

function decodeQueryParams(queryString) {
	var match,
		pl     = /\+/g,  // Regex for replacing addition symbol with a space
		search = /([^&=]+)=?([^&]*)/g,
		decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
		query  = queryString;

	var urlParams = {};
	match = search.exec(query);
	while (match) {
		urlParams[decode(match[1])] = decode(match[2]);
		match = search.exec(query);
	}
	return urlParams;
}

},{}],11:[function(require,module,exports){
'use strict';

var $ = window.$;

module.exports = {
	get: function(options, req) {
		var ajaxOptions = {
			url: options.url,
			timeout: options.timeout,
			dataType: options.json === true ? 'json' : null
		};
		return getResponseAsync(ajaxOptions, options.simple, options.resolveWithFullResponse);
	},

	post: function(options, req) {
		var ajaxOptions = {
			url: options.url,
			timeout: options.timeout,
			contentType: 'application/json; charset=UTF-8',
			method: 'POST',
			cache: false,
			data: JSON.stringify(options.body)
		};
		return getResponseAsync(ajaxOptions, options.simple, options.resolveWithFullResponse);
	}
};

function getResponseAsync(options, isSimpleRequest, resolveWithFullResponse) {
	if (!options.timeout) {
		return Promise.reject(new Error('Timeout must be provided'));
	}
	return $.ajax(options)
		.then(function(body, statusMessage, xhr){
			return getResponse(body, xhr, resolveWithFullResponse);
		})
		.catch(function(xhr, errorType, errorMessage){
			if (isSimpleRequest === false && xhr.readyState === 4) {
				var body = xhr.responseJSON || xhr.responseText;
				return getResponse(body, xhr, resolveWithFullResponse);
			}
			var err = new Error(errorMessage);
			if (xhr.status) {
				err.statusCode = xhr.status;
			}
			return Promise.reject(err);
		});
}

function getResponse(body, xhr, sendFullResponse) {
	if (sendFullResponse) {
		return Promise.resolve({
			body: body,
			statusCode: xhr.status,
			statusMessage: xhr.statusText
		});
	} else {
		return Promise.resolve(body);
	}
}

},{}],12:[function(require,module,exports){
'use strict';
module.exports = {
	"componentId": "searchui-resultsui",
	"group": "searchui",
	"service": "resultsui"
};

},{}],13:[function(require,module,exports){
'use strict';
module.exports = window.dust;
var $ = window.$;
var i18n = require('../../lib/i18n');
var i18nDustHelper = require('../../lib/dust/i18n-dust-helper');
var lifespanDustHelper = require('../../lib/dust/lifespan-dust-helper');

window.dust.renderPromise = function(viewName, viewModel) {
	return i18n.ready().then(function() {
		return new Promise(function (resolve, reject) {
			viewModel.locale = $('html').attr('lang');
			window.dust.render(viewName, viewModel, function (err, htmlStr) {
				if (err) return reject(err);
				resolve(htmlStr);
			});
		});
	}).catch(function () {
		if (console && console.err) {
			console.err(err);
			return Promise.reject(err);
		}
	});
};

i18nDustHelper(window.dust);
lifespanDustHelper(window.dust);
},{"../../lib/dust/i18n-dust-helper":20,"../../lib/dust/lifespan-dust-helper":21,"../../lib/i18n":8}],14:[function(require,module,exports){
var $ = window.$;
var dust = require('dust');
var ancestryData = require('../browserAbstractions/ancestryData');
var deepGet = window._.get;

/**
 * TreeSelectionModal class.
 * A singleton modal, which gets populated with the trees in a given cluster on the ClusterView Search Results page
 *
 * The returned Object will have the following properties and methods:
 * {String} cardType - this is used to inform the templates what to render in the modal LI elements
 * {jQuery} closeFocusTargetElement - a jQuery Object wrapping a reference to the element to receive focus after closing the HTMLTreeSelectionModal
 * {String} clusterId - A unique identifier for a given cluster of trees
 * {Number} clusterTreeCount - the number of trees comprising the cluster represented in the TreeSelectionModal
 * {jQuery} clusterTreeModalContainer - a jQuery Object wrapping a reference to the element containing the hidden template for the TreeSelectionModal
 * {jQuery} clusterTreeModalResultsLoadingContainer - a jQuery Object wrapping a reference to the element where the initial and pagination loading animations are displayed
 * {Function} hide - hides the modal widget
 * {jQuery} list - a jQuery Object wrapping a reference to the OL element containing the LI element rows of the TreeSelectionModal
 * {Object} modal - a reference to the modal widget itself
 * {jQuery} modalDarkLoading - a jQuery Object wrapping a reference to the element where the pagination loading spinner is displayed (dark background with white spinner)
 * {jQuery} modalLightLoading - a jQuery Object wrapping a reference to the element where the initial modal loading spinner is displayed (light background with black spinner)
 * {Object} page - The pagination parameters
 * {Number} page.max - The calculated maximum number of pages for the cluster - Math.ceil(clusterTreeCount / page.size)
 * {Number} page.number - The current page number
 * {Number} page.size - The number of trees to display per page
 * {Array<jQuery>} resultsLabelContainers - a jQuery Object wrapping a reference to the header and footer labels of the TreeSelectModal
 * {Function} show - shows the modal widget
 * {String} treePersonName - The name of the search person in the primary tree of a given cluster
 * {Function} updateClusterTreeModalList - re-renders the the LI element rows of the TreeSelectionModal with new data, optionally updating the closeFocusTargetElement
 * {Number} width - The width in pixels of the TreeSelectionModal
 *
 * @constructor TreeSelectionModal
 * @async
 * @param {Object} config - The configuration options
 * @param {String} config.containerElementSelector - a string representing a CSS selector for the container element of the modal template
 * @param {HTMLElement} config.closeFocusTargetElement - A reference to the element to receive focus after closing the HTMLTreeSelectionModal
 * @param {String} config.clusterId - A unique identifier for a given cluster of trees
 * @param {Number} config.clusterTreeCount - The number of trees comprising the cluster represented in the TreeSelectionModal
 * @param {Number} config.pageSize - A positive integer representing the number of trees to display on each page of the TreeSelectionModal, defaulting to 10
 * @param {String} config.treePersonName - The name of the search person in the primary tree of a given cluster, defaulting to '' if not valid
 * @param {Number} config.width - The width in pixels of the TreeSelectionModal
 * @returns {Object|null} - a Promise which resolves to a rendered TreeSelectionModal, or to null if the data is not structured as expected
 */
var TreeSelectionModal = function (config) {
	var _config = config;
	var clusterId = _config.clusterId;
	var clusterTreeCount = parseInt(_config.clusterTreeCount, 10);
	var clusterTreeModalContainer = $(_config.containerElementSelector);
	var pageSize = parseInt(_config.pageSize, 10);
	var treePersonName = typeof _config.treePersonName === 'string' ? _config.treePersonName : '';

	/**
	 * We don't instantiate the TreeSelectionModal if containerElementSelector is not a valid selector,
	 * or if clusterTreeCount is NaN or less than 1, or if pageSize is NaN or less than 1,
	 * or if pageSize is NaN or less than 1,
	 * or if clusterID is not a string or a valid :9009: clusterId.
	 */
	if (!clusterTreeModalContainer.length || isNaN(clusterTreeCount) || clusterTreeCount < 1 || isNaN(pageSize) || pageSize < 1 || typeof clusterId !== 'string' || clusterId.indexOf(':9009:') === -1) {
		return Promise.reject(new Error('Not opening modal due to bad data. containerElementSelector: ' + _config.containerElementSelector + ', clusterTreeCount: ' + clusterTreeCount + ', pageSize: ' + pageSize + ', clusterId: ' + clusterId));
	}

	// If no valid closeFocusTargetElement is provided, we will fall back to the clusterTreeModalContainer.
	var closeFocusTargetElement = $(_config.closeFocusTargetElement instanceof HTMLElement ? _config.closeFocusTargetElement : clusterTreeModalContainer);
	var onOpenLoading = false;

	/**
	 * Here we are exposing some properties to assist with manipulation of the TreeSelectionModal,
	 * and also setting some constants to avoid multiple references.
	 * Note that a newly-opened TreeSelectionModal always begins on page 1.
	 */
	var treeSelectionModal = {
		canDestroyPaging: false,
		cardType: 'TreeSelectionModal',
		closeFocusTargetElement: $(closeFocusTargetElement),
		clusterId: clusterId,
		clusterTreeCount: clusterTreeCount,
		clusterTreeModalContainer: clusterTreeModalContainer,
		page: {
			max: Math.ceil(clusterTreeCount / pageSize),
			size: pageSize,
			number: 1
		},
		treePersonName: treePersonName,
		width: _config.width
	};

	/*** PRIVATE METHODS ***/
	/**
	 * Private method _onOpen used when the tree selection modal is opened.
	 * This modal opening loading animation.
	 *
	 * @method _onOpen
	 * @private
	 * @async
	 * @callback TreeSelectionModal~_onOpen
	 */
	treeSelectionModal._onOpen = function() {
		$(treeSelectionModal.closeFocusTargetElement).attr('disabled', 'disabled');
		treeSelectionModal._showOpenLoadingAnimation();
	};

	/**
	 * Private method _onClose used when the tree selection modal is closed.
	 * This resets the page size to the original configuration, replaces the existing rows with blank placeholders,
	 * destroys paging (if it exists), and removes the results label for the next time the modal is opened.
	 * Lastly, we give focus back to the closeFocusTargetElement and re-enable the button link.
	 *
	 * @method _onClose
	 * @private
	 * @async
	 * @callback TreeSelectionModal~_onClose
	 */
	treeSelectionModal._onClose = function() {
		var page = treeSelectionModal.page;
		page.max = 1;
		page.number = 1;
		page.size = pageSize;
		return dust.renderPromise('partials/clusterTreeModalBlankList', {
			numberOfRows: Array.apply(null, Array(pageSize).map(Object))
		})
			.then(function(blankListItems) {
			// Update the list
				treeSelectionModal.list = treeSelectionModal.listContainer.html(blankListItems);
				if (treeSelectionModal.hasOwnProperty('modalPagingInfoElement') && treeSelectionModal.modalPagingInfoElement.length) {
					treeSelectionModal.modalPagingInfoElement.paging('destroy');
				}
				treeSelectionModal.resultsLabelContainers.addClass('hideVisibility');
				treeSelectionModal.closeFocusTargetElement.removeAttr('disabled');
				treeSelectionModal.closeFocusTargetElement.focus();
				delete treeSelectionModal.closeFocusTargetElement;
			});
	};

	/**
	 * Private method to show the loading animation when using pagination to load results.
	 * This loading animation is a light spinner on a dark background.
	 *
	 * @method _showResultsLoadingAnimation
	 * @private
	 * @async
	 * @returns {jQuery} $('#clusterTreeModalResultsLoadingContainer') - Result of removing the class 'hideVisibility'
	 */
	treeSelectionModal._showResultsLoadingAnimation = function() {
		treeSelectionModal.modalDarkLoading.addClass('loading loadingLarge');
		return treeSelectionModal.clusterTreeModalResultsLoadingContainer.removeClass('hideVisibility lightMode');
	};

	/**
	 * Private method to hide the loading animation when using pagination to load results.
	 * This loading animation is a light spinner on a dark background.
	 *
	 * @function _hideResultsLoadingAnimation
	 * @private
	 * @async
	 * @returns {jQuery} $('#clusterTreeModalResultsLoadingContainer') - Result of adding the class 'hideVisibility'
	 */
	treeSelectionModal._hideResultsLoadingAnimation = function() {
		treeSelectionModal.modalDarkLoading.removeClass('loading loadingLarge');
		return treeSelectionModal.clusterTreeModalResultsLoadingContainer.addClass('hideVisibility lightMode');
	};

	/**
	 * Animated load wrapper that takes a Promise and before/after resolving it, we show then hide a loading spinner
	 * If an error occurs, we will hide the loading animation and return a rejected promise.
	 *
	 * @method _animatedLoad
	 * @private
	 * @async
	 * @returns {Object} - a Promise which resolves to a newly rendered list of data items which is the result of the dataPromise object passed in
	 */
	treeSelectionModal._animatedLoad = function() {
		treeSelectionModal.scrollModalToTop();
		treeSelectionModal._showResultsLoadingAnimation();
		return treeSelectionModal.updateClusterTreeModalList({})
			.then(function() {
				treeSelectionModal._hideResultsLoadingAnimation();
				return Promise.resolve(treeSelectionModal.list);
			})
			.catch(function(err) {
				treeSelectionModal._hideResultsLoadingAnimation();
				return Promise.reject(err);
			});
	};

	/**
	 * Private method to show the loading animation when opening a modal.
	 * This loading animation is a dark spinner on a light background.
	 *
	 * @function _showOpenLoadingAnimation
	 * @private
	 * @async
	 * @returns {jQuery} $('#clusterTreeModalResultsLoadingContainer') - Result of adding the class 'hideVisibility'
	 */
	treeSelectionModal._showOpenLoadingAnimation = function() {
		onOpenLoading = true;
		treeSelectionModal.modalLightLoading.addClass('loading loadingLarge');
		return treeSelectionModal.clusterTreeModalResultsLoadingContainer.removeClass('hideVisibility');
	};

	/**
	 * Private method to hide the loading animation when opening a modal.
	 * This loading animation is a dark spinner on a light background.
	 *
	 * @method _hideOpenLoadingAnimation
	 * @private
	 * @async
	 * @returns {jQuery}  $('#clusterTreeModalResultsLoadingContainer') - Result of adding the class 'hideVisibility'
	 */
	treeSelectionModal._hideOpenLoadingAnimation = function() {
		onOpenLoading = false;
		treeSelectionModal.modalLightLoading.removeClass('loading loadingLarge');
		return treeSelectionModal.clusterTreeModalResultsLoadingContainer.addClass('hideVisibility');
	};

	/**
	 * Private method which initializes the modal paging. If we previously opened the modal, it will destroy the previous initialization and initialize paging for the new tree selection results.
	 *
	 * @method _initializeModalPaging
	 * @private
	 * @async
	 * @returns {Object} - a Promise which resolves to an instance of the paging component
	 */
	treeSelectionModal._initializeModalPaging = function() {
		treeSelectionModal.modalPagingInfoElement = $('.modalPagingInfo');
		if (!treeSelectionModal.modalPagingInfoElement) {
			return Promise.reject(new Error('Error: the element with className modalPagingInfo does not exist.'));
		}

		return Promise.resolve(treeSelectionModal.modalPagingInfoElement.paging({
			total: treeSelectionModal.page.max,
			current: 1,
			onChange: treeSelectionModal._executePagingChange,
			display: 'select'
		})).then(function(pagingResolved) {
			treeSelectionModal.canDestroyPaging = true;
			return pagingResolved;
		});
	};

	/**
	 * Private method to reload the contents of the tree selection list in the TreeSelectionModal with a new page of data.
	 * Since TreeSelectionModal is a singleton, this method can be defined here rather than added to the prototype.
	 *
	 * @method _executePagingChange
	 * @private
	 * @async
	 * @param {Number} page - A non-negative integer
	 * @returns {Object} - a Promise which resolves to a new _animatedLoad Promise, called with the newConfig wrapped inside the _dataCall Promise
	 */
	treeSelectionModal._executePagingChange = function(page) {
		// We don't update the TreeSelectionModal if page is NaN or less than 1.
		if (isNaN(page) || page < 1) {
			return Promise.reject(new Error('Error: invalid argument. page: ' + page));
		}
		treeSelectionModal.page.number = page;

		/**
		 * Inner function which is used to call the treeSelectionModal.updateClusterTreeModalList method with a new config object
		 *
		 * @function _dataCall
		 * @private
		 * @async
		 * @returns {Object} - a Promise which resolves to a new updateClusterTreeModalList Promise called with the updated newConfig Object as an argument
		 */
		var _dataCall = function() {
			var newConfig = {
				closeFocusTargetElement: treeSelectionModal.closeFocusTargetElement,
				clusterTreeCount: treeSelectionModal.clusterTreeCount,
				treePersonName: treeSelectionModal.treePersonName
			};
			return treeSelectionModal.updateClusterTreeModalList(newConfig);
		};

		// Passes the _dataCall promise into method that shows loading spinner/jumps to top of modal, calls promise, and then hides the loading spinner
		return treeSelectionModal._animatedLoad(_dataCall);
	};

	/**
	 * Private method to display the error state of the TreeSelectionModal.
	 * This is usually used when we have no items returned or a timeout occurs.
	 *
	 * @method _renderEmptyItemsModal
	 * @private
	 * @async
	 * @returns {Object} - a Promise which resolves to an instance of the TreeSelectModal with no data rows.
	 */
	treeSelectionModal._renderEmptyItemsModal = function() {
		return dust.renderPromise('partials/clusterTreeModalEmptyList', {})
			.then(function(emptyListMessage) {
				treeSelectionModal.list = treeSelectionModal.listContainer.html(emptyListMessage);
				return dust.renderPromise('partials/clusterTreeModalResultsLabel', {
					treePersonName: treeSelectionModal.treePersonName
				});
			}).then(function(resultsLabelContent) {
				$('.resultsLabelContainer').html(resultsLabelContent);
				$('.resultsLabelContainer').removeClass('hideVisibility');
				if (onOpenLoading) {
					treeSelectionModal._hideOpenLoadingAnimation();
					treeSelectionModal._initializeModalPaging()
						.then(function() {
							return treeSelectionModal;
						});
				}
				return treeSelectionModal;
			});
	};

	/*** PUBLIC METHODS ***/
	/**
	 * We expose a method to reload the contents of the tree selection list in the TreeSelectionModal with a new set of data.
	 * Since TreeSelectionModal is a singleton, this method can be defined here rather than added to the prototype.
	 * If an error occurs or an empty list of items is returned when we try to reload contents, we will display an error message and return a rejected promise.
	 *
	 * @method updateClusterTreeModalList
	 * @async
	 * @param {Object} config - The configuration options
	 * @param {jQuery} config.closeFocusTargetElement - (optional) The element to receive focus after closing the HTMLTreeSelectionModal. If not provided, this will remain the same as the previous closeFocusTargetElement.
	 * @param {String} config.clusterId - A unique identifier for a given cluster of trees.
	 * @param {Number} config.clusterTreeCount - The number of trees comprising the cluster represented in the TreeSelectionModal
	 * @param {String} config.treePersonName - The name of the search person in the primary tree of a given cluster, defaulting to the original treeSelectionModal.treePersonName if not valid
	 * @returns {Object} - a Promise which resolves to the updated TreeSelectionModal
	 */
	treeSelectionModal.updateClusterTreeModalList = function(config) {
		var _config = config || {};
		var clusterId = _config.clusterId || treeSelectionModal.clusterId;
		var treePersonName = typeof _config.treePersonName === 'string' ? _config.treePersonName : treeSelectionModal.treePersonName;
		var clusterTreeCount = parseInt((_config.clusterTreeCount || treeSelectionModal.clusterTreeCount), 10);

		/**
		 * We don't update the TreeSelectionModal if clusterTreeCount is NaN or less than 0,
		 * or if clusterId is not a String or a valid :9009: clusterId.
		 */
		if (isNaN(clusterTreeCount) || clusterTreeCount < 1 || typeof clusterId !== 'string' || clusterId.indexOf(':9009:') === -1) {
			return Promise.reject(new Error('Not updating modal due to bad arguments, clusterTreeCount: ' + clusterTreeCount + 'clusterId' + clusterId));
		}

		treeSelectionModal.closeFocusTargetElement = $(_config.closeFocusTargetElement || treeSelectionModal.closeFocusTargetElement || clusterTreeModalContainer);
		treeSelectionModal.clusterId = clusterId;
		treeSelectionModal.clusterTreeCount = clusterTreeCount;
		treeSelectionModal.treePersonName = treePersonName;
		treeSelectionModal.page.max = Math.ceil(clusterTreeCount / treeSelectionModal.page.size);

		var clusterContributorsUrl = 'https://' + ancestryData.domains.ancestry + '/api/search-results/cluster-contributors?clusterId=' + clusterId + '&pg=' + treeSelectionModal.page.number;
		var items;

		return Promise.resolve($.ajax({
			url: clusterContributorsUrl,
			timeout: 5000,
			success: function(response) {
				items = deepGet(response, 'results.items');
				// We don't update the TreeSelectionModal if items is not a valid Array of Objects.
				if (!Array.isArray(items) || !items.every(function(item) {
					return typeof item === 'object';
				})) {
					return Promise.reject(new Error('Not updating modal due to bad data. items: ' + items));
				}
				else if (!items.length) {
					return treeSelectionModal._renderEmptyItemsModal();
				}
				return dust.renderPromise('partials/clusterTreeModalList', {
					items: items,
					cardType: treeSelectionModal.cardType,
					clusterViewLinkTarget: '_blank',
					modalName: 'cluster modal'
				})
					.then(function(listItems) {
						// Update the list with rendered html list of items
						treeSelectionModal.list = treeSelectionModal.listContainer.html(listItems);

						return dust.renderPromise('partials/clusterTreeModalResultsLabel', {
							treePersonName: treePersonName
						});
					})
					// Updates the header and footer in one step and hides the open loading animation (if applicable)
					.then(function(resultsLabelContent) {
						$('.resultsLabelContainer').html(resultsLabelContent);
						$('.resultsLabelContainer').removeClass('hideVisibility');
						if (onOpenLoading) {
							treeSelectionModal._hideOpenLoadingAnimation();
							treeSelectionModal._initializeModalPaging();
						}
						return treeSelectionModal;
					});
			},
			error: function() {
				return treeSelectionModal._renderEmptyItemsModal()
					.then(function() {
						return Promise.reject(new Error('Unable to render modal items because of error when making data request to ' + clusterContributorsUrl));
					});
			},
			done: function() {
				return treeSelectionModal;
			}
		}));
	};

	/**
	 * This is the actual TreeSelectionModal constructor (factory pattern), which is executed only once,
	 * upon the initial call to TreeSelectionModal with the initial config object.
	 * This can be easily be translated once we can use esnext classes.
	 *
	 * @function init
	 * @private
	 * @async
	 * @returns {Object} - a Promise which resolves to an instance of the TreeSelectModal Singleton class
	 */
	function init() {
		return dust.renderPromise('partials/clusterTreeModal', {
			numberOfRows: Array.apply(null, Array(treeSelectionModal.page.defaultSize)).map(Object),
			treePersonName: treeSelectionModal.treePersonName,
			clusterId: treeSelectionModal.clusterId,
			clusterTreeCount: treeSelectionModal.clusterTreeCount,
			closeFocusTargetElement: treeSelectionModal.closeFocusTargetElement
		})
			.then(function(clusterTreeModalContent) {
				// Render the TreeSelectionModal
				treeSelectionModal.clusterTreeModalContainer.html(clusterTreeModalContent);
				treeSelectionModal.clusterTreeModalResultsLoadingContainer = $('#clusterTreeModalResultsLoadingContainer');
				treeSelectionModal.modalDarkLoading = $('#modalDarkLoading');
				treeSelectionModal.modalLightLoading = $('#modalLightLoading');
				treeSelectionModal.resultsLabelContainers = $('.resultsLabelContainer');
				treeSelectionModal._showOpenLoadingAnimation();
				// Create and populate the hidden TreeSelectionModal with empty rows
				return treeSelectionModal.clusterTreeModalContainer.modal({
					width: treeSelectionModal.width,
					onClose: treeSelectionModal._onClose,
					onOpen: treeSelectionModal._onOpen
				});
			})
			.then(function() {
				treeSelectionModal.modal = treeSelectionModal.clusterTreeModalContainer.data('modalInstance');
				treeSelectionModal.show = treeSelectionModal.modal.open.bind(treeSelectionModal.modal);
				treeSelectionModal.hide = treeSelectionModal.modal.close.bind(treeSelectionModal.modal);
				treeSelectionModal.scrollModalToTop = function() {
					$('#modalFixed').animate({
						scrollTop: 0
					}, 250);
				};
				treeSelectionModal.listContainer = treeSelectionModal.clusterTreeModalContainer.find('.conList');
				return treeSelectionModal.updateClusterTreeModalList({
					closeFocusTargetElement: treeSelectionModal.closeFocusTargetElement,
					clusterTreeCount: treeSelectionModal.clusterTreeCount,
					treePersonName: treeSelectionModal.treePersonName
				});
			})
			.then(function() {
				return treeSelectionModal;
			});
	}

	return init();
};

module.exports = TreeSelectionModal;

},{"../browserAbstractions/ancestryData":1,"dust":13}],15:[function(require,module,exports){
'use strict';

var $ = window.$;
var dust = require('dust');
var browseCollectionServiceProxy = require('../../lib/proxies/browseCollectionServiceProxy');

function loadTableOfContents(collectionId) {
	var $tableOfContents = $('#tableOfContents');

	dust.renderPromise('partials/bookTableOfContents', {loading: true}).then(function(content) {
		$tableOfContents.html(content);

		browseCollectionServiceProxy.getBrowseCollection({
			collectionId: collectionId,
			timeout: 10000
		}).then(function(data) {
			dust.renderPromise('partials/bookTableOfContents', data).then(function(content) {
				$tableOfContents.html(content);
			});
		}).catch(function() {
			dust.renderPromise('partials/bookTableOfContents', {error: true}).then(function(content) {
				$tableOfContents.html(content);
			});
		});	
	});
}

function init() {
	var $element = $('#tableOfContents');
	var collectionId = $element.data('collection');
	loadTableOfContents(collectionId);

	$element.on('click', 'a.reloadWidget', function (e) {
		e.preventDefault();
		loadTableOfContents(collectionId);
	});
}

module.exports = {
	init: init
};
},{"../../lib/proxies/browseCollectionServiceProxy":27,"dust":13}],16:[function(require,module,exports){
'use strict';

var $ = window.$;
var _ = window._;
var dust = require('dust');
var browseCollectionServiceProxy = require('../../lib/proxies/browseCollectionServiceProxy');

var hierarchyLabels, modalInitialized = false;

function getHierarchyLabels(collectionId) {
	return browseCollectionServiceProxy.getBrowseCollection({
		collectionId: collectionId,
		timeout: 5000
	}).then(function(data) {
		var hierarchyLabels = data.hierarchyLabels;

		var imageNoIdx = _.findIndex(hierarchyLabels, function(label) {
			// Labels can have different cases: ImageNo, ImageNO.
			return label.key.toLowerCase() === 'imageno';
		});
		if (imageNoIdx === -1) {
			throw new Error('Images were not found in the hierarchy.');
		}
		return hierarchyLabels.slice(0, imageNoIdx);
	});
}

function renderImageCollection(images) {
	$('#browsePrompt').hide();
	return dust.renderPromise('partials/standardCollectionImages', { images: images }).then(function(content) {
		$('#imageCollection').empty().show().append(content);		
	});
}

function updateDropdowns($field, options) {
	// First option is the select placeholder with empty value.
	var selectOption = $field.find('option:first-child');
	$field.removeAttr('disabled').empty().append(selectOption);

	var ddOptions = [];
	for (var i = 0; i < options.length; i++) {
		ddOptions.push($('<option />', { value: options[i].value, text: options[i].value }));
	}
	$field.append(ddOptions);
}

function getSelectedPath() {
	var $browseForm = $('#browseForm');
	var path = [];

	for (var i = 0; i < hierarchyLabels.length; i++) {
		var select = $browseForm.find('select[name="' + hierarchyLabels[i].key + '"]');
		var value = select.val();
		if (value) {
			path.push(value);
		} else {
			break;
		}
	}

	return path;
}

var currentLoadRequest;
function loadPath(collectionId) {
	var $browseForm = $('#browseForm');
	var activityIndicator = $('#browseModal .loading');
	var browsePrompt = $('#browsePrompt');
	var path = getSelectedPath();
	$('#imageCollectionAlert').hide();

	var nextEntry = hierarchyLabels[path.length];
	var lastEntry = hierarchyLabels[hierarchyLabels.length - 1];
	var isLastEntry = nextEntry && nextEntry.key === lastEntry.key;

	$('#imageCollection').hide();

	if (isLastEntry) {
		browsePrompt.hide();
		activityIndicator.show();
	} else {
		browsePrompt.show();
		activityIndicator.hide();
	}

	var requestKey = collectionId + '!' + path.join('|') + '!' + (isLastEntry ? '1' : '0');
	// Save current request key to be able to distinguish if the request is still
	// actual when response is received.
	currentLoadRequest = requestKey;

	return browseCollectionServiceProxy.getCollectionHierarchy({
		collectionId: collectionId,
		path: path.join('|'),
		getImageIds: isLastEntry,
		timeout: 20000
	}).then(function(data) {
		// Do not use the request that is not actual anymore
		if (!data || requestKey !== currentLoadRequest) {
			return;
		}

		if (isLastEntry) {
			renderImageCollection(data);
			activityIndicator.hide();
		} else if (nextEntry) {
			var select = $browseForm.find('select[name="' + nextEntry.key + '"]');
			updateDropdowns(select, data);
			if (data.length === 1) {
				select.val(data[0].value)
					.attr('disabled', 'disabled')
					.trigger('change');
			} else {
				select.removeAttr('disabled');
			}
		}
	}).catch(function() {
		// Do not react on the request that is not actual anymore
		if (requestKey !== currentLoadRequest) {
			return;
		}
		activityIndicator.hide();
		$('#browsePrompt').hide();
		$('#imageCollection').empty().hide();
		$('#imageCollectionAlert').show();
	});
}

function resizeModalContentHeight($modal) {
	var $columns = $modal.find('.modalColumn');
	if ($(window).width() < 480) {
		$columns.height('auto');
	} else {
		var modalPadding = 40;
		var innerHeight = $(window).height() - $modal.find('header').outerHeight() - modalPadding;
		$columns.outerHeight(innerHeight);
	}
}

function onBrowseBtnClick(collectionId) {
	var onResizeCallback;

	$('#browseModal').modal({
		onOpen: function (modal) {
			if (modalInitialized) {
				return;
			}
			modalInitialized = true;
			onResizeCallback = function() {
				resizeModalContentHeight(modal);
			}

			resizeModalContentHeight(modal);
			$(window).on('resize.modal', onResizeCallback);

			loadPath(collectionId);
		},
		onClose: function () {
			$(window).off('resize.modal', onResizeCallback);
		},
		useCustomPadding: true,
		width: 900
	});
}

function onBrowseFormSelectionChange(name, collectionId) {
	var $browseForm = $('#browseForm');
	// Find the index of hierarchy label by its key.
	var idx = -1;
	for (var i = 0; i < hierarchyLabels.length; i++) {
		if (name === hierarchyLabels[i].key) {
			idx = i;
		}
	}

	for (var j = idx + 1; j < hierarchyLabels.length; j++) {
		$browseForm.find('select[name="' + hierarchyLabels[j].key + '"]')
			.attr('disabled', 'disabled')
			.val('')
			.find('option[value!=""]').remove();
	}

	loadPath(collectionId);
}

function init() {
	modalInitialized = false;
	var $dialog = $('#browseModal');
	var $browseForm = $('#browseForm');
	var collectionId = $dialog.data('collectionId');
	if (!collectionId) {
		return;
	}

	$('#browseResults').on('click', 'a.reloadPath', function(e) {
		e.preventDefault();
		loadPath(collectionId);
	});

	var browseBtn = $('#browseCollectionBtn');

	browseBtn.attr('disabled', 'disabled');

	$dialog.on('change', '.browseForm select', function (e) {
		onBrowseFormSelectionChange($(e.target).attr('name'), collectionId);
	});

	return getHierarchyLabels(collectionId).then(function(labels) {
		if (!labels || labels.length === 0) {
			return;
		}

		hierarchyLabels = labels;

		$('#imageCollectionTitle').html(hierarchyLabels[hierarchyLabels.length - 1].label);

		browseBtn.on('click', function () {
			onBrowseBtnClick(collectionId);
		});

		browseBtn.removeAttr('disabled');
		return dust.renderPromise('partials/standardCollectionHierarchyForm', {hierarchyLabels: hierarchyLabels.slice(0, hierarchyLabels.length - 1)}).then(function(content) {
			$browseForm.replaceWith(content);
		});
	});
}

module.exports = {
	init: init
};

},{"../../lib/proxies/browseCollectionServiceProxy":27,"dust":13}],17:[function(require,module,exports){
'use strict';

var _ = window._;
var dust = require('dust');
var browseCollectionServiceProxy = require('../../lib/proxies/browseCollectionServiceProxy');
var localStorage = require('../browserAbstractions/localStorage')('calendar-');

var availYears = [];
var availMonths = {};
var availDays = {};

var daysInMonths = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function getQueryStringParameter(param) {
	var pageUrl = decodeURIComponent(window.location.search.substring(1)),
		urlVariables = pageUrl.split('&'),
		parameterName;

	for (var i = 0; i < urlVariables.length; i++) {
		parameterName = urlVariables[i].split('=');

		if (parameterName[0] === param) {
			return parameterName[1] === undefined ? true : parameterName[1];
		}
	}
}

function renderCalendar($element, year, month, availYears, availMonths, availDays) {
	if (!month) {
		month = 1;
	}

	var months = _.map(availMonths[year], function(monthIdx) {
		return { monthIdx: monthIdx, monthName: window.monthNames[monthIdx - 1]};
	});

	var firstDay = new Date(year, month - 1, 1);
	var startDay = firstDay.getDay();
	if (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0)) {
		daysInMonths[1] = 29;
	} else {
		daysInMonths[1] = 28;
	}

	var daysOfMonth;
	if (availDays && availDays[year] && availDays[year][month]) {
		daysOfMonth = [];
		var week = {days: []};
		var column = 0;
		for (var i = 0; i < startDay; i++, column++) {
			week.days[column] = {};
		}
		for (i = 1; i <= daysInMonths[month - 1]; i++, column++) {
			if (availDays[year] && availDays[year][month] && availDays[year][month][i]) {
				var dayData = availDays[year][month][i];
				week.days[column] = dayData;
			} else {
				week.days[column] = { day: i };
			}
			if (column === 6 && i !== daysInMonths[month - 1]) {
				daysOfMonth.push(week);
				week = {days: []};
				column = -1;
			}
		}
		if (column > 0) {
			for (i = 1; column < 7; i++, column++) {
				week.days.push({});
			}
			daysOfMonth.push(week);
		}
	}

	dust.renderPromise('partials/calendar', {
		daysOfWeek: window.dow,
		year: year,
		month: month,
		availYears: availYears,
		availMonths: months,
		availDays: daysOfMonth
	}).then(function (content) {
		$element.html(content);
	});
}

function renderErrorAlert($element) {
	dust.renderPromise('partials/calendar', {
		error: true
	}).then(function (content) {
		$element.html(content);
	});
}

function renderActivityIndicator($element) {
	dust.renderPromise('partials/calendar', {
		activityIndicator: true
	}).then(function (content) {
		$element.html(content);
	});
}

function saveCalendarState(year, month, dbid) {
	localStorage.setItem(dbid, JSON.stringify({ year: year, month: month }));
}

function getCalendarState(dbid) {
	var state = localStorage.getItem('calendar-' + dbid);
	if (state) {
		return JSON.parse(state);
	}
}

function reloadCalendar($element, dbid, year, month) {
	if (!availMonths[year]) {
		renderCalendar($element, year, month, availYears, availMonths);

		return loadMonths(dbid, year).then(function(data) {
			availMonths[year] = data.months;
			month = data.defaultMonth.month;
			_.set(availDays, [year, month], data.defaultMonth.days);
			saveCalendarState(year, month, dbid);
			renderCalendar($element, year, month, availYears, availMonths, availDays);
		});
	} else {
		if (!month) {
			month = _.minBy(availMonths[year], parseInt);
		}
		var days = _.get(availDays, [year, month]);
		if (!days) {
			renderCalendar($element, year, month, availYears, availMonths);

			return loadDays(dbid, year, month).then(function(days) {
				_.set(availDays, [year, month], days);
				saveCalendarState(year, month, dbid);
				renderCalendar($element, year, month, availYears, availMonths, availDays);
			});
		}
	}
	renderCalendar($element, year, month, availYears, availMonths, availDays);
}

function loadMonths(dbid, year) {
	return browseCollectionServiceProxy.getCalendarMonths({
		collectionId: dbid,
		year: year,
		timeout: 5000
	}).catch(function(err) {
		console.log(err, dbid);
	});
}

function loadDays(dbid, year, month) {
	return browseCollectionServiceProxy.getCalendarDays({
		collectionId: dbid,
		year: year,
		month: month,
		timeout: 5000
	}).catch(function(err) {
		console.log(err, dbid);
	});
}

function changeMonth($element, dbid) {
	var $month = $element.find('select[name=month]');
	var $year = $element.find('select[name=year]');
	reloadCalendar($element, dbid, $year.val(), $month.val());
	$month.focus();
}

function changeYear($element, dbid) {
	var $year = $element.find('select[name=year]');
	$element.find('select[name=month]').empty();
	reloadCalendar($element, dbid, $year.val());
	$year.focus();
}

function buildCalendar($element, dbid) {
	renderActivityIndicator($element);

	var path = getQueryStringParameter('path');
	var year, month;
	if (path) {
		var parts = path.split('.');
		if (parts.length > 0 && parts[0].length === 4) {
			year = parts[0];
			month = parts.length > 1 ? parts[1] : null;
		}
	}
	if (!month || !year) {
		var calendarState = getCalendarState(dbid);
		if (calendarState) {
			year = calendarState.year;
			month = calendarState.month;	
		}
	}

	return browseCollectionServiceProxy.getCalendarCollection({
		collectionId: dbid,
		defaultYear: year,
		defaultMonth: month,
		timeout: 15000
	}).then(function(data) {
		availYears = data.years;
		availMonths[data.defaultYear.year] = data.defaultYear.months;
		availDays[data.defaultYear.year] = {};
		availDays[data.defaultYear.year][data.defaultMonth.month] = data.defaultMonth.days;

		renderCalendar($element, data.defaultYear.year, data.defaultMonth.month, availYears, availMonths, availDays);

		$element.on('change', 'select[name=year]', function () {
			changeYear($element, dbid);
		});

		$element.on('change', 'select[name=month]', function () {
			changeMonth($element, dbid);
		});
	}).catch(function() {
		renderErrorAlert($element);
	});
}

module.exports = {
	buildCalendar: buildCalendar
};
},{"../../lib/proxies/browseCollectionServiceProxy":27,"../browserAbstractions/localStorage":2,"dust":13}],18:[function(require,module,exports){
'use strict';

var navInfo = null;

function reset() {
	navInfo = {
		index: -1,
		rows: $('li.searchResultRow')
	};
}

function init() {
	if (notOnSearchResultsPage()) {
		return;
	}

	initPanelTrigger();
	bindShortcutKeys();
	reset();
}

function initPanelTrigger() {
	var trigger = $('#shortcutSectionLink');
	var arrowIcon = trigger.next();
	var list = $('#keyList');

	trigger.add(arrowIcon).on('click', function () {
		if (list.is(":visible")) {
			list.hide();
			//change arrow icon
			arrowIcon.removeClass('alt');
		} else {
			list.show();
			arrowIcon.addClass('alt');
		}
	});
}

function bindShortcutKeys() {
	$(document).on('keypress', keyPressHandler);
}

function keyPressHandler(e) {
	if (!shouldProcessKeyPress(e)) {
		return;
	}

	processKeypress(e);
}

function processKeypress(e) {
	switch (e.which) {
		// n
		case 110:
			return doNewSearch();
		// r
		case 114:
			return showRefineSearchDialog();
		// p
		case 112:
			return navigationEnabled() && doRecordPreview();
		// <
		case 44:
			return navigationEnabled() && moveToPrevRecord();
		// >
		case 46:
			return navigationEnabled() && moveToNextRecord();
	}
}

function navigationEnabled() {
	// only when search results are shown and we're in Records view mode
	return navInfo.rows.length > 0 && window.ancestry.search.dataModel.viewMode === 'record';
}

function shouldProcessKeyPress(e) {
	if (e.altKey || e.ctrlKey || e.shiftKey) {
		return false;
	}

	// focus is on an input field
	var tag = e.target.tagName.toLowerCase();
	if (tag === 'input' || tag === 'textarea') {
		return false;
	}

	// if refine window is active
	return $('#RefineSearchWindow.modalActive').length === 0;
}

function notOnSearchResultsPage() {
	return $('#hotkeyContainer').length === 0;
}

function doNewSearch() {
	var trigger = $('a.newSearch');
	if (trigger.length === 1) {
		trigger[0].click();
	}
}

function showRefineSearchDialog() {
	if (window.ancestry.search.editSearch) {
		window.ancestry.search.editSearch();
	}
}

function doRecordPreview() {
	if (noRowSelected()) {
		return;
	}

	var row = getSelectedRow();
	var trigger = row.find('.calloutTriggerNoArrow');
	trigger.mouseover();
}

function previewPaneIsOpen() {
	return $('.callout.open > .recordPreviewContainer').length === 1;
}

function moveToPrevRecord() {
	if (noRowSelected()) {
		moveToFirstRecord();
		return;
	}

	if (firstRowSelected()) {
		return;
	}

	selectPrevRecord();

	if (previewPaneIsOpen()) {
		doRecordPreview();
	}
}

function moveToNextRecord() {
	if (noRowSelected()) {
		selectNextRecord();
		return;
	}

	if (lastRowSelected()) {
		return;
	}

	selectNextRecord();

	if (previewPaneIsOpen()) {
		doRecordPreview();
	}
}

function moveToFirstRecord() {
	navInfo.index = 0;
	highlightRow();
}

function selectNextRecord() {
	removeRowHighlighting();
	navInfo.index++;
	highlightRow();
}

function selectPrevRecord() {
	removeRowHighlighting();
	navInfo.index--;
	highlightRow();
}

function removeRowHighlighting() {
	var row = getSelectedRow();
	if (row) {
		row.removeClass('selectedRecord');
	}
}

function highlightRow() {
	var row = getSelectedRow();
	row.addClass('selectedRecord');

	// if the selected record is not visible completely/partiall on screen
	if (!rowIsInView(row)) {
		row[0].scrollIntoView();
	}
}

function getSelectedRow() {
	return navInfo.rows.eq(navInfo.index);
}

function noRowSelected() {
	return navInfo.index === -1;
}

function firstRowSelected() {
	return navInfo.index === 0;
}

function lastRowSelected() {
	return navInfo.index !== -1 && navInfo.index === navInfo.rows.length - 1;
}

function rowIsInView(domElement) {
	var el = $(domElement);
	var w = $(window);

	var docViewTop = w.scrollTop();
	var docViewBottom = docViewTop + w.height();
	var elemTop = el.offset().top;
	var elemBottom = elemTop + el.height();

	return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

module.exports = {
	init: init,
	reset: reset
};


},{}],19:[function(require,module,exports){
'use strict';

var WellKnownEvents = ["SelfBirth","SelfMarriage","SelfDeath","SelfResidence","SelfMilitary","SelfDeparture","SelfArrival","Self"];
var WellKnownFields = ["SelfRace","keyword","SelfGender"]; 

function removeUnrelatedData(dataModel, fieldNames) {
	removeUnrelatedEvents(dataModel, fieldNames);
	removeUnrelatedFields(dataModel, fieldNames);
}


function removeUnrelatedFields(dataModel, fieldNames) {
	Object.keys(dataModel.fields).forEach(function (fieldName) {
		// Keep well known events
		if (WellKnownFields.indexOf(fieldName) >= 0) {
			return;
		}
		var field = dataModel.fields[fieldName];
		if (!fieldNameExists(fieldName, fieldNames)) {
			delete dataModel.fields[fieldName];
		}
	});
}

function removeUnrelatedEvents(dataModel, fieldNames) {
	Object.keys(dataModel.events).forEach(function (eventGroupName) {
		// Keep well known events
		if (WellKnownEvents.indexOf(eventGroupName) >= 0) {
			return;
		}

		var evt = dataModel.events[eventGroupName];
		var instances = evt.instances;
		var prefix = (evt.relation || '') + (evt.eventName || '');

		for (var i = 0; i < instances.length; i++) {
			var inst = instances[i];

			if (inst.date.day && !fieldNameExists(prefix + 'Day', fieldNames)) {
				inst.date.day = null;
			}

			if (inst.date.month && !fieldNameExists(prefix + 'Month', fieldNames)) {
				inst.date.month = null;
			}

			if (inst.date.year && !fieldNameExists(prefix + 'Year', fieldNames)) {
				inst.date.year = null;
			}

			if (inst.location && !fieldNameExists(prefix + 'Place', fieldNames)) {
				inst.gpid = null;
				inst.location = null;
			}
		}
	});
}

function fieldNameExists(name, fields) {
	if (!fields) {
		return false;
	}

	for (var i = 0; i < fields.length; i++) {
		if (fields[i].toLowerCase() === name.toLowerCase()) {
			return true;
		}
	}

	return false;
}

module.exports = {
	removeUnrelatedData: removeUnrelatedData
};
},{}],20:[function(require,module,exports){
'use strict';

var i18n = require('../i18n');
var log = require('../logging');

module.exports = function (dust) {
	dust.helpers.t = function (chunk, context, bodies, params) {
		var locale = context.get('locale', false);

		try {
			var localizedStr = i18n.get(params.key, locale, function (str, strType, formatter) {
				if (strType === 'literal') {
					return dust.escapeHtml(str);
				}
				var paramValue = params[str];
				if (paramValue) {
					return context.resolve(paramValue);
				}

				var contextValue = context.get(str);
				if (formatter && contextValue != null) {
					contextValue = formatter(contextValue);
				}
				return contextValue != null ? dust.escapeHtml(contextValue.toString()) : null;
			});

			return chunk.write(localizedStr);
		} catch (ex) {
			var metadata = {
				locale: locale,
				key: params.key
			};
			log.error('Localization', ex, null, null, metadata);
			return chunk.write('');
		}
	};
};

},{"../i18n":8,"../logging":9}],21:[function(require,module,exports){
var i18n = require('../i18n');

module.exports = function (dust) {
	dust.helpers.lifespan = function (chunk, context, bodies, params) {
		var locale = context.get('locale', false);
		var birthYear = params.birthYear;
		var deathYear = params.deathYear;
		var lifespan;

		if (birthYear && deathYear) {
			lifespan = birthYear + '-' + deathYear;
		}
		else if (birthYear) {
			lifespan = i18n.get('clusterview.familyMembersCard.members.born', locale) + ' ' + birthYear;
		}
		else if (deathYear) {
			lifespan = i18n.get('clusterview.familyMembersCard.members.died', locale) + ' ' + deathYear;
		}
		else {
			lifespan = '';
		}

		return chunk.write(lifespan);
	};
};

},{"../i18n":8}],22:[function(require,module,exports){
function DependencyError(message, logGrouping, dependencyName, meta, severity) {
	this.message = message;
	this.name = 'DependencyError';
	this.logGrouping = logGrouping;
	this.dependencyName = dependencyName;
	this.meta = meta || null;
	this.severity = severity || "error";
}
DependencyError.prototype = Object.create(Error.prototype);

module.exports = DependencyError;

},{}],23:[function(require,module,exports){
var _ = window._;

module.exports.normalizeDebugInfo = function (searchResultSResponse){
	if (!_.has(searchResultSResponse, "debug.recordSearch")) return;
	var searchuiResultsResponseCopy = _.cloneDeep(searchResultSResponse);
	searchResultSResponse.debug.response = searchuiResultsResponseCopy;
};

},{}],24:[function(require,module,exports){
module.exports = function (i18n) {
	return function (month, locale) {
		const monthInt = parseInt(month, 10);
		if (!isNaN(monthInt)) {
			if (monthInt >= 1 && monthInt <= 12) {
				const localizedMonth = new Intl.DateTimeFormat(locale, {month: 'short'});
				return localizedMonth.format(new Date().setMonth(monthInt - 1)).replace('.', '');  /* Strip out any '.' characters because the '.' character appearing was inconsistant depending on whether this codes runs on the server or client(paging). */
			} else {
				throw new Error('Invalid argument for month');
			}
		}
		return month;
	};
};
},{}],25:[function(require,module,exports){
'use strict';

var keyMap = {
	"name.givenName": "searchGuidance.suggestedFields.givenName",
	"name.surname": "searchGuidance.suggestedFields.surname",
	"events.SelfBirth": "searchGuidance.suggestedFields.birth",
	"events.SelfDeath": "searchGuidance.suggestedFields.death",
	"events.*.gpid": "searchGuidance.suggestedFields.location",
	"events.*.location": "searchGuidance.suggestedFields.location"
};

module.exports = function(i18n) {
	return function(arr, locale) {
		var sb = [];
		var used = {};
		arr.forEach(function(str){
			var key = keyMap[str];
			var localizedStr = i18n.get(key, locale);
			if (!used[localizedStr]) {
				sb.push(localizedStr);
				used[localizedStr] = true;
			}
		});
		switch(sb.length){
			case 0:
				throw new Error("Invalid use of the \"list\" formatter: requires at least 1 item in the array passed in");
			case 1:
				return sb[0];
			case 2:
				return sb[0] + i18n.get("globals.AndConjunction2Items", locale) + sb[1];
			default:
				return sb.slice(0, sb.length - 1).join(i18n.get("globals.listSeparator", locale)) + i18n.get("globals.lastListSeparator", locale) + sb[sb.length - 1];
		}
	}
}
},{}],26:[function(require,module,exports){
var snippetZoom = 0.35;
var ScaledWidth = 245;  // preview width
var ScaledHeight = 94;	// preview height
var HalfScaledWidth = ScaledWidth / 2;
var HalfScaledHeight = ScaledHeight / 2;

module.exports.getPreviewData = function (matchAreas) {
	if (matchAreas == null || matchAreas.length === 0) {
		throw new Error("matchAreas required by result items passed to the imageMatchPreviewProvider");
	}
	var matchAreasCopy = []
	matchAreas.forEach(function(matchArea){
		matchAreasCopy.push({
			left:		matchArea.left	 * snippetZoom,
			top:		matchArea.top		 * snippetZoom,
			width:	matchArea.width	 * snippetZoom,
			height:	matchArea.height * snippetZoom
		});
	});
	var matchAreasInPreview = [];
	var firstMatch = matchAreasCopy[0];

	//Create matchAreasInPreview rectangles
	var area1 = firstMatch;

	//center preview snippet on first match area
	var previewArea = { 
		left:		Math.max((area1.left + (area1.width  / 2)) - HalfScaledWidth,  0),
		top:		Math.max((area1.top  + (area1.height / 2)) - HalfScaledHeight, 0),
		width:	ScaledWidth, 
		height:	ScaledHeight 
	};

	// center between first and second match areas if we have 2 or more matches and they are close enough
	if (matchAreasCopy.length >= 2) {
		var area2 = matchAreasCopy[1]; 

		if (Math.abs(area1.left + area1.width  - area2.left) < ScaledWidth  && 
			  Math.abs(area2.left + area2.width  - area1.left) < ScaledWidth  && 
				Math.abs(area1.top  + area1.height - area2.top)  < ScaledHeight && 
				Math.abs(area2.top  + area2.height - area1.top)  < ScaledHeight) {
			previewArea.left = (area1.left + ((area2.width  + (area2.left - area1.left)) / 2)) - (ScaledWidth  / 2);
			previewArea.top  = (area1.top	 + ((area2.height + (area2.top  - area1.top))  / 2)) - (ScaledHeight / 2);
			previewArea.left = Math.max(previewArea.left, 0);
			previewArea.top  = Math.max(previewArea.top, 0);
		}
	}

	matchAreasCopy.forEach(function(matchArea){
		//clip match area into snippet view area if it overlaps
		area1 = matchArea;
		if (((area1.left + area1.width)  > previewArea.left) && 
			 ((area1.top	 + area1.height) > previewArea.top)  &&
				(area1.left < (previewArea.left + ScaledWidth))  && 
				(area1.top  < (previewArea.top  + ScaledHeight))) {
			var dx = area1.left - previewArea.left;
			var dy = area1.top - previewArea.top;
			var dw = area1.width;
			var dh = area1.height;
			if (dx < 0) {
				dw += dx;
				dx = 0;
			}
			if (dy < 0) {
				dh += dy;
				dy = 0;
			}
			if ((dw + dx) > ScaledWidth)
				dw = ScaledWidth - dx;
			if ((dh + dy) > ScaledHeight)
				dh = ScaledHeight - dy;

			dx = Math.round(dx);
			dy = Math.round(dy);
			dw = Math.round(dw);
			dh = Math.round(dh);

			matchAreasInPreview.push({left:dx, top: dy, width: dw, height: dh});
		}
	});

	return {
		matchAreasInPreview: matchAreasInPreview,
		previewArea: {
			left:		Math.round(previewArea.left), 
			top:		Math.round(previewArea.top), 
			width:	Math.round(previewArea.width), 
			height:	Math.round(previewArea.height)
		},
		previewScale: snippetZoom
	};
};

},{}],27:[function(require,module,exports){
'use strict';
var format = require('string-format');
var request = require('ancestry-request');
var log = require('../logging');
var config = require('config');
var pub = require('../pubRepository');
var _ = window._;

var urlPrefix = null;
var initialized = false;

var EXPECTED_COLLECTION_ID_ERROR = 'Collection ID must be provided';

function ensureInitCalled() {
	if (!initialized) {
		return Promise.reject(new Error('browseCollectionServiceProxy requires that init(options) must be called before using other methods.'));
	}
	return Promise.resolve();
}

function init(options) {
	if (!options.urlPrefix) {
		throw new Error('init(options) must be called with options.urlPrefix specified like searchui-browsecollection.ancestry.int');
	}
	urlPrefix = options.urlPrefix;
	initialized = true;
}

function getCollectionType(options, req) {
	return ensureInitCalled().then(function () {
		if (!options || !options.collectionId) {
			return Promise.reject(new Error(EXPECTED_COLLECTION_ID_ERROR));
		}

		var urlFormat = '{urlPrefix}/{collectionId}/type';
		var url = format(urlFormat, {
			urlPrefix: options.urlPrefix || urlPrefix,
			collectionId: options.collectionId
		});

		return getDataFromService({ url: url, timeout: options.timeout }, req)
			.then(function (result) {
				return result.type;
			})
			.catch(log.getDependencyErrorHandler('GetCollectionType', 'BrowseCollectionService', options, req, 'error'));
	});
}

function getDataFromService(requestOptions, req) {
	requestOptions.json = true;
	requestOptions.timeout = requestOptions.timeout || config.browseServiceTimeout || 1500;

	return request.get(requestOptions, req);
}

function getCalendarCollection(options, req) {
	return ensureInitCalled().then(function () {
		if (!options || !options.collectionId) {
			return Promise.reject(new Error(EXPECTED_COLLECTION_ID_ERROR));
		}

		var urlFormat = '{urlPrefix}/{collectionId}';
		var url = format(urlFormat, {
			urlPrefix: options.urlPrefix || urlPrefix,
			collectionId: options.collectionId
		});

		var query = [];
		if (options.defaultYear) {
			query.push('year=' + options.defaultYear);
		}

		if (options.defaultMonth) {
			query.push('month=' + options.defaultMonth);
		}

		if (query.length > 0) {
			url += '?' + query.join('&');
		}

		return getDataFromService({ url: url, timeout: options.timeout }, req)
			.then(function(result) {
				if (result.type !== 'Periodical') {
					throw new Error('Wrong collection type');
				}

				var days = _.get(result, 'defaultMonth.days');
				return getUrlForCalendarDays(days, options.collectionId, req).then(function(days) {
					_.set(result, 'defaultMonth.days', days);
					return result;
				});
			})
			.catch(log.getDependencyErrorHandler('GetCalendarCollection', 'BrowseCollectionService', options, req, 'error'));
	});
}

function getBrowseCollection(options, req) {
	return ensureInitCalled().then(function () {
		if (!options || !options.collectionId) {
			return Promise.reject(new Error(EXPECTED_COLLECTION_ID_ERROR));
		}

		var urlFormat = '{urlPrefix}/{collectionId}';
		var url = format(urlFormat, {
			urlPrefix: options.urlPrefix || urlPrefix,
			collectionId: options.collectionId
		});

		return getDataFromService({ url: url, timeout: options.timeout }, req)
			.then(function (result) {
				if (result.type !== 'TOC') {
					return result;
				}

				return getUrlForTableOfContents(result.tableOfContents, options.collectionId, req).then(function(tableOfContents) {
					result.tableOfContents = tableOfContents;
					return result;
				});
			})
			.catch(log.getDependencyErrorHandler('GetBrowseStructure', 'BrowseCollectionService', options, req, 'error'));
	});
}

function getCollectionHierarchy(options, req) {
	return ensureInitCalled().then(function() {
		if (!options || !options.collectionId) {
			return Promise.reject(new Error(EXPECTED_COLLECTION_ID_ERROR));
		}

		var urlFormat = '{urlPrefix}/{collectionId}/hierarchy';
		var url = format(urlFormat, {
			urlPrefix: options.urlPrefix || urlPrefix,
			collectionId: options.collectionId
		});

		var query = [];
		if (options.path) {
			query.push('path=' + options.path);
		}

		if (options.getImageIds === true) {
			query.push('getImageIds=true');
		}

		if (query.length > 0) {
			url += '?' + query.join('&');
		}

		return getDataFromService({ url: url, timeout: options.timeout }, req)
			.then(function(hierarchy) {
				return getUrlForHierarchy(hierarchy, options.collectionId, req);
			})
			.catch(log.getDependencyErrorHandler('GetCollectionHierarchy', 'BrowseCollectionService', options, req, 'error'));
	});
}

function getCalendarMonths(options, req) {
	return ensureInitCalled().then(function() {
		if (!options || !options.collectionId) {
			return Promise.reject(new Error(EXPECTED_COLLECTION_ID_ERROR));
		}

		var urlFormat = '{urlPrefix}/{collectionId}/year/{year}';
		var url = format(urlFormat, {
			urlPrefix: options.urlPrefix || urlPrefix,
			collectionId: options.collectionId,
			year: options.year
		});

		return getDataFromService({ url: url, timeout: options.timeout }, req)
			.then(function (data) {
				return getUrlForCalendarDays(data.defaultMonth.days, options.collectionId, req).then(function(days) {
					data.defaultMonth.days = days;
					return data;
				});
			})
			.catch(log.getDependencyErrorHandler('GetCalendarMonths', 'BrowseCollectionService', options, req, 'error'));
	});
}

function getCalendarDays(options, req) {
	return ensureInitCalled().then(function() {
		if (!options || !options.collectionId) {
			return Promise.reject(new Error(EXPECTED_COLLECTION_ID_ERROR));
		}

		var urlFormat = '{urlPrefix}/{collectionId}/year/{year}/month/{month}';
		var url = format(urlFormat, {
			urlPrefix: options.urlPrefix || urlPrefix,
			collectionId: options.collectionId,
			year: options.year,
			month: options.month
		});

		return getDataFromService({ url: url, timeout: options.timeout }, req)
			.then(function (days) {
				return getUrlForCalendarDays(days, options.collectionId, req);
			})
			.catch(log.getDependencyErrorHandler('GetCalendarDays', 'BrowseCollectionService', options, req, 'error'));
	});
}

function getUrlForHierarchy(hierarchy, collectionId, req) {
	var pubContext = pub.getContext(req);

	var allEntries = _.map(hierarchy, function (entry) {
		if (!entry.imageId) {
			return Promise.resolve(entry);
		}

		return getInteractiveImageUrl(collectionId, entry.imageId, pubContext).then(function (imageUrl) {
			entry.imageUrl = imageUrl;
			return entry;
		}).catch(function () { return entry; });
	});

	return Promise.all(allEntries);
}

function getUrlForCalendarDays(days, collectionId, req) {
	var pubContext = pub.getContext(req);

	var allImages = _.map(days, function(imageId, day) {
		return getInteractiveImageUrl(collectionId, imageId, pubContext).then(function (imageUrl) {
			return {
				day: day,
				imageId: imageId,
				imageUrl: imageUrl
			};
		}).catch(function () {
			return {
				day: day,
				imageId: imageId
			};
		});
	});

	return Promise.all(allImages).then(function (images) {
		var result = {};
		for (var i = 0; i < images.length; i++) {
			result[images[i].day] = images[i];
		}
		return result;
	});
}

function getUrlForTableOfContents(tableOfContents, collectionId, req) {
	var pubContext = pub.getContext(req);

	tableOfContents = _.map(tableOfContents, function (item) {
		return getInteractiveImageUrl(collectionId, item.imageId, pubContext).then(function (imageUrl) {
			item.imageUrl = imageUrl;
			return item;
		}).catch(function () { return item; });
	});

	return Promise.all(tableOfContents);
}

function getInteractiveImageUrl(collectionId, imageId, pubContext) {
	return new Promise(function (resolve, reject) {
		pub.getHistoryParams({
			url: pubContext.getUrl(),
			context: pubContext
		}, function (err, params) {
			pub.getUrl({
				destPageName: 'InteractiveImageViewer',
				destInputs: {
					InteractiveUrlPrefix: 'interactive',
					CollectionId: collectionId,
					ImageId: imageId
				},
				passThroughParameters: params.query,
				fragmentPassthroughParameters: params.fragment,
				context: pubContext
			}, function (err, url) {
				if (err) {
					return reject(err);
				}
				resolve(url);
			});
		});
	});
}

module.exports = {
	init: init,
	getCollectionType: getCollectionType,
	getCalendarCollection: getCalendarCollection,
	getBrowseCollection: getBrowseCollection,
	getCalendarDays: getCalendarDays,
	getCalendarMonths: getCalendarMonths,
	getCollectionHierarchy: getCollectionHierarchy
};
},{"../logging":9,"../pubRepository":10,"ancestry-request":11,"config":12,"string-format":67}],28:[function(require,module,exports){
'use strict';

var request = require('ancestry-request');
var LruCache = require('lru-cache');

var halfHourInMillis = 0.5 * 60 * 60 * 1000;
var cache = LruCache({
	max: 3000,
	maxAge: halfHourInMillis
}); 
var globalCacheKey = "global";
var urlPrefix;
function requireInit() {
	return !urlPrefix
		? Promise.reject(new Error("init must be called prior to any other method"))
		: Promise.resolve();
}

module.exports = {
	init: function(options) {
		if (!options || !options.urlPrefix) {
			throw new Error("init requires urlPrefix");
		}
		if (/[^/]$/.test(options.urlPrefix) !== true) {
			throw new Error("urlPrefix must not end with a slash (/)");
		}
		urlPrefix = options.urlPrefix;
	},
	getFieldsForCategories: function(categoryIds, req) {
		return requireInit().then(function() {
			return getFormFieldsByIds(fetchFieldsForCategory, categoryIds, 'cat:', req);
		});
	},
	getFieldsForCollections: function(collectionIds, req) {
		return requireInit().then(function() { 
			return getFormFieldsByIds(fetchFieldsForCollection, collectionIds, 'col:', req);
		});
	},
	getFieldsForGlobalSearch: function(req){
		var cacheResponsePromise = cache.get(globalCacheKey);
		if (cacheResponsePromise)
			return cacheResponsePromise;
		var responsePromise = requireInit().then(function() {
			return fetchFieldsForGlobalSearch(req);
		}).catch(function(err){
			cache.del(globalCacheKey);
			throw err;
		});
		cache.set(globalCacheKey, responsePromise);
		return responsePromise;
	}
};

function fetchFieldsForCategory(id, req) {
	var options = {
		url: urlPrefix + '/categories/' + id,
		json: true,
		timeout: 200
	};

	return request.get(options, req);
}

function fetchFieldsForCollection(id, req) {
	var options = {
		url: urlPrefix + '/collections/' + id,
		json: true,
		timeout: 200
	};

	return request.get(options, req);
}

function fetchFieldsForGlobalSearch(req) {
	var options = {
		url: urlPrefix + '/global',
		json: true,
		timeout: 200
	};

	return request.get(options, req);
}

function getFormFieldsByIds(fn, ids, cachePrefix, req) {
	if (!ids || ids.length === 0) {
		return Promise.resolve([]);
	}

	return Promise.all(getPromises(fn, ids, cachePrefix, req));
}

function getPromises(fn, entityIds, cachePrefix, req) {
	var promises = [];

	entityIds.forEach(function(id) {
		var cacheKey = cachePrefix + id;

		var cachedFields = cache.get(cacheKey);
		if (cachedFields) {
			return promises.push(Promise.resolve({
				id: id, fields: cachedFields
			}));
		}

		var p = fn(id, req).then(function(fields) {
			cache.set(cacheKey, fields);
			return { id: id, fields: fields };
		});

		promises.push(p);
	});

	return promises;
}

},{"ancestry-request":11,"lru-cache":41}],29:[function(require,module,exports){
'use strict';

var request = require('ancestry-request');
var log = require('../logging');

var urlPrefix;

module.exports = {
	init: function(options) {
		urlPrefix = options.urlPrefix;
	},
	saveLastSearch: function (searchUrl, req) {
		var requestOptions = {
			url: urlPrefix + '/last-search',
			json: true,
			timeout: 1000,
			body: {
				type: "LastHorizonSearch",
				uri: searchUrl
			}
		};
		return request.post(requestOptions, req)
			.catch(function(err){
				log.logDependencyError("lastSearchProxy", "searchui-results", null, req, 'warn', err);
			});
	}
};
},{"../logging":9,"ancestry-request":11}],30:[function(require,module,exports){
'use strict';

var request = require('ancestry-request');
var log = require('../logging');

module.exports = {
	getRecord: getRecord
};

var MAX_TOC_ITEMS = 8;
var THUMBNAIL_SIZE = 96;
var PRIVATE_MEMBER_TREES_NAME = 'membertrees';
var PUBLIC_MEMBER_TREES_NAME = 'pubmembertrees';
var cache = {};

function getRecord(options, callback) {
	var pub = options.pub;
	var dataModel = options.dataModel;
	var collectionId = options.collectionId;
	var recordId = options.recordId;
	var environmentDomainStr = options.environmentDomainStr;
	var domain = options.domain;
	var client = options.client;
	var usage = options.usage;
	var pageName = options.pageName;
	var req = options.req;

	var cacheKey = domain + '-' + collectionId + '-' + recordId;
	if (cacheKey in cache) {
		return callback(null, cache[cacheKey]);
	}
	var url = 'https://' + domain + '/api/search-results/record/' + collectionId + '/' + recordId + '/?client=' + client + '&viewType=' + usage + '&pageName=' + pageName;
	var requestOptions = {
		url: url,
		json: true,
		timeout: 2000
	};

	request.get(requestOptions, req).then(function(record) {
		record.hasTableOfContents = record.features && !!record.features.tableOfContents;
		record.isTreesCollection = record.collectionName.toLowerCase() === PRIVATE_MEMBER_TREES_NAME || record.collectionName.toLowerCase() === PUBLIC_MEMBER_TREES_NAME;

		var pubContext = pub.getContext(req);
		var queryId = options.queryId;

		function getUrlWithHistoryPromise(pageName, inputs) {
			return new Promise(function (resolve, reject) {
				pub.getHistoryParams({
					url: pubContext.getUrl() + '&successSource=Search&queryId=' + queryId,
					context: pubContext,
					taskName: 'successSource'
				}, function (err, params) {
					pub.getUrl({
						destPageName: pageName,
						destInputs: inputs,
						passThroughParameters: params.query,
						fragmentPassthroughParameters: params.fragment,
						context: pubContext
					}, function (err, url) {
						if (err) return reject(err);
						resolve(url);
					});
				});
			});
		}

		var promises = [];

		function doesTableOnlyContainCurrentRecord(tableFeature, recordId) {
			if (tableFeature && tableFeature.Rows && tableFeature.Rows.length <= 1) {
				return tableFeature.Rows.length === 1 && tableFeature.Rows.Items
					? tableFeature.Rows[0].Items[0].Link.RecordId === recordId
					: true;
			}
			return false;
		}

		var veiled = false;

		record.displayFields.forEach(function (item) {
			if (item.veiled) {
				veiled = true;
			}

			if (doesTableOnlyContainCurrentRecord(item.tableFeature, record.recordId)) {
				item.tableFeature = null;
			}

			//TODO: the old stack has a limit of max number of HH records to show. we need to respect it here?
			if (item.tableFeature) {
				checkAndRemoveAgeColumnIfEmpty(item.tableFeature);
				removeRelationshipColumn(item.tableFeature);

				item.tableFeature.Rows.forEach(function (row) {
					if (row.Items) {
						row.Items.forEach(function (rowItem) {
							if (rowItem.Link) {
								getUrlWithHistoryPromise("RecordIndex", {
									"CollectionId": rowItem.Link.CollectionId,
									"RecordId": rowItem.Link.RecordId
								}).then(function (url) {
									rowItem.viewRecordUrl = url;
								});
							}
						});
					}
				});
			}
		});

		record.hasVeiledFields = veiled;

		if (record.hasTableOfContents) {
			record.features.tableOfContents.items.forEach(function (item) {
				promises.push(getUrlWithHistoryPromise("InteractiveImageViewer", {
					"CollectionId": record.collectionId,
					"RecordId": record.recordId,
					"ImageId": item.imageIds[0],
					"TreeId": dataModel.treePerson.treeId,
					"PersonId": dataModel.treePerson.personId
				}).then(function (url) {
					item.viewImageUrl = url;
				}));
				item.value = item.startPage;
				if (item.endPage !== item.startPage) {
					item.value += '-' + item.endPage;
				}
			});

			record.features.tableOfContents.hiddenItems = record.features.tableOfContents.items.splice(MAX_TOC_ITEMS);
			record.features.tableOfContents.showImageFan = record.features.tableOfContents.totalImages > 1;
		}
		// TODO: build page urls with PUB instead to get history
		var pageName = record.isTreesCollection ? 'PersonFacts' : 'RecordIndex';
		var recordUrlPromise = getUrlWithHistoryPromise(pageName, {
			"CollectionId": record.collectionId,
			"RecordId": record.recordId,
			"TreeId": dataModel.treePerson.treeId,
			"PersonId": dataModel.treePerson.personId
		}).then(function (url) {
			record.viewIndexUrl = url;
		});
		promises.push(recordUrlPromise);
		var imageViewerUrlPromise = null;

		if (!record.imageId) {
			imageViewerUrlPromise = Promise.resolve();
		}
		else {
			var thumbnailUrlPromise = getUrlWithHistoryPromise("CollectionImageThumbnail", {
				"CollectionId": record.collectionId,
				"ImageId": record.imageId,
				"LongestSide": THUMBNAIL_SIZE
			}).then(function (url) {
				record.thumbnailUrl = url;
			});
			promises.push(thumbnailUrlPromise);
			imageViewerUrlPromise = getUrlWithHistoryPromise("InteractiveImageViewer", {
				"CollectionId": record.collectionId,
				"RecordId": record.recordId,
				"ImageId": record.imageId,
				"TreeId": dataModel.treePerson.treeId,
				"PersonId": dataModel.treePerson.personId
			}).then(function (url) {
				record.viewImageUrl = url;
			});
			promises.push(imageViewerUrlPromise);
		}
		var setPrimaryActualUrlPromise = Promise.all([recordUrlPromise, imageViewerUrlPromise]).then(function () {
			//TODO: is this logic always valid? (i.e. is index link always the best to default to?)
			record.primaryActionUrl = record.viewIndexUrl || record.viewImageUrl;
		});
		promises.push(setPrimaryActualUrlPromise);

		if (record.hasVeiledFields) {
			setPrimaryActualUrlPromise.then(function () {
				if (record.features.contentRights.isFreeIfLoggedIn) {
					record.denyUrl = '/secure/register/index/?rtype=1' +
						'&fname=&lname=' +
						'&dbid=' + record.collectionId + '&pid=' + record.recordId +
						'&flowId=dbid' + record.collectionId + '&returnurl=' + encodeURIComponent(record.primaryActionUrl);
				} else {
					record.denyUrl = '/security/deny.aspx?hovR=1' +
						'&sub=' + record.features.contentRights.subscriptionAccessToken +
						'&dbid=' + record.collectionId +
						'&h=' + record.recordId +
						'&gsfn=' +
						'&gsln=' +
						'&url=' + encodeURIComponent(record.primaryActionUrl);
				}
				if (record.features.contentRights.isPpvSubscriber) {
					record.denyUrl = record.primaryActionUrl;
				}
			});
		}

		Promise.all(promises).then(function () {
			cache[cacheKey] = record;
			callback(null, record);
		}).catch(callback);

	}).catch(function(err) {
		log.logDependencyError('GetRecord', 'RecordService', requestOptions, req, err);
		callback(err);
	});
}

function removeRelationshipColumn(table) {
	var index = getColumnIndex('relationship', table);

	if (index !== -1) {
		removeColumnFromTable(table, index);
	}
}

function checkAndRemoveAgeColumnIfEmpty(table) {
	var index = getColumnIndex('age', table);

	if (index !== -1 && columnIsEmpty(table, index)) {
		removeColumnFromTable(table, index);
	}
}

function getColumnIndex(columnName, table) {
	for (var i = 0; i < table.ColumnHeaders.length; i++) {
		if (table.ColumnHeaders[i].toLowerCase() === columnName.toLowerCase()) {
			return i;
		}
	}

	return -1;
}

function columnIsEmpty(table, columnIndex) {
	for (var i = 0; i < table.Rows.length; i++) {
		if (table.Rows[i].Items[columnIndex].Value.length > 0) {
			return false;
		}
	}

	return true;
}

function removeColumnFromTable(table, columnIndex) {
	table.ColumnHeaders.splice(columnIndex, 1);

	table.Rows.forEach(function (row) {
		row.Items.splice(columnIndex, 1);
	});
}

},{"../logging":9,"ancestry-request":11}],31:[function(require,module,exports){
'use strict';

var request = require('ancestry-request');
var queryParamNormalizer = require('url-canonicalizer').queryParamNormalizer;
var _ = window._;
var DependencyError = require('../errors/dependencyError');

var urlPrefix;

function requireInit() {
	return !urlPrefix
		? Promise.reject(new Error("init must be called prior to any other method"))
		: Promise.resolve();
}

function init(options) {
	if (!options || !options.urlPrefix) {
		throw new Error("init requires urlPrefix");
	}
	if (/[^/]$/.test(options.urlPrefix) !== true) {
		throw new Error("urlPrefix must not end with a slash (/)");
	}
	urlPrefix = options.urlPrefix;
}

function getSearchResults(options, req) {
	var queryModel = options.queryModel || {};
	queryModel = _.omit(queryModel, 'sort', 'viewMode');
	var queryParamData = queryParamNormalizer.toQueryParams(queryModel, 'searchResults', { 
		collections: queryModel.collections.map(function (slugObj) { return slugObj.id; }).join('.'),
		categories: queryModel.categories.map(function (slugObj) { return slugObj.id; }).join('.'),
		testCaseId: options.testCaseId || '',
		debug: options.debug || '',
		useClusterView: options.useClusterView,
		searchState: options.searchState
	});
	var clusterView = (req.isInternal && req.query.test_cluster === '1') ? '&test_cluster=1': ''; // checks the url for test_cluster in order to opt in mock cluster data.
	var url = urlPrefix + '?' + queryParamData.queryString + clusterView ;
	var requestOptions = { url: url, json: true, timeout: 25000 };
	return request.get(requestOptions, req).then(function (searchModel) {
		searchModel.requestUrl = url;
		return searchModel;
	}).catch(function (err) {		
		throw new DependencyError(err.message, 'getResults', 'searchui-results');
	});
}

function getCategorySearchResults(options, req) {
	var queryModel = options.queryModel || {};
	queryModel = _.omit(queryModel, 'sort', 'viewMode');
	var queryParamData = queryParamNormalizer.toQueryParams(queryModel, 'searchResults', {
		debug: options.debug,
		categoryBucket: categoryBucketToString(options.categoryBucket),
		category: options.categoryName,
		paged: options.paging ? true : null,
		itemsPerPage: (options.paging||{}).itemsPerPage,
		pageNumber: (options.paging||{}).pageNumber,
		testCaseId: options.testCaseId,
		sort: options.sort
	});
	var url = urlPrefix + '/hit-counts?' + queryParamData.queryString;
	var requestOptions = { url: url, json: true, timeout: 25000 };
	return request.get(requestOptions, req).then(function (results) {
		results.requestUrl = url;
		return results;
	}).catch(function (err) {
		throw new DependencyError(err.message, 'getCategorySearchResults', 'searchui-results');
	});
}

function categoryBucketToString(categoryBucket) {
	return _.keys(categoryBucket).map(function (key) {
		if (categoryBucket[key]) {
			return _.first(key);
		}
		return '';
	}).join('');
}

module.exports = {
	init: init,
	getSearchResults: function(options, req){
		return requireInit().then(function(){
			return getSearchResults(options, req);
		});
	},
	getCategorySearchResults: function(options, req){
		return requireInit().then(function(){
			return getCategorySearchResults(options, req);
		});
	}
};
},{"../errors/dependencyError":22,"ancestry-request":11,"url-canonicalizer":69}],32:[function(require,module,exports){
'use strict';

var searchResultsServiceProxy = require('./proxies/searchResultsServiceProxy');
var pub = require('./pubRepository');
var _ = window._;
var queryParamNormalizer = require('url-canonicalizer').queryParamNormalizer;
var searchResultDebugInfoFormatter = require('./formatters/searchResultDebugInfoFormatter');
var config = require('config');
var imageMatchPreviewProvider = require('./imageMatchPreviewProvider');
var format = require('string-format');
var facetFieldsServiceProxy = require('./proxies/facetFieldsServiceProxy');
var searchUrlHelper = require('./searchUrlHelper');
var i18n = require('./i18n');
var log = require('./logging');

var RECORD_VIEW_MODE = 'record';
var PAGE_RANGE = 5;

module.exports = new SearchResultsProvider();

function SearchResultsProvider() {
	this.getSearchResultsViewModel = function (options) {
		var queryModel = _.clone(options.dataModel);
		//remove cursor on page 1
		var oldPaging = queryModel.page;
		if (queryModel.page.number === 1) {
			queryModel.page = {
				number: 1,
				size: oldPaging.size,
				cursor: null
			};
		}

		var searchParams = {
			domain: options.domain,
			att: options.attCookie,
			queryModel: queryModel,
			partner: options.partnerId,
			pub: pub,
			debug: options.debug,
			testCaseId: options.testCaseId,
			cultureId: options.cultureId,
			baseUrl: options.baseUrl,
			useClusterView: options.useClusterView,
			searchState: options.searchState,
			viewFeedbackCallout: options.viewFeedbackCallout
		};

		if (options.dataModel.viewMode === RECORD_VIEW_MODE) {
			return getRecordViewResultsModel(searchParams, options.req);
		} else {
			return getCategoryViewResultsModel(searchParams, options.req);
		}
	};
}

function getCategoryViewResultsModel(options, req) {
	var paginated = false;
	var queryModel = options.queryModel;
	options.categoryBucket = queryModel.types;
	options.categoryNames = null;
	options.sort = queryModel.sort;

	if (queryModel.categories.length > 0) {
		paginated = true;
		options.categoryName = queryModel.categories[0].id;
		options.paging = {
			itemsPerPage: queryModel.page.size,
			pageNumber: queryModel.page.number
		};
	}
	options.queryModel = _.omit(queryModel, 'sort');

	return searchResultsServiceProxy.getCategorySearchResults(options, req)
		.then(function (results) {
			searchResultDebugInfoFormatter.normalizeDebugInfo(results, results.requestUrl);
			results = _.set(results, 'categoryHitCounts', true);
			_.set(results, 'paginated', paginated);
			var baseUrl = options.baseUrl || (req.protocol + '://' + req.get('host') + req.path);
			return postProcessResults(req, options.queryModel, results, 'category', options.partner, options.cultureId, baseUrl);
		});
}

function setUpNextAndPreviousPageUrls(results, queryModel, baseUrl) {
	var dataModelPageNumber = queryModel.page.number;
	if (results.pageNumber > 1) {
		queryModel.page.number = results.pageNumber - 1;
		results.page.prev = baseUrl + '?' + queryParamNormalizer.toQueryParams(queryModel, 'searchResults').queryString;
	}
	if (results.pageNumber < results.pageCount) {
		queryModel.page.number = results.pageNumber + 1;
		results.page.next = baseUrl + '?' + queryParamNormalizer.toQueryParams(queryModel, 'searchResults').queryString;
	}
	queryModel.page.number = dataModelPageNumber;
}

function getRecordViewResultsModel(options, req) {
	options.queryModel = _.omit(options.queryModel, 'sort', 'viewMode');
	return searchResultsServiceProxy.getSearchResults(options, req)
		.then(function (results) {
			searchResultDebugInfoFormatter.normalizeDebugInfo(results, results.requestUrl);
			_.set(results, 'categoryHitCounts', false);
			var baseUrl = options.baseUrl || (req.protocol + '://' + req.get('host') + req.path);
			return postProcessResults(req, options.queryModel, results, 'record', options.partner, options.cultureId, baseUrl, options.useClusterView, options.viewFeedbackCallout);
		});
}

function postProcessResults(req, queryModel, searchModel, viewMode, partner, cultureId, baseUrl, useClusterView, viewFeedbackCallout) {
	if (searchModel.results.page) {
		searchModel.results.page = fixupPagingNumbers(queryModel, searchModel.results.page, searchModel.results.hitCount, baseUrl);
	} else {
		searchModel.results.page = {};
		if (searchModel.results.pageCount && searchModel.results.pageCount > 1) {
			setUpNextAndPreviousPageUrls(searchModel.results, queryModel, baseUrl);
		}
	}

	if (viewMode === RECORD_VIEW_MODE) {
		addMatchPreviewData(searchModel.results.items);
		addSourceData(searchModel.results.items, req && req.culture ? req.culture.code : cultureId);
		addHitHighlighting(searchModel.results.items);
		addHoverInfo(searchModel.results.items);
		setCollectionTitles(searchModel);
		addMatchingTreeResult(searchModel);
		addIconClass(searchModel);
		addClusterViewData(searchModel.results.items);
		searchModel.results.clusterViewEnabled = useClusterView;
		searchModel.results.feedbackCallout = viewFeedbackCallout;

		if (searchModel.guidance && searchModel.guidance.length > 0) {
			searchModel.results.suggestedFields = searchModel.guidance;
		}

		return addLinks(queryModel, searchModel, req).then(function () {
			return searchModel;
		});
	}

	return setResultsUrls(req, queryModel, searchModel, partner).then(function () {
		return searchModel;
	});
}

var mediaTypeToIconClassMap = {
	StoryPDF: 'iconDocumentPdf',
	StoryDoc: 'iconDocumentWord',
	StoryRTF: 'iconDocument',
	StoryOther: 'iconStory',
	Story: 'iconStory',
	Photo: 'iconCamera',
	Unknown: 'iconDocument'
};

function addHoverInfo(items) {
	items.forEach(function (item) {
		item.hasHover = item.recordId && item.recordType !== 'media' && item.recordType !== 'image' && item.recordType !== 'treePerson';
	});
}

function setCollectionTitles(searchModel) {
	searchModel.results.items.forEach(function (item) {
		if (item.recordType !== 'treePerson') {
			item.title = item.collectionTitle;
			item.subTitle = item.primaryCategory;
		} else {
			item.title = item.treeName;
			item.subTitle = item.collectionTitle;
		}
	});
}

function addIconClass(searchModel) {
	searchModel.results.items.forEach(function (item) {
		if (item.hasTableOfContents === true) {
			item.iconClass = item.imageIds.length > 1 ? 'iconGallery' : 'iconImage';
		} else if (item.recordType === 'media') {
			item.iconClass = mediaTypeToIconClassMap[item.mediaType];
		} else if (item.recordType === 'treePerson') {
			item.iconClass = 'iconPerson';
		} else if (item.recordType === 'image') {
			item.iconClass = 'iconImage';
		}
		item.iconClass = item.iconClass || 'iconNote';
	});
}

function addClusterViewData(resultItems) {
	_.forEach(resultItems, function (resultItem) {
		if (resultItem.lifeStory) {
			resultItem.includesDates = false;
			for (var i = 0; i < resultItem.lifeStory.length; i++) {
				if (resultItem.lifeStory[i].day || resultItem.lifeStory[i].month || resultItem.lifeStory[i].year) {
					resultItem.includesDates = true;
				}
			}
		}
	});
}

function fixupPagingNumbers(queryModel, pageModel, totalHitCount, baseUrl) {
	pageModel.max = Math.ceil(totalHitCount / pageModel.size);
	pageModel.firstHit = pageModel.number * pageModel.size - pageModel.size + 1;
	var lastHit = pageModel.firstHit + pageModel.size - 1;
	pageModel.lastHit = lastHit > totalHitCount ? totalHitCount : lastHit;
	pageModel.allowedPages = getAllowedPages(queryModel, pageModel);
	var previousPageQuery = pageModel.allowedPages[pageModel.number - 1];
	var nextPageQuery = pageModel.allowedPages[pageModel.number + 1];
	pageModel.prev = previousPageQuery ? baseUrl + previousPageQuery : null;
	pageModel.next = nextPageQuery ? baseUrl + nextPageQuery : null;
	return pageModel;
}

function getAllowedPages(queryModel, pageModel) {
	var page = pageModel.number;
	var minPage = Math.max(1, page - PAGE_RANGE);
	var maxPage = Math.min(pageModel.max, page + PAGE_RANGE);
	var pages = {};
	var dataModelPageNumber = queryModel.page.number;
	for (var pageNumber = minPage; pageNumber <= maxPage; ++pageNumber) {
		queryModel.page.number = pageNumber;
		pages[pageNumber] = '?' + queryParamNormalizer.toQueryParams(queryModel, 'searchResults').queryString;
	}
	queryModel.page.number = dataModelPageNumber;
	return pages;
}

function addMatchingTreeResult(searchResultsModel) {
	var treeItem = searchResultsModel.results.treeItem;
	if (!treeItem) return;

	//TEMP: don't show if there are guidance suggestions as this may indicate a low-quality search & result
	if (searchResultsModel.guidance && searchResultsModel.guidance.length > 0) {
		delete searchResultsModel.results.treeItem;
		return;
	}

	//TEMP: get name field from fields and remove - this needs to be done in a better way
	// (probably a different summary view from record search that includes name and maybe picture as properties)
	for (var i = 0; i < treeItem.fields.length; ++i) {
		var field = treeItem.fields[i];
		if (field.label === 'Name') {
			treeItem.name = field.text;
			treeItem.fields.splice(i, 1);
			break;
		}
	}
}

// creates URL for search result items where irrelevant search params are stripped off
function setResultsUrls(req, queryModel, searchResultsModel, partner) {
	var searchResultRecords = searchResultsModel.results.items;
	var queryId = searchResultsModel.queryId;
	var pageSize = queryModel.page.size;
	var model = _.omit(queryModel, 'page');
	model.page = { size: pageSize };

	var categoryIds = [];
	var collectionIds = [];

	collectEntityIds(searchResultRecords, categoryIds, collectionIds);

	var getFieldsForCategories = facetFieldsServiceProxy.getFieldsForCategories(categoryIds, req);
	var getFieldsForCollections = facetFieldsServiceProxy.getFieldsForCollections(collectionIds, req);
	var getFieldsForGlobalSearch = facetFieldsServiceProxy.getFieldsForGlobalSearch(req);

	return Promise
		.all([getFieldsForCategories, getFieldsForCollections, getFieldsForGlobalSearch])
		.then(function (results) {
			var categoriesFields = results[0];
			var collectionsFields = results[1];
			var globalSearchFields = results[2];

			createLinks(searchResultRecords, model, categoriesFields, collectionsFields, globalSearchFields, partner, req, queryId);
		}, function () {
			// fallback behavior takes place when we failed to retrieve any search form fields. in this case we configure facet links
			// but they're not cleaned up from irrelevant query params
			createLinks(searchResultRecords, model, [], [], [], partner, req, queryId);

			//return a resolved promise to trigger caller's success handler
			return Promise.resolve();
		});
}

function createLinks(searchResultRecords, dataModel, categoriesFields, collectionFields, globalSearchFields, partner, req, queryId) {
	var globalSearchUrl = createGlobalSearchUrl(dataModel, globalSearchFields);

	searchResultRecords.forEach(function (item) {
		if (!(item.searchUrl && item.searchUrl.includes('/categories'))) {
			if (dataModel.categories[0]) {
				item.searchUrl = globalSearchUrl;
				if(!dataModel.parentCategory) {
					dataModel.parentCategory = dataModel.categories[0].id;
				}
			} else if (item.Token) {
				var id = item.slug ? item.slug : getId(item.Token);
				item.searchUrl = createCategorySearchUrl(id, dataModel, categoriesFields, req);
			}
		}

		item.Collections.forEach(function (collection) {
			if (!(collection.searchUrl && !collection.searchUrl.includes('/collections'))) {
				if (dataModel.collections[0]) {
					collection.searchUrl = globalSearchUrl;
				} else if (collection.Token) {
					var id = collection.slug ? collection.slug : getId(collection.Token);
					collection.searchUrl = createCollectionSearchUrl(id, dataModel, collectionFields, queryId);
				}
			}
		});
	});
}

function createCategorySearchUrl(id, dataModel, fieldData) {
	var fieldNames = getSearchFormFields(fieldData, id);
	var queryString = searchUrlHelper.createSearchQueryStringFromDataModel(dataModel, fieldNames);

	return format('/search/categories/{id}/?{queryString}', { id: id, queryString: queryString });
}

function createCollectionSearchUrl(id, dataModel, collectionFields, queryId) {
	var fieldNames = getSearchFormFields(collectionFields, id);
	var queryString = searchUrlHelper.createSearchQueryStringFromDataModel(dataModel, fieldNames);
	if (queryId) queryString += '&qh=' + encodeURIComponent(queryId);
	return format('/search/collections/{id}/?{queryString}', { id: id, queryString: queryString });

}

function createGlobalSearchUrl(dataModel, fieldNames) {
	var queryString = searchUrlHelper.createSearchQueryStringFromDataModel(dataModel, fieldNames);

	return '/search/?' + queryString;
}

function getSearchFormFields(fieldData, id) {
	var item = _.find(fieldData, function (f) {
		return f.id === id;
	});

	return item ? item.fields : [];
}

function collectEntityIds(items, categoryIds, collectionIds) {
	items.forEach(function (item) {
		if (!(item.searchUrl && item.searchUrl.includes('/categories')) && item.Token) {
			categoryIds.push(getId(item.Token));
		}

		item.Collections.forEach(function (collection) {
			if (!(collection.searchUrl && !collection.searchUrl.includes('/collections')) && collection.Token) {
				collectionIds.push(getId(collection.Token));
			}
		});
	});
}

function getId(token) {
	var lastPart = _.last(token.split('|'));
	return _.last(lastPart.split('='));
}

function addLinks(dataModel, searchModel, req) {
	var pubContext = pub.getContext(req);
	var queryId = searchModel.results.queryId;

	function getUrlPromise(pageName, inputs) {
		return new Promise(function (resolve, reject) {
			pub.getUrl({
				destPageName: pageName,
				destInputs: inputs,
				context: pubContext
			}, function (err, url) {
				if (err) {
					return reject(err);
				}

				resolve(url);
			});
		});
	}

	function getUrlWithHistoryPromise(pageName, inputs) {
		return new Promise(function (resolve, reject) {
			pub.getHistoryParams({
				url: pubContext.getUrl() + '&successSource=Search&queryId=' + queryId,
				context: pubContext,
				taskName: 'successSource'
			}, function (err, params) {
				if (err) return reject(err);
				pub.getUrl({
					destPageName: pageName,
					destInputs: inputs,
					passThroughParameters: params.query,
					fragmentPassthroughParameters: params.fragment,
					context: pubContext
				}, function (getUrlErr, url) {
					if (getUrlErr) return reject(getUrlErr);
					resolve(url);
				});
			});
		});
	}

	var addLinksPromises = [];
	var recordJudgmentItems = searchModel.recordJudgments == null ? [] : searchModel.recordJudgments.items;
	recordJudgmentItems.forEach(function (item) {
		var recordPageDestInputs = {
			CollectionId: item.CollectionId,
			RecordId: item.RecordId,
			TreeId: dataModel.treePerson.treeId,
			PersonId: dataModel.treePerson.personId
		};
		addLinksPromises.push(getUrlWithHistoryPromise('RecordIndex', recordPageDestInputs).then(function (url) {
			item.recordUrl = url;
		}));
	});

	if (!searchModel.categoryHitCounts) {
		(searchModel.results.items || []).forEach(function (item) {
			var treeId = dataModel.treePerson.treeId;
			var personId = dataModel.treePerson.personId;
			var imagePageDestInputs;

			var rectangleCoordinates = '';
			if (item.matchPreviewArea) {
				var previewCropArea = [
					item.matchPreviewArea.left,
					item.matchPreviewArea.top,
					item.matchPreviewArea.width,
					item.matchPreviewArea.height
				];
				var imageSnippetInputs = {
					CollectionId: item.collectionId,
					ImageId: item.imageIds[0],
					Client: config.componentId,
					SecurityToken: item.imageToken,
					CropRectangle: previewCropArea.join(),
					ImageScale: item.matchPreviewScale,
					ImageQuality: 'mc'
				};
				addLinksPromises.push(getUrlPromise('ImageSnippet', imageSnippetInputs).then(function (url) {
					item.matchPreview = url;
				}).catch(function (err) {
					log.warn('ImageSnippetFailed', err, null, null, null, req);
				}));
				var rectangleCoordinatesSeparator = '';
				item.matchAreas.forEach(function (matchArea) {
					rectangleCoordinates += rectangleCoordinatesSeparator + matchArea.left + ',' + matchArea.top + ',' +
						(matchArea.left + matchArea.width) + ',' + (matchArea.top + matchArea.height);
					rectangleCoordinatesSeparator = ';';
				});
			}

			if (item.recordType === 'media') {
				var pubPage = 'TreeViewStory';
				if (item.mediaType === 'Photo') {
					pubPage = 'TreeViewPhoto';
				}
				var mediaInputs = {
					MediaId: item.mediaId,
					TreeId: item.attachedTo[0].treeId,
					PersonId: item.attachedTo[0].personId,
					Source: 'search'
				};
				addLinksPromises.push(getUrlWithHistoryPromise(pubPage, mediaInputs).then(function (url) {
					item.recordUrl = url;
					item.imageViewerUrl = url;
				}));
			} else if (item.recordType === 'treePerson') {
				var personViewInputs = {
					TreeId: item.treeId,
					PersonId: item.personId
				};
				addLinksPromises.push(getUrlWithHistoryPromise('CurrentPersonView', personViewInputs).then(function (url) {
					item.recordUrl = url;
				}));
			} else if (item.recordType === 'image') {
				imagePageDestInputs = {
					CollectionId: item.collectionId,
					RecordId: item.recordId,
					ImageId: item.imageIds[0],
					TreeId: treeId,
					PersonId: personId,
					RectangleCoordinates: rectangleCoordinates
				};
				addLinksPromises.push(getUrlWithHistoryPromise('InteractiveImageViewer', imagePageDestInputs).then(function (url) {
					item.imageViewerUrl = url;
					item.recordUrl = url;
				}));
			} else {
				var recordPageDestInputs = {
					CollectionId: item.collectionId,
					RecordId: item.recordId,
					TreeId: treeId,
					PersonId: personId
				};
				addLinksPromises.push(getUrlWithHistoryPromise('RecordIndex', recordPageDestInputs).then(function (url) {
					item.recordUrl = url;
				}));
				if (item.imageIds && item.imageIds.length > 0) {
					imagePageDestInputs = {
						CollectionId: item.collectionId,
						RecordId: item.recordId,
						ImageId: item.imageIds[0],
						TreeId: treeId,
						PersonId: personId,
						RectangleCoordinates: rectangleCoordinates
					};
					addLinksPromises.push(getUrlWithHistoryPromise('InteractiveImageViewer', imagePageDestInputs).then(function (url) {
						item.imageViewerUrl = url;
					}));
				}
			}
			if (item.thumbnailIndex >= 0 && item.thumbnailIndex < item.imageIds.length) {
				var thumbnailInputs = {
					CollectionId: item.collectionId,
					ImageId: item.imageIds[item.thumbnailIndex],
					LongestSide: 160
				};
				addLinksPromises.push(getUrlPromise('CollectionImageThumbnail', thumbnailInputs).then(function (thumbnailUrl) {
					item.thumbnailUrl = thumbnailUrl;
				}));
			}
		});

		if (searchModel.results.treeItem) {
			var treeItem = searchModel.results.treeItem;
			var treePersonInputs = {
				TreeId: treeItem.treeId,
				PersonId: treeItem.personId
			};
			addLinksPromises.push(getUrlWithHistoryPromise('CurrentPersonView', treePersonInputs).then(function (treePersonUrl) {
				treeItem.personLink = treePersonUrl;
			}));

			var queryString = searchUrlHelper.createSearchQueryStringFromDataModel(dataModel);
			treeItem.moreTreesLink = '/search/categories/42/?' + queryString;
		}
	}
	return Promise.all(addLinksPromises);
}

function addMatchPreviewData(resultItems) {
	resultItems.forEach(function (resultItem) {
		if (resultItem.matchAreas == null || resultItem.matchAreas.length === 0) return;
		var previewData = imageMatchPreviewProvider.getPreviewData(resultItem.matchAreas);
		resultItem.matchAreasInPreview = previewData.matchAreasInPreview;
		resultItem.matchPreviewArea = previewData.previewArea;
		resultItem.matchPreviewBorder = {
			width: previewData.previewArea.width + 2,
			height: previewData.previewArea.height + 2
		};
		resultItem.matchPreviewScale = previewData.previewScale;
	});
}

function addHitHighlighting(resultItems) {
	resultItems.forEach(function (resultItem) {
		if (resultItem == null || resultItem.fields == null) return;
		resultItem.fields.forEach(function (field) {
			if (field.hitHighlightInfo == null || field.hitHighlightInfo.length === 0) return;
			var fieldText = [];
			var previousStartIndex = 0;
			_.forEachRight(field.hitHighlightInfo, function (highlightInfo) {
				fieldText = insertText(
					fieldText,
					field.text,
					'<span class=\'bold\'>',
					'</span>',
					highlightInfo.startIndex,
					highlightInfo.endIndex + 1,
					previousStartIndex
				);
				previousStartIndex = highlightInfo.startIndex;
			});
			fieldText.unshift(_.escape(field.text.slice(0, previousStartIndex)));
			field.text = fieldText.join('');
		});
	});
}

function insertText(fieldText, baseStr, startTag, endTag, startPosition, endPosition, previousStartIndex) {
	if (fieldText.length === 0)
		fieldText.unshift(_.escape(baseStr.slice(endPosition)));
	if (endPosition < previousStartIndex)
		fieldText.unshift(_.escape(baseStr.slice(endPosition, previousStartIndex)));
	if (baseStr) {
		fieldText.unshift(endTag);
		fieldText.unshift(_.escape(baseStr.slice(startPosition, endPosition)));
		fieldText.unshift(startTag);
	}
	return fieldText;
}

function addSourceData(resultItems, cultureId) {
	resultItems.forEach(function (resultItem) {
		if (resultItem.recordType === 'treePerson') {
			if (resultItem.attachedRecordsCount === 0 && resultItem.attachedSourcesCount === 0) {
				resultItem.sources = i18n.get('results.sources.unsourced', cultureId);
			} else {
				var attachedRecordsStr = pluralize('results.attachedRecords', resultItem.attachedRecordsCount, cultureId);
				var attachedSourcesStr = pluralize('results.sources', resultItem.attachedSourcesCount, cultureId);
				resultItem.sources = attachedRecordsStr && attachedSourcesStr
					? attachedRecordsStr + ', ' + attachedSourcesStr
					: attachedRecordsStr
						? attachedRecordsStr
						: attachedSourcesStr;
			}
		}
	});
}

function pluralize(key, count, cultureId) {
	if (count === 0) {
		return '';
	}

	key += count === 1 ? '.singular' : '.plural';

	return i18n.get(key, cultureId, { count: count });
}
},{"./formatters/searchResultDebugInfoFormatter":23,"./i18n":8,"./imageMatchPreviewProvider":26,"./logging":9,"./proxies/facetFieldsServiceProxy":28,"./proxies/searchResultsServiceProxy":31,"./pubRepository":10,"./searchUrlHelper":33,"config":12,"string-format":67,"url-canonicalizer":69}],33:[function(require,module,exports){
'use strict';

var queryParamNormalizer = require('url-canonicalizer').queryParamNormalizer;
var dataModelHelper = require('./dataModelHelper');
var _ = window._;

module.exports = {
	createSearchQueryStringFromDataModel: createSearchQueryStringFromDataModel
};

function createSearchQueryStringFromDataModel(dataModel, fieldNames) {
	var model = dataModel;

	if (fieldNames && fieldNames.length > 0) {
		model = _.cloneDeep(dataModel);
		// shape data model to reset values for fields not found in the list of search form fields
		dataModelHelper.removeUnrelatedData(model, fieldNames);
	}

	return queryParamNormalizer.toQueryParams(model, 'searchResults').queryString;
}


},{"./dataModelHelper":19,"url-canonicalizer":69}],34:[function(require,module,exports){
var zero = '0'.charCodeAt(0);
var plus = '+'.charCodeAt(0);
var minus = '-'.charCodeAt(0);

function isWhitespace(code) {
	return code <= 32;
}

function isDigit(code) {
	return 48 <= code && code <= 57;
}

function isSign(code) {
	return code === minus || code === plus;
}

module.exports = function (opts, a, b) {
	var checkSign = opts.sign;
	var ia = 0;
	var ib = 0;
	var ma = a.length;
	var mb = b.length;
	var ca, cb; // character code
	var za, zb; // leading zero count
	var na, nb; // number length
	var sa, sb; // number sign
	var ta, tb; // temporary
	var bias;

	while (ia < ma && ib < mb) {
		ca = a.charCodeAt(ia);
		cb = b.charCodeAt(ib);
		za = zb = 0;
		na = nb = 0;
		sa = sb = true;
		bias = 0;

		// skip over leading spaces
		while (isWhitespace(ca)) {
			ia += 1;
			ca = a.charCodeAt(ia);
		}
		while (isWhitespace(cb)) {
			ib += 1;
			cb = b.charCodeAt(ib);
		}

		// skip and save sign
		if (checkSign) {
			ta = a.charCodeAt(ia + 1);
			if (isSign(ca) && isDigit(ta)) {
				if (ca === minus) {
					sa = false;
				}
				ia += 1;
				ca = ta;
			}
			tb = b.charCodeAt(ib + 1);
			if (isSign(cb) && isDigit(tb)) {
				if (cb === minus) {
					sb = false;
				}
				ib += 1;
				cb = tb;
			}
		}

		// compare digits with other symbols
		if (isDigit(ca) && !isDigit(cb)) {
			return -1;
		}
		if (!isDigit(ca) && isDigit(cb)) {
			return 1;
		}

		// compare negative and positive
		if (!sa && sb) {
			return -1;
		}
		if (sa && !sb) {
			return 1;
		}

		// count leading zeros
		while (ca === zero) {
			za += 1;
			ia += 1;
			ca = a.charCodeAt(ia);
		}
		while (cb === zero) {
			zb += 1;
			ib += 1;
			cb = b.charCodeAt(ib);
		}

		// count numbers
		while (isDigit(ca) || isDigit(cb)) {
			if (isDigit(ca) && isDigit(cb) && bias === 0) {
				if (sa) {
					if (ca < cb) {
						bias = -1;
					} else if (ca > cb) {
						bias = 1;
					}
				} else {
					if (ca > cb) {
						bias = -1;
					} else if (ca < cb) {
						bias = 1;
					}
				}
			}
			if (isDigit(ca)) {
				ia += 1;
				na += 1;
				ca = a.charCodeAt(ia);
			}
			if (isDigit(cb)) {
				ib += 1;
				nb += 1;
				cb = b.charCodeAt(ib);
			}
		}

		// compare number length
		if (sa) {
			if (na < nb) {
				return -1;
			}
			if (na > nb) {
				return 1;
			}
		} else {
			if (na > nb) {
				return -1;
			}
			if (na < nb) {
				return 1;
			}
		}

		// compare numbers
		if (bias) {
			return bias;
		}

		// compare leading zeros
		if (sa) {
			if (za > zb) {
				return -1;
			}
			if (za < zb) {
				return 1;
			}
		} else {
			if (za < zb) {
				return -1;
			}
			if (za > zb) {
				return 1;
			}
		}

		// compare ascii codes
		if (ca < cb) {
			return -1;
		}
		if (ca > cb) {
			return 1;
		}

		ia += 1;
		ib += 1;
	}

	// compare length
	if (ma < mb) {
		return -1;
	}
	if (ma > mb) {
		return 1;
	}
};

},{}],35:[function(require,module,exports){
var compare = require('./compare');

function mediator(a, b) {
	return compare(this, a.converted, b.converted);
}

module.exports = function (array, opts) {
	if (!Array.isArray(array) || array.length < 2) {
		return array;
	}
	if (typeof opts !== 'object') {
		opts = {};
	}
	opts.sign = !!opts.sign;
	var insensitive = !!opts.insensitive;
	var result = Array(array.length);
	var i, max, value;

	for (i = 0, max = array.length; i < max; i += 1) {
		value = String(array[i]);
		result[i] = {
			value: array[i],
			converted: insensitive ? value.toLowerCase() : value
		};
	}

	result.sort(mediator.bind(opts));

	for (i = result.length - 1; ~i; i -= 1) {
		result[i] = result[i].value;
	}

	return result;
};

},{"./compare":34}],36:[function(require,module,exports){
(function (process,setImmediate){
module.exports = function (arr, iterator, callback) {
  callback = callback || function () {};
  if (!Array.isArray(arr) || !arr.length) {
      return callback();
  }
  var completed = 0;
  var iterate = function () {
    iterator(arr[completed], function (err) {
      if (err) {
        callback(err);
        callback = function () {};
      }
      else {
        ++completed;
        if (completed >= arr.length) { callback(); }
        else { nextTick(iterate); }
      }
    });
  };
  iterate();
};

function nextTick (cb) {
  if (typeof setImmediate === 'function') {
    setImmediate(cb);
  } else {
    process.nextTick(cb);
  }
}
}).call(this,require('_process'),require("timers").setImmediate)
},{"_process":42,"timers":68}],37:[function(require,module,exports){
// async-each MIT license (by Paul Miller from http://paulmillr.com).
(function(globals) {
  'use strict';
  var each = function(items, next, callback) {
    if (!Array.isArray(items)) throw new TypeError('each() expects array as first argument');
    if (typeof next !== 'function') throw new TypeError('each() expects function as second argument');
    if (typeof callback !== 'function') callback = Function.prototype; // no-op

    if (items.length === 0) return callback(undefined, items);

    var transformed = new Array(items.length);
    var count = 0;
    var returned = false;

    items.forEach(function(item, index) {
      next(item, function(error, transformedItem) {
        if (returned) return;
        if (error) {
          returned = true;
          return callback(error);
        }
        transformed[index] = transformedItem;
        count += 1;
        if (count === items.length) return callback(undefined, transformed);
      });
    });
  };

  if (typeof define !== 'undefined' && define.amd) {
    define([], function() {
      return each;
    }); // RequireJS
  } else if (typeof module !== 'undefined' && module.exports) {
    module.exports = each; // CommonJS
  } else {
    globals.asyncEach = each; // <script>
  }
})(this);

},{}],38:[function(require,module,exports){
(function (global){
/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		typeof define == 'function' &&
		typeof define.amd == 'object' &&
		define.amd
	) {
		define('punycode', function() {
			return punycode;
		});
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],39:[function(require,module,exports){
(function (global,setImmediate){
(function(global){

//
// Check for native Promise and it has correct interface
//

var NativePromise = global['Promise'];
var nativePromiseSupported =
  NativePromise &&
  // Some of these methods are missing from
  // Firefox/Chrome experimental implementations
  'resolve' in NativePromise &&
  'reject' in NativePromise &&
  'all' in NativePromise &&
  'race' in NativePromise &&
  // Older version of the spec had a resolver object
  // as the arg rather than a function
  (function(){
    var resolve;
    new NativePromise(function(r){ resolve = r; });
    return typeof resolve === 'function';
  })();


//
// export if necessary
//

if (typeof exports !== 'undefined' && exports)
{
  // node.js
  exports.Promise = nativePromiseSupported ? NativePromise : Promise;
  exports.Polyfill = Promise;
}
else
{
  // AMD
  if (typeof define == 'function' && define.amd)
  {
    define(function(){
      return nativePromiseSupported ? NativePromise : Promise;
    });
  }
  else
  {
    // in browser add to global
    if (!nativePromiseSupported)
      global['Promise'] = Promise;
  }
}


//
// Polyfill
//

var PENDING = 'pending';
var SEALED = 'sealed';
var FULFILLED = 'fulfilled';
var REJECTED = 'rejected';
var NOOP = function(){};

function isArray(value) {
  return Object.prototype.toString.call(value) === '[object Array]';
}

// async calls
var asyncSetTimer = typeof setImmediate !== 'undefined' ? setImmediate : setTimeout;
var asyncQueue = [];
var asyncTimer;

function asyncFlush(){
  // run promise callbacks
  for (var i = 0; i < asyncQueue.length; i++)
    asyncQueue[i][0](asyncQueue[i][1]);

  // reset async asyncQueue
  asyncQueue = [];
  asyncTimer = false;
}

function asyncCall(callback, arg){
  asyncQueue.push([callback, arg]);

  if (!asyncTimer)
  {
    asyncTimer = true;
    asyncSetTimer(asyncFlush, 0);
  }
}


function invokeResolver(resolver, promise) {
  function resolvePromise(value) {
    resolve(promise, value);
  }

  function rejectPromise(reason) {
    reject(promise, reason);
  }

  try {
    resolver(resolvePromise, rejectPromise);
  } catch(e) {
    rejectPromise(e);
  }
}

function invokeCallback(subscriber){
  var owner = subscriber.owner;
  var settled = owner.state_;
  var value = owner.data_;  
  var callback = subscriber[settled];
  var promise = subscriber.then;

  if (typeof callback === 'function')
  {
    settled = FULFILLED;
    try {
      value = callback(value);
    } catch(e) {
      reject(promise, e);
    }
  }

  if (!handleThenable(promise, value))
  {
    if (settled === FULFILLED)
      resolve(promise, value);

    if (settled === REJECTED)
      reject(promise, value);
  }
}

function handleThenable(promise, value) {
  var resolved;

  try {
    if (promise === value)
      throw new TypeError('A promises callback cannot return that same promise.');

    if (value && (typeof value === 'function' || typeof value === 'object'))
    {
      var then = value.then;  // then should be retrived only once

      if (typeof then === 'function')
      {
        then.call(value, function(val){
          if (!resolved)
          {
            resolved = true;

            if (value !== val)
              resolve(promise, val);
            else
              fulfill(promise, val);
          }
        }, function(reason){
          if (!resolved)
          {
            resolved = true;

            reject(promise, reason);
          }
        });

        return true;
      }
    }
  } catch (e) {
    if (!resolved)
      reject(promise, e);

    return true;
  }

  return false;
}

function resolve(promise, value){
  if (promise === value || !handleThenable(promise, value))
    fulfill(promise, value);
}

function fulfill(promise, value){
  if (promise.state_ === PENDING)
  {
    promise.state_ = SEALED;
    promise.data_ = value;

    asyncCall(publishFulfillment, promise);
  }
}

function reject(promise, reason){
  if (promise.state_ === PENDING)
  {
    promise.state_ = SEALED;
    promise.data_ = reason;

    asyncCall(publishRejection, promise);
  }
}

function publish(promise) {
  var callbacks = promise.then_;
  promise.then_ = undefined;

  for (var i = 0; i < callbacks.length; i++) {
    invokeCallback(callbacks[i]);
  }
}

function publishFulfillment(promise){
  promise.state_ = FULFILLED;
  publish(promise);
}

function publishRejection(promise){
  promise.state_ = REJECTED;
  publish(promise);
}

/**
* @class
*/
function Promise(resolver){
  if (typeof resolver !== 'function')
    throw new TypeError('Promise constructor takes a function argument');

  if (this instanceof Promise === false)
    throw new TypeError('Failed to construct \'Promise\': Please use the \'new\' operator, this object constructor cannot be called as a function.');

  this.then_ = [];

  invokeResolver(resolver, this);
}

Promise.prototype = {
  constructor: Promise,

  state_: PENDING,
  then_: null,
  data_: undefined,

  then: function(onFulfillment, onRejection){
    var subscriber = {
      owner: this,
      then: new this.constructor(NOOP),
      fulfilled: onFulfillment,
      rejected: onRejection
    };

    if (this.state_ === FULFILLED || this.state_ === REJECTED)
    {
      // already resolved, call callback async
      asyncCall(invokeCallback, subscriber);
    }
    else
    {
      // subscribe
      this.then_.push(subscriber);
    }

    return subscriber.then;
  },

  'catch': function(onRejection) {
    return this.then(null, onRejection);
  }
};

Promise.all = function(promises){
  var Class = this;

  if (!isArray(promises))
    throw new TypeError('You must pass an array to Promise.all().');

  return new Class(function(resolve, reject){
    var results = [];
    var remaining = 0;

    function resolver(index){
      remaining++;
      return function(value){
        results[index] = value;
        if (!--remaining)
          resolve(results);
      };
    }

    for (var i = 0, promise; i < promises.length; i++)
    {
      promise = promises[i];

      if (promise && typeof promise.then === 'function')
        promise.then(resolver(i), reject);
      else
        results[i] = promise;
    }

    if (!remaining)
      resolve(results);
  });
};

Promise.race = function(promises){
  var Class = this;

  if (!isArray(promises))
    throw new TypeError('You must pass an array to Promise.race().');

  return new Class(function(resolve, reject) {
    for (var i = 0, promise; i < promises.length; i++)
    {
      promise = promises[i];

      if (promise && typeof promise.then === 'function')
        promise.then(resolve, reject);
      else
        resolve(promise);
    }
  });
};

Promise.resolve = function(value){
  var Class = this;

  if (value && typeof value === 'object' && value.constructor === Class)
    return value;

  return new Class(function(resolve){
    resolve(value);
  });
};

Promise.reject = function(reason){
  var Class = this;

  return new Class(function(resolve, reject){
    reject(reason);
  });
};

})(typeof window != 'undefined' ? window : typeof global != 'undefined' ? global : typeof self != 'undefined' ? self : this);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("timers").setImmediate)
},{"timers":68}],40:[function(require,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}

},{}],41:[function(require,module,exports){
(function (process){
'use strict'

module.exports = LRUCache

// This will be a proper iterable 'Map' in engines that support it,
// or a fakey-fake PseudoMap in older versions.
var Map = require('pseudomap')
var util = require('util')

// A linked list to keep track of recently-used-ness
var Yallist = require('yallist')

// use symbols if possible, otherwise just _props
var hasSymbol = typeof Symbol === 'function' && process.env._nodeLRUCacheForceNoSymbol !== '1'
var makeSymbol
if (hasSymbol) {
  makeSymbol = function (key) {
    return Symbol(key)
  }
} else {
  makeSymbol = function (key) {
    return '_' + key
  }
}

var MAX = makeSymbol('max')
var LENGTH = makeSymbol('length')
var LENGTH_CALCULATOR = makeSymbol('lengthCalculator')
var ALLOW_STALE = makeSymbol('allowStale')
var MAX_AGE = makeSymbol('maxAge')
var DISPOSE = makeSymbol('dispose')
var NO_DISPOSE_ON_SET = makeSymbol('noDisposeOnSet')
var LRU_LIST = makeSymbol('lruList')
var CACHE = makeSymbol('cache')

function naiveLength () { return 1 }

// lruList is a yallist where the head is the youngest
// item, and the tail is the oldest.  the list contains the Hit
// objects as the entries.
// Each Hit object has a reference to its Yallist.Node.  This
// never changes.
//
// cache is a Map (or PseudoMap) that matches the keys to
// the Yallist.Node object.
function LRUCache (options) {
  if (!(this instanceof LRUCache)) {
    return new LRUCache(options)
  }

  if (typeof options === 'number') {
    options = { max: options }
  }

  if (!options) {
    options = {}
  }

  var max = this[MAX] = options.max
  // Kind of weird to have a default max of Infinity, but oh well.
  if (!max ||
      !(typeof max === 'number') ||
      max <= 0) {
    this[MAX] = Infinity
  }

  var lc = options.length || naiveLength
  if (typeof lc !== 'function') {
    lc = naiveLength
  }
  this[LENGTH_CALCULATOR] = lc

  this[ALLOW_STALE] = options.stale || false
  this[MAX_AGE] = options.maxAge || 0
  this[DISPOSE] = options.dispose
  this[NO_DISPOSE_ON_SET] = options.noDisposeOnSet || false
  this.reset()
}

// resize the cache when the max changes.
Object.defineProperty(LRUCache.prototype, 'max', {
  set: function (mL) {
    if (!mL || !(typeof mL === 'number') || mL <= 0) {
      mL = Infinity
    }
    this[MAX] = mL
    trim(this)
  },
  get: function () {
    return this[MAX]
  },
  enumerable: true
})

Object.defineProperty(LRUCache.prototype, 'allowStale', {
  set: function (allowStale) {
    this[ALLOW_STALE] = !!allowStale
  },
  get: function () {
    return this[ALLOW_STALE]
  },
  enumerable: true
})

Object.defineProperty(LRUCache.prototype, 'maxAge', {
  set: function (mA) {
    if (!mA || !(typeof mA === 'number') || mA < 0) {
      mA = 0
    }
    this[MAX_AGE] = mA
    trim(this)
  },
  get: function () {
    return this[MAX_AGE]
  },
  enumerable: true
})

// resize the cache when the lengthCalculator changes.
Object.defineProperty(LRUCache.prototype, 'lengthCalculator', {
  set: function (lC) {
    if (typeof lC !== 'function') {
      lC = naiveLength
    }
    if (lC !== this[LENGTH_CALCULATOR]) {
      this[LENGTH_CALCULATOR] = lC
      this[LENGTH] = 0
      this[LRU_LIST].forEach(function (hit) {
        hit.length = this[LENGTH_CALCULATOR](hit.value, hit.key)
        this[LENGTH] += hit.length
      }, this)
    }
    trim(this)
  },
  get: function () { return this[LENGTH_CALCULATOR] },
  enumerable: true
})

Object.defineProperty(LRUCache.prototype, 'length', {
  get: function () { return this[LENGTH] },
  enumerable: true
})

Object.defineProperty(LRUCache.prototype, 'itemCount', {
  get: function () { return this[LRU_LIST].length },
  enumerable: true
})

LRUCache.prototype.rforEach = function (fn, thisp) {
  thisp = thisp || this
  for (var walker = this[LRU_LIST].tail; walker !== null;) {
    var prev = walker.prev
    forEachStep(this, fn, walker, thisp)
    walker = prev
  }
}

function forEachStep (self, fn, node, thisp) {
  var hit = node.value
  if (isStale(self, hit)) {
    del(self, node)
    if (!self[ALLOW_STALE]) {
      hit = undefined
    }
  }
  if (hit) {
    fn.call(thisp, hit.value, hit.key, self)
  }
}

LRUCache.prototype.forEach = function (fn, thisp) {
  thisp = thisp || this
  for (var walker = this[LRU_LIST].head; walker !== null;) {
    var next = walker.next
    forEachStep(this, fn, walker, thisp)
    walker = next
  }
}

LRUCache.prototype.keys = function () {
  return this[LRU_LIST].toArray().map(function (k) {
    return k.key
  }, this)
}

LRUCache.prototype.values = function () {
  return this[LRU_LIST].toArray().map(function (k) {
    return k.value
  }, this)
}

LRUCache.prototype.reset = function () {
  if (this[DISPOSE] &&
      this[LRU_LIST] &&
      this[LRU_LIST].length) {
    this[LRU_LIST].forEach(function (hit) {
      this[DISPOSE](hit.key, hit.value)
    }, this)
  }

  this[CACHE] = new Map() // hash of items by key
  this[LRU_LIST] = new Yallist() // list of items in order of use recency
  this[LENGTH] = 0 // length of items in the list
}

LRUCache.prototype.dump = function () {
  return this[LRU_LIST].map(function (hit) {
    if (!isStale(this, hit)) {
      return {
        k: hit.key,
        v: hit.value,
        e: hit.now + (hit.maxAge || 0)
      }
    }
  }, this).toArray().filter(function (h) {
    return h
  })
}

LRUCache.prototype.dumpLru = function () {
  return this[LRU_LIST]
}

/* istanbul ignore next */
LRUCache.prototype.inspect = function (n, opts) {
  var str = 'LRUCache {'
  var extras = false

  var as = this[ALLOW_STALE]
  if (as) {
    str += '\n  allowStale: true'
    extras = true
  }

  var max = this[MAX]
  if (max && max !== Infinity) {
    if (extras) {
      str += ','
    }
    str += '\n  max: ' + util.inspect(max, opts)
    extras = true
  }

  var maxAge = this[MAX_AGE]
  if (maxAge) {
    if (extras) {
      str += ','
    }
    str += '\n  maxAge: ' + util.inspect(maxAge, opts)
    extras = true
  }

  var lc = this[LENGTH_CALCULATOR]
  if (lc && lc !== naiveLength) {
    if (extras) {
      str += ','
    }
    str += '\n  length: ' + util.inspect(this[LENGTH], opts)
    extras = true
  }

  var didFirst = false
  this[LRU_LIST].forEach(function (item) {
    if (didFirst) {
      str += ',\n  '
    } else {
      if (extras) {
        str += ',\n'
      }
      didFirst = true
      str += '\n  '
    }
    var key = util.inspect(item.key).split('\n').join('\n  ')
    var val = { value: item.value }
    if (item.maxAge !== maxAge) {
      val.maxAge = item.maxAge
    }
    if (lc !== naiveLength) {
      val.length = item.length
    }
    if (isStale(this, item)) {
      val.stale = true
    }

    val = util.inspect(val, opts).split('\n').join('\n  ')
    str += key + ' => ' + val
  })

  if (didFirst || extras) {
    str += '\n'
  }
  str += '}'

  return str
}

LRUCache.prototype.set = function (key, value, maxAge) {
  maxAge = maxAge || this[MAX_AGE]

  var now = maxAge ? Date.now() : 0
  var len = this[LENGTH_CALCULATOR](value, key)

  if (this[CACHE].has(key)) {
    if (len > this[MAX]) {
      del(this, this[CACHE].get(key))
      return false
    }

    var node = this[CACHE].get(key)
    var item = node.value

    // dispose of the old one before overwriting
    // split out into 2 ifs for better coverage tracking
    if (this[DISPOSE]) {
      if (!this[NO_DISPOSE_ON_SET]) {
        this[DISPOSE](key, item.value)
      }
    }

    item.now = now
    item.maxAge = maxAge
    item.value = value
    this[LENGTH] += len - item.length
    item.length = len
    this.get(key)
    trim(this)
    return true
  }

  var hit = new Entry(key, value, len, now, maxAge)

  // oversized objects fall out of cache automatically.
  if (hit.length > this[MAX]) {
    if (this[DISPOSE]) {
      this[DISPOSE](key, value)
    }
    return false
  }

  this[LENGTH] += hit.length
  this[LRU_LIST].unshift(hit)
  this[CACHE].set(key, this[LRU_LIST].head)
  trim(this)
  return true
}

LRUCache.prototype.has = function (key) {
  if (!this[CACHE].has(key)) return false
  var hit = this[CACHE].get(key).value
  if (isStale(this, hit)) {
    return false
  }
  return true
}

LRUCache.prototype.get = function (key) {
  return get(this, key, true)
}

LRUCache.prototype.peek = function (key) {
  return get(this, key, false)
}

LRUCache.prototype.pop = function () {
  var node = this[LRU_LIST].tail
  if (!node) return null
  del(this, node)
  return node.value
}

LRUCache.prototype.del = function (key) {
  del(this, this[CACHE].get(key))
}

LRUCache.prototype.load = function (arr) {
  // reset the cache
  this.reset()

  var now = Date.now()
  // A previous serialized cache has the most recent items first
  for (var l = arr.length - 1; l >= 0; l--) {
    var hit = arr[l]
    var expiresAt = hit.e || 0
    if (expiresAt === 0) {
      // the item was created without expiration in a non aged cache
      this.set(hit.k, hit.v)
    } else {
      var maxAge = expiresAt - now
      // dont add already expired items
      if (maxAge > 0) {
        this.set(hit.k, hit.v, maxAge)
      }
    }
  }
}

LRUCache.prototype.prune = function () {
  var self = this
  this[CACHE].forEach(function (value, key) {
    get(self, key, false)
  })
}

function get (self, key, doUse) {
  var node = self[CACHE].get(key)
  if (node) {
    var hit = node.value
    if (isStale(self, hit)) {
      del(self, node)
      if (!self[ALLOW_STALE]) hit = undefined
    } else {
      if (doUse) {
        self[LRU_LIST].unshiftNode(node)
      }
    }
    if (hit) hit = hit.value
  }
  return hit
}

function isStale (self, hit) {
  if (!hit || (!hit.maxAge && !self[MAX_AGE])) {
    return false
  }
  var stale = false
  var diff = Date.now() - hit.now
  if (hit.maxAge) {
    stale = diff > hit.maxAge
  } else {
    stale = self[MAX_AGE] && (diff > self[MAX_AGE])
  }
  return stale
}

function trim (self) {
  if (self[LENGTH] > self[MAX]) {
    for (var walker = self[LRU_LIST].tail;
      self[LENGTH] > self[MAX] && walker !== null;) {
      // We know that we're about to delete this one, and also
      // what the next least recently used key will be, so just
      // go ahead and set it now.
      var prev = walker.prev
      del(self, walker)
      walker = prev
    }
  }
}

function del (self, node) {
  if (node) {
    var hit = node.value
    if (self[DISPOSE]) {
      self[DISPOSE](hit.key, hit.value)
    }
    self[LENGTH] -= hit.length
    self[CACHE].delete(hit.key)
    self[LRU_LIST].removeNode(node)
  }
}

// classy, since V8 prefers predictable objects.
function Entry (key, value, length, now, maxAge) {
  this.key = key
  this.value = value
  this.length = length
  this.now = now
  this.maxAge = maxAge || 0
}

}).call(this,require('_process'))
},{"_process":42,"pseudomap":43,"util":78,"yallist":79}],42:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],43:[function(require,module,exports){
(function (process){
if (process.env.npm_package_name === 'pseudomap' &&
    process.env.npm_lifecycle_script === 'test')
  process.env.TEST_PSEUDOMAP = 'true'

if (typeof Map === 'function' && !process.env.TEST_PSEUDOMAP) {
  module.exports = Map
} else {
  module.exports = require('./pseudomap')
}

}).call(this,require('_process'))
},{"./pseudomap":44,"_process":42}],44:[function(require,module,exports){
var hasOwnProperty = Object.prototype.hasOwnProperty

module.exports = PseudoMap

function PseudoMap (set) {
  if (!(this instanceof PseudoMap)) // whyyyyyyy
    throw new TypeError("Constructor PseudoMap requires 'new'")

  this.clear()

  if (set) {
    if ((set instanceof PseudoMap) ||
        (typeof Map === 'function' && set instanceof Map))
      set.forEach(function (value, key) {
        this.set(key, value)
      }, this)
    else if (Array.isArray(set))
      set.forEach(function (kv) {
        this.set(kv[0], kv[1])
      }, this)
    else
      throw new TypeError('invalid argument')
  }
}

PseudoMap.prototype.forEach = function (fn, thisp) {
  thisp = thisp || this
  Object.keys(this._data).forEach(function (k) {
    if (k !== 'size')
      fn.call(thisp, this._data[k].value, this._data[k].key)
  }, this)
}

PseudoMap.prototype.has = function (k) {
  return !!find(this._data, k)
}

PseudoMap.prototype.get = function (k) {
  var res = find(this._data, k)
  return res && res.value
}

PseudoMap.prototype.set = function (k, v) {
  set(this._data, k, v)
}

PseudoMap.prototype.delete = function (k) {
  var res = find(this._data, k)
  if (res) {
    delete this._data[res._index]
    this._data.size--
  }
}

PseudoMap.prototype.clear = function () {
  var data = Object.create(null)
  data.size = 0

  Object.defineProperty(this, '_data', {
    value: data,
    enumerable: false,
    configurable: true,
    writable: false
  })
}

Object.defineProperty(PseudoMap.prototype, 'size', {
  get: function () {
    return this._data.size
  },
  set: function (n) {},
  enumerable: true,
  configurable: true
})

PseudoMap.prototype.values =
PseudoMap.prototype.keys =
PseudoMap.prototype.entries = function () {
  throw new Error('iterators are not implemented in this version')
}

// Either identical, or both NaN
function same (a, b) {
  return a === b || a !== a && b !== b
}

function Entry (k, v, i) {
  this.key = k
  this.value = v
  this._index = i
}

function find (data, k) {
  for (var i = 0, s = '_' + k, key = s;
       hasOwnProperty.call(data, key);
       key = s + i++) {
    if (same(data[key].key, k))
      return data[key]
  }
}

function set (data, k, v) {
  for (var i = 0, s = '_' + k, key = s;
       hasOwnProperty.call(data, key);
       key = s + i++) {
    if (same(data[key].key, k)) {
      data[key].value = v
      return
    }
  }
  data.size++
  data[key] = new Entry(k, v, key)
}

},{}],45:[function(require,module,exports){
'use strict'

var _ = window._;
var paramValueSplitter = require('./paramValueSplitter');

var querySets = {};

function prepareQuerySetParamConfigs(querySet) {
    querySet.order = querySet.order || {};
    querySet.order.start =  querySet.order.start || [];
    querySet.order.end =    querySet.order.end || [];
    querySet.known = querySet.known || {};
    querySet.dynamic = querySet.dynamic || {};
    querySet.types = querySet.types || {};
    prepareQuerySetParamMatching(querySet);
    prepareQuerySetParamSuffix(querySet);
    prepareQuerySetGroupList(querySet);
    prepareQuerySetQueryParamMetadata(querySet);
    prepareQuerySetTypes(querySet);
}

function prepareQuerySetParamMatching(querySet){
    /** The config's querySets section has "known" and "dynamic" parameter names that map to types.
     * This method will map a keyRegex to each of these params so that they can later be matched. **/
    _.each(["known", "dynamic"], function(paramKeySet) {
        _.each(querySet[paramKeySet], function(paramConfig, paramKey){
            // Regex for this param key begins matching at the beginning of the param key name
            var keyRegex = "^";

            if(paramKeySet === "known") {
                keyRegex += "(" + getEscapedRegExpStr(paramKey) + ")";
                // Add regex for multiplicity
                if (paramConfig.multiplicity && paramConfig.multiplicity > 0) {
                    var multiplicityDigits = paramConfig.multiplicity.toString().length;
                    keyRegex += "([0-9]{0," + getEscapedRegExpStr(multiplicityDigits.toString()) +"})?";
                } else {
                    keyRegex += "()";  // no multiplicity but add a capturing group so that indices are a constant for known params
                }
            }
            else if(paramKeySet === "dynamic") {
                var format = paramValueSplitter.parseParamFormat(paramKey);
                var dynamicKeyRegex = getEscapedRegExpStr(format.prefix) + format.str.substr(format.prefix.length);
                format.componentNames.forEach(function(componentName){
                    dynamicKeyRegex = dynamicKeyRegex.replace('{' + getEscapedRegExpStr(componentName) + '}', '([^' + getEscapedRegExpStr(format.delimiter) + ']*?)');
                });
                format.componentNames.sort();
                paramConfig.dynamicFormat = format;
                keyRegex += dynamicKeyRegex;
            }

            // Add regex for suffix
            var typeConfig = getTypeConfig(querySet, paramConfig, paramConfig.type);
            if (typeConfig && typeConfig.suffix){
                var keySuffix = typeConfig.suffix.keySuffix;
                if (keySuffix) {
                    keyRegex += "(" + getEscapedRegExpStr(keySuffix) + ")?";
                } else {
                    keyRegex += "()";
                }
            } else {
                keyRegex += "()";
            }
            keyRegex += "$";
            
            paramConfig.keyRegex = new RegExp(keyRegex);
        });
    });

    if (querySet.dynamic) {
        querySet.dynamicKeys = _.sortBy(Object.keys(querySet.dynamic), function(dynamicKey){
            return querySet.dynamic[dynamicKey].dynamicFormat.componentNames.length;
        });
    }
}

function getEscapedRegExpStr(string) {
    return string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
}

function prepareQuerySetParamSuffix(querySet) {
    _.each(["known", "dynamic"], function(paramKeySet) {
        _.each(querySet[paramKeySet], function(paramConfig, paramKey) {
            var typeConfig = getTypeConfig(querySet, paramConfig, paramConfig.type);
            if (typeConfig && typeConfig.suffix) {
                paramConfig.suffix = typeConfig.suffix;
            }
        });
    });
}

function prepareQuerySetGroupList(querySet) {
    var allParamConfigsObj = _.extend({}, querySet.known, querySet.dynamic);
    var arrayOfAllParamConfigs = _.sortBy(allParamConfigsObj, function(config){ return config.group; });
    querySet.groups = _.without(_.uniq(_.map(arrayOfAllParamConfigs, 'group')), null, undefined);
}

function prepareQuerySetQueryParamMetadata(querySet) {
    var queryParamConfigs = {};
    _.each(querySet.known, function(paramValue, paramKey){
        queryParamConfigs[paramKey] = getParamMetadata(paramKey, querySet);
    });
    _.each(querySet.dynamic, function(paramValue, paramKey){
        queryParamConfigs[paramKey] = getParamMetadata(paramKey, querySet);
    });
    var setTypeMetadata = function (paramValue, paramKey){
        if (_.has(paramValue, "modelName"))
            queryParamConfigs[paramKey] = {
                modelName : paramValue.modelName
            };
        if (_.has(paramValue, "types"))
            _.each(paramValue.types, setTypeMetadata);
    };
    _.each(querySet.types, setTypeMetadata);

    querySet.paramMetadata = queryParamConfigs;
}

function normalizeTypeProperty(typeConfig){
    var types = typeConfig.type || [];
    types = !_.isArray(types) ? [types] : types;
    if (typeConfig.format != null && !_.includes(types, "format")) {
        types.splice(0, 0, "format");
    }
    typeConfig.type = types;
    
    // Recursively normalize all child types
    if (typeConfig.types) {
        _.each(typeConfig.types, normalizeTypeProperty);
    }
}

function prepareQuerySetTypes(querySet) {
    _.each(querySet.known, normalizeTypeProperty);
    _.each(querySet.dynamic, normalizeTypeProperty);
    _.each(querySet.types, normalizeTypeProperty);
}

function getParamMetadata(paramKey, querySet) {
    // Match the parameter key against all known and dynamic parameter key regex's
    var paramMatch = getParamRegexMatch(paramKey, querySet);
    if (paramMatch == null) return {found: false};
    var output = {
        found: true,
        configParamKey: paramMatch.configParamKey,
        modelName: paramMatch.paramConfig.modelName != null 
            ? paramMatch.paramConfig.modelName 
            : paramMatch.configParamKey,
        config: paramMatch.paramConfig,
        configParamType: paramMatch.paramType
    };
    return output;
}

var getParamRegexMatch = function (paramKey, querySet) {
    var paramRegexMatch = null;
    var configParamKey = _.findKey(querySet.known, function (loopParamConfig, loopParamKey) {
        return paramKey.match(loopParamConfig.keyRegex) != null;
    });
    if (configParamKey) {
        paramRegexMatch = paramKey.match(querySet.known[configParamKey].keyRegex);
        if (paramRegexMatch == null) return null;
        var paramConfig = null;
        paramConfig = querySet.known[configParamKey];
        return {
            paramType: 'known',
            configParamKey: configParamKey,
            paramConfig: paramConfig,
            paramIndex: paramRegexMatch.length >= 3 ? paramRegexMatch[2] : null,
            paramSuffix: paramRegexMatch.length >= 4 ? paramRegexMatch[3] : null,
        };
        
    }
    if (querySet.dynamic) {
        //if paramKey did not match all known paramConfig regex, check through dynamic paramConfig regex's
        configParamKey = _.findKey(querySet.dynamic, function (loopParamConfig, loopParamKey) {
            return paramKey.match(loopParamConfig.keyRegex) != null;
        });
        if (!configParamKey) return null;
        paramRegexMatch = paramKey.match(querySet.dynamic[configParamKey].keyRegex);
        var paramConfig = null;
        if (paramRegexMatch == null) return null;
        paramConfig = querySet.dynamic[configParamKey];
        
        var dynamicModelName = getDynamicModelName(paramKey, paramConfig);
        var knownConfigKey = getKnownConfigKeyMatchingModelName(dynamicModelName, querySet);
        if (knownConfigKey) {
            return getParamRegexMatch(knownConfigKey, querySet);
        }
        
        return {
            paramType: 'dynamic',
            configParamKey: configParamKey,
            paramConfig: paramConfig,
            paramIndex: null,
            paramSuffix: paramRegexMatch[paramRegexMatch.length - 1],
            modelName: dynamicModelName
        };
    }
    return null;
};

function getDynamicModelName(paramKey, config){
    var dynamicFormat = config.dynamicFormat;
    var dynamicKeysObj = paramValueSplitter.parseParamValues(paramKey, dynamicFormat);
    var dynamicModelName = config.modelNameFormat || '{' + dynamicFormat.componentNames.join('}{') + '}';
    dynamicFormat.componentNames.forEach(function(componentName){
        dynamicModelName = dynamicModelName.replace('{' + componentName + '}', dynamicKeysObj[componentName]);
    });
    return dynamicModelName;
}

function getKnownConfigKeyMatchingModelName(modelName, querySet) {
    return _.findKey(querySet.known, function(paramConfig, paramKey){
        if (_.has(paramConfig, "modelName")){
            return (paramConfig.modelName === modelName);
        }
        return (paramKey === modelName);
    });
}

function getTypeConfig(querySet, typeConfig, typeKey) {
    // Try to pull the config out of typeConfig.types
    var config = _.get(typeConfig, 'types.' + typeKey);
    if (config) return config;

    // Try to pull the config out of querySet.types
    config = _.get(querySet, 'types.' + typeKey);
    if (config) return config;

    // Try to pull the config out of the configuration's topLevelTypes list
    return _.get(querySets, 'topLevelTypes.known.' + typeKey, null);
}

function addConfig(config){
    var newQuerySets = _.cloneDeep(config.querySets || {});

    // Add top level types to a special top-level parameter queryset
    newQuerySets.topLevelTypes = {
        order: { start: [], end: [] },
        known: _.has(config, "types") ? _.cloneDeep(config.types) : {},
        dynamic: {},
        types: {}
    };

    // Set up param config metadata in each querySet
    _.each(newQuerySets, function (querySet){
        prepareQuerySetParamConfigs(querySet);
    });

    //the new and old querysets should be combined, with the new query sets taking precedence
    var combinedQuerySets = _.defaultsDeep(newQuerySets, querySets);
    querySets = combinedQuerySets;
};

module.exports = {
    addConfig: addConfig,
    clearQuerySets: function () { querySets = {} },
    getTypeConfig: getTypeConfig,
    getQuerySetConfig: function (querySetName) { return querySets[querySetName]; },
    getParamRegexMatch: getParamRegexMatch
};
},{"./paramValueSplitter":49}],46:[function(require,module,exports){
'use strict'

var _ = window._;
var paramValueSplitter = require('./paramValueSplitter');
var configProvider = require('./configProvider');
var normalizers = require('./normalizers');

var querySetDefaultsMap = {};

function getDefaultInstancedTopLevelValue(paramConfig, querySet) {
    if (!paramConfig.multiplicity) return null;
    if (paramConfig.default) return paramConfig.default;
    var output = getDefaultValue(querySet, paramConfig);
    if (paramConfig.suffix && paramConfig.suffix.type) {
        var typeConfig = configProvider.getTypeConfig(querySet, paramConfig, paramConfig.type);
        var suffixTypeConfig = configProvider.getTypeConfig(querySet, typeConfig, paramConfig.suffix.type);
        var suffixObj = getDefaultValue(querySet, suffixTypeConfig);
        if (_.isObject(suffixObj)) {
            _.assign(output, suffixObj);
        } else {
            var suffixName = paramConfig.suffix.type;
            if (_.has(querySet.paramMetadata, paramConfig.suffix.type))
                suffixName = querySet.paramMetadata[paramConfig.suffix.type].modelName;
            output[suffixName] = suffixObj;
        }
    }
    return output;
}

function setDefaultProperties(obj, config, isContainer) {
    if (config.properties && (config.multiplicity == null || isContainer === true)) {
        Object.keys(config.properties).forEach(function(propertyName){
            obj[propertyName] = _.cloneDeep(config.properties[propertyName]);
        });
    }
};

function getDefaultTopLevelValue(paramConfig, querySet) {
    var output = null;
    if (paramConfig.multiplicity) {
        output = {instances: []};
        setDefaultProperties(output, paramConfig, true);
        return output;
    }
    var output = getDefaultValue(querySet, paramConfig);
    if (paramConfig.suffix && paramConfig.suffix.type) {
        var typeConfig = configProvider.getTypeConfig(querySet, paramConfig, paramConfig.type);
        var suffixTypeConfig = configProvider.getTypeConfig(querySet, typeConfig, paramConfig.suffix.type);
        var suffixObj = getDefaultValue(querySet, suffixTypeConfig);
        output = output || {};
        if (_.isObject(suffixObj)) {
            _.assign(output, suffixObj);
        } else {
            var suffixName = paramConfig.suffix.type;
            if (_.has(querySet.paramMetadata, paramConfig.suffix.type))
                suffixName = querySet.paramMetadata[paramConfig.suffix.type].modelName;
            output[suffixName] = suffixObj;
        }
    }
    return output;
}

function getDefaultValue(querySet, typeConfig) {
    //TODO: This may become public someday when we start making search forms on the client.
    // Search Form could use this to, for example, build a default event instance (since it
    // is an empty array by default)

    var typeKey = ((typeConfig == null) ? ["default"] : typeConfig.type)[0];
    var normalizer = normalizers[typeKey];

    if (normalizer != null) {
        var output = normalizer.getDefault(typeConfig);
        setDefaultProperties(output, typeConfig, false);
        return output;
    }

    var listInfo = normalizers.list.getListInfo(typeKey);
    if (listInfo.isListType) {
        return [];
    }

    if (_.has(querySet.types, typeConfig.type) || _.has(normalizers, typeConfig.type)) {
        output = getDefaultValue(querySet, configProvider.getTypeConfig(querySet, typeConfig, typeConfig.type));
        setDefaultProperties(output, typeConfig, false);
        return output;
    }

    if (_.has(typeConfig, "format")) {
        var paramFormatObj = paramValueSplitter.parseParamFormat(typeConfig.format);
        var output = {};
        _.each(paramFormatObj.componentNames, function (componentName) {
            normalizer = normalizers[componentName];
            if (normalizer != null) {
                output[componentName] = normalizer.getDefault(typeConfig);
            } else {
                var componentTypeConfig = configProvider.getTypeConfig(querySet, typeConfig, componentName);
                var paramName = _.has(querySet.paramMetadata, componentName) ? querySet.paramMetadata[componentName].modelName : componentName;
                output[paramName] = getDefaultValue(querySet, componentTypeConfig);
            }
        });
        setDefaultProperties(output, typeConfig, false);
        return output;
    }
    return null;
}

function getDefaultDataModel(querySet) {
    var model = {};
    _.each(querySet.known, function (paramConfig, paramKey) {
        var container;
        if (paramConfig.group) {
            model[paramConfig.group] = model[paramConfig.group] || {};
            container = model[paramConfig.group];
        }
        else
            container = model;

        var modelName = querySet.paramMetadata[paramKey].modelName;
        container[modelName] = getDefaultTopLevelValue(paramConfig, querySet);
    });
    return model;
};

function getDefaultInstancedDataModels(querySet) {
    var model = {};
    _.each(querySet.known, function (paramConfig, paramKey) {
        var value = getDefaultInstancedTopLevelValue(paramConfig, querySet);
        var paramName = querySet.paramMetadata[paramKey].modelName;
        model[paramName] = value;
    });
    return model;
};

function getDefaultDynamicDataModels(querySet) {
    // The dynamic keys are the alphatical ordering of the dynamic key names separated by pipes.
    // So a dynamic param of "e-{key2}-{key1}" will have a key of "key1-key2" in dynamicDefaults.
    var dynamicDefaults = {};
    _.each(querySet.dynamic, function (paramConfig, paramKey) {
        var value = getDefaultTopLevelValue(paramConfig, querySet);
        if (_.has(value, "instances"))
            value = getDefaultInstancedTopLevelValue(paramConfig, querySet);
        if (value) {
            var dynamicKey = paramConfig.dynamicFormat.componentNames.join('-');
            dynamicDefaults[dynamicKey] = value;
        }
    });
    return dynamicDefaults;
};

function getEmptyDefaults() {
    return { model: {}, instanceModels: {}, dynamicModels: {} };
}

function getDefaults(querySetName){
    if (querySetName == null) return getEmptyDefaults();
    
    var defaults = querySetDefaultsMap[querySetName];
    if (defaults == null) {
        var querySet = configProvider.getQuerySetConfig(querySetName);
        if (querySet == null) return getEmptyDefaults();
        defaults = {
            model: getDefaultDataModel(querySet),
            instanceModels: getDefaultInstancedDataModels(querySet),
            dynamicModels: getDefaultDynamicDataModels(querySet)
        }
        querySetDefaultsMap[querySetName] = defaults;
    }
    return _.cloneDeep(defaults);
}

module.exports = {
    getDefaultDataModel: function(querySetName){
        var defaults = getDefaults(querySetName);
        return defaults.model;
    },
    getDefaultInstancedDataModels: function(querySetName) {
        var defaults = getDefaults(querySetName);
        return defaults.instanceModels;
    },
    getDefaultDynamicDataModels: function(querySetName) {
        var defaults = getDefaults(querySetName);
        return defaults.dynamicModels;
    },
};
},{"./configProvider":45,"./normalizers":48,"./paramValueSplitter":49}],47:[function(require,module,exports){
'use strict'

var configProvider = require('./configProvider');
var defaultModelValueProvider = require('./defaultModelValueProvider');
var _ = window._;

function removeDefaultValues(obj, defaultObj) {
    if (_.isArray(obj)) return obj;
    if (!_.isObject(obj)) return obj === defaultObj ? null : obj;
    var output = {};
    _.each(obj, function (value, key, object) {
        if (_.has(defaultObj, key)) {
            var defaultValue = defaultObj[key];
            if (value == null && defaultValue != null) {
                output[key] = value;
            } else if (value != null && defaultValue == null) {
                output[key] = value;
            } else if (key === "instances") {
                output[key] = value;
            } else if (_.isDate(value)) {
                if (value.getTime() !== defaultValue.getTime()) {
                    output[key] = value;
                }
            } else if (_.isObject(value)) {
                var valueWithoutDefault = removeDefaultValues(value, defaultValue);
                if (valueWithoutDefault != null && _.keys(valueWithoutDefault).length !== 0) {
                    output[key] = valueWithoutDefault;
                }
            } else if (value !== defaultValue) {
                output[key] = value;
            }
        } else {
            output[key] = value;
        }
    });
    return _.keys(output).length === 0 ? null : output;
}

function removeDefaultDynamicValues(model, querySet, defaultDynamicModels) {
    var output = {};
    _.each(model, function(paramObj, paramName){
        // recurse for groups
        if (_.includes(querySet.groups, paramName)) {
            var value = removeDefaultDynamicValues(paramObj, querySet, defaultDynamicModels);
            if (value && _.keys(value).length > 0)
                output[paramName] = value;
            return;
        }
        var dynamicParam = _.findKey(querySet.paramMetadata, function (metadataObj, metadataName){
            if (!metadataObj.config.dynamicFormat) return false;
            for (var i = 0; i < metadataObj.config.dynamicFormat.componentNames.length; ++i) {
                if (!_.has(paramObj, metadataObj.config.dynamicFormat.componentNames[i])) {
                    return false;
                }
            }
            return true;
        });
        if (dynamicParam){
            var typeConfig = querySet.dynamic[dynamicParam];
            var dynamicKey = typeConfig.dynamicFormat.componentNames.join('-');
            var hasMultiplicity = typeConfig.multiplicity != null;
            var valueWithoutDefault = null;
            if (hasMultiplicity) {
                var defaultInstanceModels = {};
                var container = {};
                container[paramName] = paramObj;
                defaultInstanceModels[paramName] = defaultDynamicModels[dynamicKey];
                container = removeDefaultInstancedValues(container, querySet, defaultInstanceModels);
                valueWithoutDefault = container[paramName];
            } else {
                valueWithoutDefault = removeDefaultValues(paramObj, defaultDynamicModels[dynamicKey]);
            }
            
            if (valueWithoutDefault && Object.keys(valueWithoutDefault).length > typeConfig.dynamicFormat.componentNames.length) {
                output[paramName] = valueWithoutDefault;
            }
        }
        else {
            output[paramName] = paramObj;
        }
    });
    return output;
}

function removeDefaultInstancedValues(model, querySet, defaultInstanceModels) {
    var output = {};
    _.each(model, function(paramObj, paramName){
        if (_.includes(querySet.groups, paramName)) {
            var value = removeDefaultInstancedValues(paramObj, querySet, defaultInstanceModels);
            if (value && _.keys(value).length > 0)
                output[paramName] = value;
            return;
        }
        if (!_.has(paramObj,"instances") || paramObj.instances.length === 0) {
            output[paramName] = paramObj;
            return;
        }
        output[paramName] = _.cloneDeep(paramObj);
        output[paramName].instances = [];
        _.forEach(paramObj.instances, function(instance, index){
            var valueWithoutDefault = removeDefaultValues(instance, defaultInstanceModels[paramName])
            if (valueWithoutDefault != null) {
                output[paramName].instances.push(valueWithoutDefault);
            }
        });
        if (output[paramName].instances.length == 0) {
            delete output[paramName];
        }
    });
    return output;
}

module.exports = {
    removeDefaults: function(model, querySetName) {
        var querySet = configProvider.getQuerySetConfig(querySetName);
        if (querySet == null) return {};
        
        var defaultModel = defaultModelValueProvider.getDefaultDataModel(querySetName) || {};
        var defaultInstanceModels = defaultModelValueProvider.getDefaultInstancedDataModels(querySetName) || {};
        var defaultDynamicModels = defaultModelValueProvider.getDefaultDynamicDataModels(querySetName) || {};
        
        model = removeDefaultValues(model, defaultModel);
        model = removeDefaultInstancedValues(model, querySet, defaultInstanceModels);
        model = removeDefaultDynamicValues(model, querySet, defaultDynamicModels);
        
        return model;
    }
};
},{"./configProvider":45,"./defaultModelValueProvider":46}],48:[function(require,module,exports){
'use strict'

var normalizers = {};

function addNormalizer(normalizerKey, normalizer) {
    normalizers[normalizerKey] = normalizer;
}

addNormalizer("int", require('./../normalizers/intNormalizer'));
addNormalizer("string", require('./../normalizers/stringNormalizer'));
addNormalizer("escapedString", require('./../normalizers/escapedStringNormalizer'));
addNormalizer("flagsOrBool", require('./../normalizers/flagsOrBoolNormalizer'));
addNormalizer("flags", require('./../normalizers/flagsNormalizer'));
addNormalizer("bool", require('./../normalizers/booleanNumberNormalizer'));
addNormalizer("list", require('./../normalizers/listNormalizer'));
addNormalizer("enum", require('./../normalizers/enumNormalizer'));
addNormalizer("default", require('./../normalizers/defaultNormalizer'));

module.exports = normalizers;
},{"./../normalizers/booleanNumberNormalizer":52,"./../normalizers/defaultNormalizer":53,"./../normalizers/enumNormalizer":54,"./../normalizers/escapedStringNormalizer":55,"./../normalizers/flagsNormalizer":56,"./../normalizers/flagsOrBoolNormalizer":57,"./../normalizers/intNormalizer":58,"./../normalizers/listNormalizer":59,"./../normalizers/stringNormalizer":60}],49:[function(require,module,exports){
'use strict'

var _ = window._;

var formatRegex = /[^a-zA-Z0-9{}]/;
var componentRegex = /\{([^}]+)\}/;

module.exports = {
    parseParamFormat: function(format) {
        var output = {
            isValid: true,
            components: [],
            componentNames: [],
            delimiter: '',
            escapedChar: '~',
            prefix: ''
        };
        var trimmedFormat = format;
        var firstComponentIndex = format.indexOf('{');
        if (firstComponentIndex > 0) {
            output.prefix = format.substr(0, firstComponentIndex);
            trimmedFormat = format.substr(firstComponentIndex);
        }
        var delimiterMatch = trimmedFormat.match(formatRegex);
        if (delimiterMatch && delimiterMatch.length > 0) {
            output.str = format;
            output.delimiter = delimiterMatch[0];
            output.components = trimmedFormat.split(output.delimiter);
            output.components = _.map(output.components, function (value){
                if (value === '{}') {
                    output.isValid = false;
                }
                return value[0] === '{' && value[value.length-1] === '}'
                    ? value.substr(1,value.length-2)
                    : '';
            });
            output.componentNames = _.filter(output.components, function (value){
                return value !== ''
            });
            output.isValid = output.isValid && output.componentNames.length > 0;
            if (output.isValid) {
                output.isValid = !_.some(output.componentNames, function (value){
                    return value.indexOf('{') > -1
                        || value.indexOf('}') > -1;
                });
            }
        } else {
            var singleMatch = trimmedFormat.match(componentRegex);
            if (singleMatch) {
                output.str = format;
                output.components.push(singleMatch[1]);
                output.componentNames.push(singleMatch[1]);
            } else {
                output.isValid = false;
            }
        }

        return output;
    },
    parseParamValues: function(str, format){
        var list = [];
        // Remove the prefix in front of str.  If the prefix isn't present at the front, then make the entire str fail to match.
        str = format.prefix.length > 0 && str.indexOf(format.prefix) !== 0 ? '' : str.substr(format.prefix.length);
        
        if (format.delimiter == null || format.delimiter.length === 0) {
            list.push(str);
        } else {
            // Split by the escaped escape character.  If the escaped escape character is not used there will only
            // be a single element.  Otherwise there will be multiple that will need to be combined later adding back in
            // the escape character between.
            // e.g. Split on the escaped escape char like ".." where "." is the escape char
            var list = str.split(format.escapedChar + format.escapedChar);
            // Separate out the components by the delimiter
            list =  _.map(list, function (value) {
                // split it by the escaped delimiter next
                return value.split(format.escapedChar + format.delimiter);
            });
            // Recombine the component values that were separated by the escaped escape character
            list = _.reduce(list, function(prev, curr) {
                var firstElementOfCurrentArr = curr.splice(0, 1)[0];
                // Add delimiter back into the param value
                prev[prev.length - 1] = prev[prev.length - 1] + format.escapedChar + firstElementOfCurrentArr;
                return prev.concat(curr);
            });
            // Separate out the components by the delimiter
            list =  _.map(list, function (value) {
                return value.split(format.delimiter);
            });
            // Recombine the component values that were separated by the escaped delimiter
            list = _.reduce(list, function(prev, curr) {
                var firstElementOfCurrentArr = curr.splice(0, 1)[0];
                // Add delimiter back into the param value
                prev[prev.length - 1] = prev[prev.length - 1] + format.delimiter + firstElementOfCurrentArr;
                return prev.concat(curr);
            });
        }
        for (var i = list.length; i < format.componentNames.length; ++i) {
            list.push('');
        }
        var mappedObj = _.zipObject(format.components, list);
        delete mappedObj[""];
        return mappedObj;
    },
    compose: function(obj, format){
        var result = format.str;
        _.each(format.componentNames, function(componentName){
            if(_.has(obj,componentName) && obj[componentName] != null) {
                var delimiterRegex = new RegExp("[" + format.delimiter + "]", 'g');
                var encodedValue = obj[componentName].replace(format.escapedChar, format.escapedChar + format.escapedChar);
                encodedValue = encodedValue.replace(delimiterRegex, format.escapedChar + format.delimiter);
                result = result.replace("{" + componentName + "}", encodedValue);
            }
            else {
                result = result.replace("{" + componentName + "}", "");
            }
        });

        var trailingDelimiterRegex = new RegExp("(["+format.delimiter+"]*)$");
        result = result.replace(trailingDelimiterRegex, "");

        // Trailing delimiters were deleted, but if the last component had a value ending in an escaped delimiter,
        // this should be added back to the result
        var lastComponentWithValueIndex = _.findLastIndex(format.componentNames, function (component){
            return _.has(obj,component) && obj[component] !== null && obj[component].length>0;
        });
        if (lastComponentWithValueIndex >= 0) {
            var lastComponentWithValue = format.componentNames[lastComponentWithValueIndex];
            lastComponentWithValue = obj[lastComponentWithValue];
            if (lastComponentWithValue[lastComponentWithValue.length - 1] === format.delimiter)
                result += format.delimiter;
        }

        return result;
    }
};
},{}],50:[function(require,module,exports){
'use strict'

var paramValueSplitter = require('./paramValueSplitter');
var configProvider = require('./configProvider');
var defaultValueFilter = require('./defaultValueFilter');
var normalizers = require('./normalizers');
var alphaNumSort = require('alphanum-sort');
var _ = window._;

var possibleUnnecessaryPercentEncodingRegex = /%[234][0-9a-z]/gi;
var apostropheRegex = /'/g;
var unnecessaryEncodingMap = {
	"%20": '+',
	"%24": '$',
	"%2C": ',',
	"%2F": '/',
	"%3A": ':',
	"%3B": ';',
	"%3F": '?',
	"%40": '@'
};

function encodeQueryComponent(str) {
    // Note: Chrome and Internet Explorer will convert apostrophes to %27, so to prevent
    //       canonicalizer redirection wars with the browser we will allow this to be 
    //       encoded even though by the URI spec it doesn't need to be.
    return encodeURIComponent(str)
        .replace(possibleUnnecessaryPercentEncodingRegex, function (str) {
            return unnecessaryEncodingMap[str] || str;
        }).replace(apostropheRegex, "%27");
}

function fromObjectToQueryString(queryStringObj, keyOrder) {
    keyOrder = keyOrder || _.keys(queryStringObj);
    keyOrder = _.filter(keyOrder, function(key){
        return queryStringObj[key] != null;
    });
    return _.map(keyOrder, function (key) {
        return encodeQueryComponent(key) + '=' + encodeQueryComponent(queryStringObj[key]);
    }).join('&');
}

var keyWithoutTrailingNumberRegex = new RegExp(/(.+?)\d*$/);
function getOrderedKeys(paramModel, querySet, otherParams) {
    var knownStartOrderKeys = querySet.order.start;
    var knownEndOrderKeys = querySet.order.end;
    var unknownParams = _.cloneDeep(otherParams || []);
    var orderedKeys = [];
    var unsortedParams = _.clone(paramModel);

    _.each(knownStartOrderKeys, function (key) {
        if (_.has(unsortedParams, key)) {
            orderedKeys.push(key);
            delete unsortedParams[key];
            delete unknownParams[key];
        }
    });

    var unsortedParamKeys = alphaNumSort(_.keys(unsortedParams));

    _.each(unsortedParamKeys, function (key) {
        var keyWithoutTrailingNumbers = key.replace(keyWithoutTrailingNumberRegex, "$1");
        var isKnownEndOrderKey = _.includes(knownEndOrderKeys, keyWithoutTrailingNumbers);
        if (!isKnownEndOrderKey) {
            orderedKeys.push(key);
            delete unsortedParams[key];
            delete unknownParams[key];
        }
    });

    unsortedParamKeys = alphaNumSort(_.keys(unsortedParams));
    _.each(knownEndOrderKeys, function (key) {
        var matchingKeys = _.filter(unsortedParamKeys, function(unsortedKey){
            var keyWithoutTrailingNumbers = unsortedKey.replace(keyWithoutTrailingNumberRegex, "$1");
            return keyWithoutTrailingNumbers === key;
        });
        matchingKeys.forEach(function(matchingEndKey){
            orderedKeys.push(matchingEndKey);
            delete unsortedParams[matchingEndKey];
            delete unknownParams[matchingEndKey];
            _.remove(unsortedParamKeys, function(unsortedParamKey) {
                return unsortedParamKey === matchingEndKey;
            });
        });
    });

    var unknownParamKeys = alphaNumSort(_.keys(unknownParams));
    _.each(unknownParamKeys, function (key) {
        orderedKeys.push(key);
    });

    return orderedKeys;
}

function composeTopLevelValue(queryStringObj, paramName, modelValue, config, querySet, context) {
    var composedValue = composeValues(modelValue, config, querySet, context);
    if (composedValue == null || composedValue === "") return;
    queryStringObj[paramName] = composedValue;
    if (config.suffix) {
        var typeConfig = configProvider.getTypeConfig(querySet, config, config.type);
        var suffixConfig = configProvider.getTypeConfig(querySet, typeConfig, typeConfig.suffix.type);
        var suffixParamName = paramName + config.suffix.keySuffix;
        var suffixModel = suffixConfig.format ? modelValue : modelValue[config.suffix.type];
        // suffixModel is null if the suffix had a default value that was removed prior to this
        if (suffixModel != null) {
            composedValue = composeValues(suffixModel, suffixConfig, querySet, context);
            if (composedValue != null && composedValue != "") {
                queryStringObj[suffixParamName] = composedValue;
            }
        }
    }
}

function composeTopLevelValues(paramModels, queryStringObj, querySet, context) {
    _.each(paramModels, function (modelValue, modelKey) {
        if (_.includes(querySet.groups, modelKey)) {
            composeTopLevelValues(modelValue, queryStringObj, querySet, context);
        } else {
            var configKey = _.findKey(querySet.known, function (paramConfig, paramKey) {
                if (_.has(paramConfig, "modelName")) {
                    return (paramConfig.modelName === modelKey);
                }
                else {
                    return (paramKey === modelKey);
                }
            });
            var config = querySet.known[configKey];
            var paramName = configKey;
            if (!config && _.isObject(modelValue)) {
                var mostNonEmptyMatches = 0;
                _.forEach(querySet.dynamicKeys, function(loopDynamicConfigKey){
                    var dynamicConfig = querySet.dynamic[loopDynamicConfigKey];
                    var nonEmptyMatches = 0;
                    _.each(dynamicConfig.dynamicFormat.componentNames, function(dynamicComponentName) {
                        if (!_.has(modelValue, dynamicComponentName)) {
                            // skip this format since all components must be present in the model
                            nonEmptyMatches = 0;
                            return false;
                        } else if (modelValue[dynamicComponentName].length > 0) {
                            nonEmptyMatches++;
                        }
                    });
                    if (nonEmptyMatches > mostNonEmptyMatches) {
                        config = dynamicConfig;
                        mostNonEmptyMatches = nonEmptyMatches;
                    }
                });

                if (config) {
                    paramName = paramValueSplitter.compose(modelValue, config.dynamicFormat);
                }
            }
            if (config) {
                if (_.has(config, 'multiplicity')) {
                    _.each(modelValue.instances, function (instance, instanceIndex) {
                        var indexStr = instanceIndex == 0 ? '' : (instanceIndex + 1).toString();
                        var paramNameWithIndex = paramName + indexStr;
                        composeTopLevelValue(queryStringObj, paramNameWithIndex, instance, config, querySet, context);
                    });
                } else {
                    composeTopLevelValue(queryStringObj, paramName, modelValue, config, querySet, context);
                }
            }
            else {
                //TODO: throw an error here, there is no parameter with the name in variable 'modelKey'
            }
        }
    });
};

function composeValues(value, typeConfig, querySet, context) {
    if (value == null || typeConfig == null) return '';

    var loopValue = value;
    var types = _.cloneDeep(typeConfig.type).reverse();
    _.each(types, function (typeStr) {
        var normalizer = normalizers[typeStr];
        if (normalizer != null) {
            loopValue = normalizer.compose(loopValue, typeConfig, context);
            return;
        }
        if (normalizers.list.isListType(typeStr)) {
            loopValue = composeListValues(loopValue, typeStr, typeConfig, querySet, context);
            return;
        }
        var nestedTypeConfig = configProvider.getTypeConfig(querySet, typeConfig, typeStr);
        if (nestedTypeConfig != null) {
            loopValue = composeValues(loopValue, nestedTypeConfig, querySet, context);
            return;
        }
        if (typeStr == "format") {
            var formatObj = {};
            var paramFormatObj = paramValueSplitter.parseParamFormat(typeConfig.format);

            // In order to parse the resulting data object, we need it to follow a format similar to the parameter list
            _.each(paramFormatObj.componentNames, function (componentName) {
                if (!_.has(loopValue, componentName)) return;
                var componentTypeConfig = configProvider.getTypeConfig(querySet, typeConfig, componentName);
                formatObj[componentName] = composeValues(loopValue[componentName], componentTypeConfig, querySet, context);
            });

            loopValue = paramValueSplitter.compose(formatObj, paramFormatObj);
            return;
        }

        // TODO: log an error or throw an exception
        // do nothing for now.
        return;
    });

    return loopValue;
};

function composeListValues(list, typeStr, typeConfig, querySet, context) {
    var strList = [];
    var listInfo = normalizers.list.getListInfo(typeStr);
    var itemTypeStr = listInfo.listType;
    if (normalizers[itemTypeStr] != null) {
        _.each(list, function (item) {
            strList.push(normalizers[itemTypeStr].compose(item, typeConfig, context));
        });
    } else {
        var itemTypeConfig = configProvider.getTypeConfig(querySet, typeConfig, itemTypeStr);
        _.each(list, function (item) {
            strList.push(composeValues(item, itemTypeConfig, querySet, context));
        });
    }
    return normalizers['list'].compose(strList, typeConfig, context);
};

module.exports = {
    toQueryParams: function (dataModel, querySetName, otherParams, context) {
        otherParams = otherParams || {};
        var queryStringObj = {};

        if (querySetName == null) querySetName = 'topLevelTypes';
        var querySet = configProvider.getQuerySetConfig(querySetName);
        if (querySet == null)
            return {};

        dataModel = defaultValueFilter.removeDefaults(_.cloneDeep(dataModel), querySetName);
        composeTopLevelValues(dataModel, queryStringObj, querySet, context);
        var keyOrder = getOrderedKeys(queryStringObj, querySet, otherParams);
        if (otherParams) {
            Object.keys(otherParams).forEach(function(key){
                if (otherParams[key] != null && !queryStringObj[key]) {
                    queryStringObj[key] = otherParams[key];
                }
            });
        }
        var queryString = fromObjectToQueryString(queryStringObj, keyOrder);
        return {
            queryString: queryString,
            params: queryStringObj,
            keyOrder: keyOrder
        };
    }
};
},{"./configProvider":45,"./defaultValueFilter":47,"./normalizers":48,"./paramValueSplitter":49,"alphanum-sort":35}],51:[function(require,module,exports){
'use strict'

var _ = window._;
var asyncEach = require('async-each');
var asyncEachSeries = require('async-each-series');
var paramValueSplitter = require('./paramValueSplitter');
var configProvider = require('./configProvider');
var normalizers = require('./normalizers');
var defaultModelValueProvider = require('./defaultModelValueProvider');
var alphaNumSort = require('alphanum-sort');

function getQueryParamConfigs(queryStringObj, querySet) {
    var querySetParamConfigs = querySet.paramMetadata;
    var paramConfigs = {};
    _.each(queryStringObj, function(paramValue, paramKey){
        var currentParamConfig = getCurrentParamConfig(paramKey, querySet);
        var paramName = currentParamConfig.paramName;

        paramConfigs[paramKey] = {};

        //Extend query set param config metadata into the new paramConfigs object
        _.assign(paramConfigs[paramKey], querySetParamConfigs[paramName]);
        _.assign(paramConfigs[paramKey], currentParamConfig);

        //Assign the value from the query string into the param config object
        paramConfigs[paramKey].paramValue = queryStringObj[paramKey];
    });
    return paramConfigs;
}

function addValueIntoModel(queryStringKey, queryParamConfig, convertedValue, container, querySetName) {
    // Dynamic types are always an object so that it can hold the dynamic keys, 
    // so if the value to assign to the dynamic property is not an object, then 
    // wrap the primitive in an object
    var isDynamicType = queryParamConfig.paramType === "dynamic";
    if (isDynamicType) {
        if (!_.isObject(convertedValue)) {
            throw new Error('Expected dynamic type (components ' + 
                queryParamConfig.config.dynamicFormat.componentNames.join(', ') + 
                ') to be an object type but instead found: ' + convertedValue);
        }
        addDefaultDynamicModel(convertedValue, queryParamConfig.config, querySetName);
    }

    var modelName = queryParamConfig.modelName;
    var hasMultiplicity = queryParamConfig.config.multiplicity != null; 
    if (hasMultiplicity) {
        container[modelName] = container[modelName] || {};
        container = container[modelName];
        container.instances = container.instances || [];
        container.instances.push(convertedValue);
        addInstanceDefaults(convertedValue, modelName, querySetName);
    } else {
        container[modelName] = convertedValue;
    }

    if (isDynamicType) {
        // Assign dynamic keys to the value they match in the parameter name.
        // i.e.  format of "e-{key1}-{key2}=..." matches parameter "e-hello-world" will map an object
        //       to have the dynamic keys like { key1: "hello", key2: "world" }
        var dynamicObj = hasMultiplicity ? container : container[modelName];
        var dynamicFormat = queryParamConfig.config.dynamicFormat;
        var dynamicKeysObj = paramValueSplitter.parseParamValues(queryStringKey, dynamicFormat);
        dynamicFormat.componentNames.forEach(function(componentName){
            dynamicObj[componentName] = dynamicKeysObj[componentName];
        });
    }
}

function getTopLevelObject(config, dataModel) {
    var container = dataModel;        
    // Create group (property like "events" or "family" that has other param properties under it)
    if (config.group != null) {
        container[config.group] = container[config.group] || {};
        container = container[config.group];
    }
    return container;
};

function parseTopLevelValues(queryStringObj, querySetName, queryParamConfigs, context, callback) {
    queryStringObj = queryStringObj || {};
    var querySet = configProvider.getQuerySetConfig(querySetName);
    var dataModel = {};
    var topLevelKeys = alphaNumSort(Object.keys(queryStringObj));
    var insertFuncByKey = {};
    asyncEach(topLevelKeys, function(queryStringKey, forEachCallback) {
        var queryStringValue = queryStringObj[queryStringKey];
        var queryParamConfig = queryParamConfigs[queryStringKey];
        if (queryParamConfig == null || queryParamConfig.found !== true) {
            return forEachCallback();
        }
        var config = queryParamConfig.config;
        if (queryParamConfig.paramSuffix != null) return forEachCallback();
        parseValue(queryStringValue, config, querySet, context, function(err, convertedValue){
            if (err) return forEachCallback(err);
            if (convertedValue == null) return forEachCallback();
            
            // Add suffix information if available
            parseTopLevelSuffixValue(convertedValue, queryStringKey, queryStringObj, querySet, queryParamConfigs, context, function(suffixErr){
                if (suffixErr) return forEachCallback(suffixErr);
                insertFuncByKey[queryStringKey] = function() {
                    var container = getTopLevelObject(config, dataModel);
                    addValueIntoModel(queryStringKey, queryParamConfig, convertedValue, container, querySetName);
                };
                forEachCallback();
            });
        });
    }, function(err) {
        if (err) {
            callback(err);
            return;
        }
        topLevelKeys.forEach(function(queryStringKey){
            if (insertFuncByKey[queryStringKey]) {
                insertFuncByKey[queryStringKey]();
            }
        });
        callback(err, dataModel);
    });
}

function parseTopLevelSuffixValue(model, queryStringKey, queryStringObj, querySet, queryParamConfigs, context, callback) {
    var queryParamConfig = queryParamConfigs[queryStringKey]; 
    var typeConfig = queryParamConfig.config;
    // Skip non objects and types that do not have a suffix
    if (!_.isObject(model) || typeConfig.suffix == null) return callback();
            
    var suffixQueryStringKey = queryStringKey + typeConfig.suffix.keySuffix;
    var suffixQueryStringValue = queryStringObj[suffixQueryStringKey];
    if (suffixQueryStringValue != null) {
        var suffixRootConfig = queryParamConfigs[suffixQueryStringKey].config;
        var suffixConfig = configProvider.getTypeConfig(querySet, queryParamConfig.paramTypeConfig, suffixRootConfig.suffix.type);
        parseValue(suffixQueryStringValue, suffixConfig, querySet, context, function(err, suffixObj){
            if (err) return callback(err);
            if (suffixObj) {
                if (_.isObject(suffixObj)) {
                    _.assign(model, suffixObj);
                } else {
                    //get the suffix name, overriding it if there's a modelName property on the config
                    var suffixName = typeConfig.suffix.type;
                    if (_.has(querySet.paramMetadata, typeConfig.suffix.type))
                        suffixName = querySet.paramMetadata[typeConfig.suffix.type].modelName;
                    model[suffixName] = suffixObj;
                }
            }
            callback();
        });
    } else {
        callback();
    }
};

function parseValueByType(valueContainer, typeStr, typeConfig, querySet, context, callback){
    var normalizer = normalizers[typeStr];
    var nestedTypeConfig = configProvider.getTypeConfig(querySet, typeConfig, typeStr);
    if (normalizer != null) {
        safeNormalizerParse(typeStr, valueContainer.value, typeConfig, context, function(err, value){
            if (err) return callback(err);
            valueContainer.value = value;
            callback();
        });
    } else if (normalizers.list.isListType(typeStr)) {
        parseListValues(valueContainer, typeStr, typeConfig, querySet, context, callback);
    } else if (nestedTypeConfig != null) {
        parseValue(valueContainer.value, nestedTypeConfig, querySet, context, function(err, value){
            if (err) return callback(err);
            valueContainer.value = value;
            callback();
        });
    } else if (typeStr == "format") {
        var paramFormatObj = paramValueSplitter.parseParamFormat(typeConfig.format);
        var paramValues = paramValueSplitter.parseParamValues(valueContainer.value, paramFormatObj);
        // In order to parse the resulting data object, we need it to follow a format similar to the parameter list
        valueContainer.value = {};
        asyncEach(paramFormatObj.componentNames, function(componentKey, formatLoopIteratorDone){
            //Get the correct component name (overridden by config's "modelName" property)
            var componentName = componentKey;
            if (_.has(querySet.paramMetadata, componentKey)) {
                componentName = querySet.paramMetadata[componentKey].modelName;
            }
            var componentConfig = configProvider.getTypeConfig(querySet, typeConfig, componentKey); 
            parseValue(paramValues[componentKey], componentConfig, querySet, context, function(err, value){
                if (err) return formatLoopIteratorDone(err);
                if (value != null) {
                    valueContainer.value[componentName] = value;
                }
                formatLoopIteratorDone();
            });
        }, callback);
    } else {
        safeNormalizerParse("default", valueContainer.value, typeConfig, context, function(err, value){
            if (err) return callback(err);
            valueContainer.value = value;
            callback();
        });
    }
}

function safeNormalizerParse(normalizerName, objToParse, typeConfig, context, callback) {
    try {
        normalizers[normalizerName].parse(objToParse, typeConfig, context, callback);
    } catch (err) {
        callback(err);
    }
}

function parseListValues(valueContainer, typeStr, typeConfig, querySet, context, callback) {
    var listItemType = normalizers.list.getListInfo(typeStr).listType;
    safeNormalizerParse('list', valueContainer.value, typeConfig, context, function(err, valueList){
        valueContainer.value = [];
        var listValueContainer = { value: null };
        function parseListItem(itemValue, parseListItemDoneCallback){
            listValueContainer.value = itemValue;
            parseValueByType(listValueContainer, listItemType, typeConfig, querySet, context, function(err){
                if (err) return parseListItemDoneCallback(err); 
                valueContainer.value.push(listValueContainer.value);
                parseListItemDoneCallback();
            });
        };
        asyncEachSeries(valueList, parseListItem, callback);
    });
}

function parseValue(value, typeConfig, querySet, context, callback){
    if (value == null || typeConfig == null) {
        return callback(new Error("parseValue() requires a non-null value and a typeConfig for parsing"));
    }

    var valueContainer = { value: value };
    var types = typeConfig.type; 
    asyncEachSeries(types,
        function loop(typeStr, typeLoopIteratorDone){
            parseValueByType(valueContainer, typeStr, typeConfig, querySet, context, typeLoopIteratorDone);
    }, function iterationDone(err) {
        callback(err, valueContainer.value);
    });
}

function addInstanceDefaults(instance, modelName, querySetName) {
    var querySet = configProvider.getQuerySetConfig(querySetName);
    var defaultInstanceModels = defaultModelValueProvider.getDefaultInstancedDataModels(querySetName);
    if (_.has(defaultInstanceModels, modelName)) {
        _.defaultsDeep(instance, defaultInstanceModels[modelName]);
    }
}

function addDefaultDynamicModel(model, typeConfig, querySetName) {
    var dynamicKey = typeConfig.dynamicFormat.componentNames.join('-');
    var defaultDynamicModels = defaultModelValueProvider.getDefaultDynamicDataModels(querySetName);
    var defaultDynamicModel = defaultDynamicModels[dynamicKey];
    _.defaultsDeep(model, defaultDynamicModel);
}

function getCurrentParamConfig(paramKey, querySet) {
    //match the parameter key against all known and dynamic parameter key regex's
    var paramMatch = configProvider.getParamRegexMatch(paramKey, querySet);
    if (!paramMatch) return {found: false};
    
    var paramConfig = paramMatch.paramConfig;
    var paramName = paramMatch.configParamKey;

    var paramIndex = null;
    if (paramMatch.paramIndex != null) {
        paramIndex = parseInt(paramMatch.paramIndex);
    }

    var paramSuffix = paramMatch.paramSuffix;
    if (paramSuffix === "")
        paramSuffix = null;
    var paramTypeKey = "";
    var paramTypeConfig = {};
    if (paramSuffix){
        paramTypeKey = paramConfig.suffix.type;
        paramTypeConfig = configProvider.getTypeConfig(querySet, paramConfig, paramConfig.type);
        paramTypeConfig = configProvider.getTypeConfig(querySet, paramTypeConfig, paramTypeKey);
    } else {
        paramTypeKey = paramConfig.type;
        paramTypeConfig = configProvider.getTypeConfig(querySet, paramConfig, paramTypeKey);
    }

    var output = {
        found: true,
        paramName: paramName,
        queryStringKey: paramKey,
        paramIndex: paramIndex,
        paramSuffix: paramSuffix,
        paramType: paramMatch.paramType,
        paramTypeKey: paramTypeKey,
        paramTypeConfig: paramTypeConfig
    };
    
    if (paramMatch.modelName){
        output.modelName = paramMatch.modelName;
    }

    return output;
}

function getDataModel(queryStringObj, querySetName, context, callback) {
    var querySet = configProvider.getQuerySetConfig(querySetName);
    if (querySet == null) {
        querySet = configProvider.getQuerySetConfig('topLevelTypes');
    }
    if (querySet == null) {
        return callback(new Error('Unknown query set' + querySetName));
    }
    var queryParamConfigs = getQueryParamConfigs(queryStringObj, querySet);
    parseTopLevelValues(queryStringObj, querySetName, queryParamConfigs, context, function(err, dataModel){
        if (err) return callback(err);
        var defaultModel = defaultModelValueProvider.getDefaultDataModel(querySetName);
        _.defaultsDeep(dataModel, defaultModel);
        callback(null, dataModel);
    });
};

module.exports = {
     getDataModel: getDataModel
};

},{"./configProvider":45,"./defaultModelValueProvider":46,"./normalizers":48,"./paramValueSplitter":49,"alphanum-sort":35,"async-each":37,"async-each-series":36}],52:[function(require,module,exports){
var _ = window._;

module.exports = {
    parseNullableBool: function(value, ruleConfig) {
        if (ruleConfig.composeTrueValue != null) {
            var parseValue = value === ruleConfig.composeTrueValue;
            var isBool = parseValue || value === '' || value == null;
            return { isBool: isBool, value: parseValue };
        }
        var match = null;
        if (value != null) {
            match = value.match(/^(?:0|1|false|true)/i);
            if (match != null) {
                if (match[0] === "1" || match[0].toLowerCase() === "true")
                    value = true;
                if (match[0] === "0" || match[0].toLowerCase() === "false")
                    value = false;
            }
        }
        return { isBool: match != null, value: value };
    },
    parse: function(str, ruleConfig, context, callback) {
        var parsedBool = this.parseNullableBool(str, ruleConfig);
        callback(null, parsedBool.isBool ? parsedBool.value : false);
    },
    compose: function(obj, ruleConfig, context) {
        if (obj !== true) return "";
        return ruleConfig.composeTrueValue == null ? "1" : ruleConfig.composeTrueValue;
    },
    getDefault: function(ruleConfig){
        var str = "";
        if (ruleConfig.default != null) {
            if (ruleConfig.default === true) { return true; }
            if (ruleConfig.default === false) { return false; }
            str = ruleConfig.default;
        }

        var parsedBool = this.parseNullableBool(str, ruleConfig);
        return parsedBool.isBool ? parsedBool.value : false;
    }
};
},{}],53:[function(require,module,exports){
var _ = window._;

module.exports = {
    parse: function (str, ruleConfig, context, callback) {
        callback(null, str);
    },
    compose: function (obj, ruleConfig, context) {
        if (obj==null) return "";
        return obj.toString();
    },
    getDefault: function (ruleConfig) {
        if (ruleConfig.default != null)
            return ruleConfig.default;
        return "";
    }
};
},{}],54:[function(require,module,exports){
module.exports = {
    parse: function(str, ruleConfig, context, callback) {
        var parsedValue = ruleConfig.values[str] || this.getDefault(ruleConfig); 
        callback(null, parsedValue);
    },
    compose: function(obj, ruleConfig, context) {
        var paramValues = Object.keys(ruleConfig.values);
        for (var i = 0; i < paramValues.length; ++i) {
            var paramValue = paramValues[i];
            var modelValue = ruleConfig.values[paramValue];
            if (modelValue === obj) {
                return paramValue;
            }
        }
        return "";
    },
    getDefault: function(ruleConfig) {
        if (ruleConfig.default) {
            return ruleConfig.values[ruleConfig.default];
        }
        return null;
    }
};
},{}],55:[function(require,module,exports){
var _ = window._;

function getEscapedRegExpStr(string) {
    return string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
}

function getUnescapedString(str, ruleConfig) {
    var unescapedStr = str;
    if (ruleConfig && ruleConfig.escapes) {
        for (var i = ruleConfig.escapes.length - 1; i >= 0; --i) {
            var escapeObj = ruleConfig.escapes[i];
            var escapeKeys = _.keys(escapeObj);
            for (var j = escapeKeys.length - 1; j >= 0; --j) {
                var escapeKey = escapeKeys[j];
                var escapeValue = escapeObj[escapeKey];
                var escapeRegex = new RegExp(getEscapedRegExpStr(escapeValue), "g");
                unescapedStr = unescapedStr.replace(escapeRegex, escapeKey);
            }
        }
    }
    return unescapedStr;
}

module.exports = {
    parse: function(str, ruleConfig, context, callback) {
        if (str == null || str.length === 0) return callback(null, "");
        var unescapedStr = getUnescapedString(str, ruleConfig);
        callback(null, unescapedStr);
    },
    compose: function(obj, ruleConfig, context) {
        var str = obj;
        if (!_.isString(obj) || ruleConfig == null || ruleConfig.escapes == null) {
            return "";
        }
        var escapedStr = str;
        _.each(ruleConfig.escapes, function(escapeObj){
            var escapeKeys = _.keys(escapeObj);
            _.each(escapeKeys, function(escapeKey){
                var escapeValue = escapeObj[escapeKey];
                var escapeRegex = new RegExp(getEscapedRegExpStr(escapeKey), "g");
                escapedStr = escapedStr.replace(escapeRegex, escapeValue);
            });
        });
        return escapedStr;
    },
    getDefault: function(ruleConfig){
        var str = ruleConfig.default != null ? ruleConfig.default : "";
        if (str == null || str.length === 0) return "";
        return getUnescapedString(str, ruleConfig);
    }
};
},{}],56:[function(require,module,exports){
var _ = window._;

module.exports = {
    getFlags: function (obj, ruleConfig) {
        var flagsObj = {};
        if (!_.isString(obj)) {
            flagsObj = this.getDefault(ruleConfig);
        } else {
            var str = obj;
            _.each(ruleConfig.values, function (flagPropertyName, flag) {
                flagsObj[flagPropertyName] = str.indexOf(flag) !== -1;
            });
        }
        return flagsObj;
    },
    parse: function(obj, ruleConfig, context, callback) {
        if (ruleConfig == null || ruleConfig.values == null)
            return callback(null, {});

        var flagsObj = this.getFlags(obj, ruleConfig);
        callback(null, flagsObj);
    },
    compose: function(obj, ruleConfig, context) {
        if (obj == null || !_.isObject(obj) || ruleConfig == null || ruleConfig.values == null) return "";
        var str = "";
        var defaultFlags = this.getDefault(ruleConfig);
        var flagChars = _.invert(ruleConfig.values);
        _.each(defaultFlags, function(flagValue, flagName) {
            var flagsToCheck = _.has(obj, flagName) ? obj : defaultFlags;
            if (flagsToCheck[flagName] === true)
                str += flagChars[flagName];
        });
        return str;
    },
    getDefault: function(ruleConfig){
        var str = ruleConfig.default != null ? ruleConfig.default : "";
        return this.getFlags(str, ruleConfig);
    }
};
},{}],57:[function(require,module,exports){
var _ = window._;
var boolNormalizer = require('./booleanNumberNormalizer');
var flagsNormalizer = require('./flagsNormalizer');

//TODO: right now this is a straight copy of the stringNormalizer, so make it do it's own flaggy, booly thang

function getConfigData(ruleConfig) {
    return {
        flagsPropName: ruleConfig.flagsModelName ? ruleConfig.flagsModelName : "flags",
        boolPropName: ruleConfig.boolModelName ? ruleConfig.boolModelName : "isSet"
    };
};

function getFlagsOrBool(str, ruleConfig) {
    var output = {};
    var configData = getConfigData(ruleConfig);
    var boolResult = boolNormalizer.parseNullableBool(str, ruleConfig);
    
    if (boolResult.isBool) {
        output[configData.flagsPropName] = flagsNormalizer.getDefault(ruleConfig);
        output[configData.boolPropName] = boolResult.value;
    } else {
        var flags = flagsNormalizer.getFlags(str, ruleConfig);
        var boolResultValue = _.some(flags, function (flagValue) {
            return flagValue === true;
        });
        output[configData.flagsPropName] = flags;
        output[configData.boolPropName] = boolResultValue;
    }
    return output;
};

module.exports = {
    parse: function(str, ruleConfig, context, parseCallback) {
        var output = getFlagsOrBool(str, ruleConfig);
        parseCallback(null, output);
    },
    compose: function(obj, ruleConfig, context) {
        var configData = getConfigData(ruleConfig);
        if (!_.isObject(obj)) return '';
        if (!_.has(obj, configData.boolPropName) && !_.has(obj, configData.flagsPropName)) return '';
        var resultStr = flagsNormalizer.compose(obj[configData.flagsPropName], ruleConfig);
        if (resultStr == null || resultStr.length === 0) {
            resultStr = boolNormalizer.compose(obj[configData.boolPropName], ruleConfig);
        }
        return resultStr;
    },
    getDefault: function(ruleConfig){
        var str = ruleConfig.default != null ? ruleConfig.default : "";
        return getFlagsOrBool(str, ruleConfig);
    }
};
},{"./booleanNumberNormalizer":52,"./flagsNormalizer":56}],58:[function(require,module,exports){
var _ = window._;

module.exports = {
    parse: function (str, ruleConfig, context, callback) {
        var output = this.getInt(str, ruleConfig);
        callback(null, output);
    },
    compose: function (obj, ruleConfig, context) {
        if (obj == null || !_.isNumber(obj)) return '';
        return obj.toString();
    },
    getDefault: function (ruleConfig) {
        var str = ruleConfig.default != null ? ruleConfig.default : "";
        return this.getInt(str, ruleConfig);
    },
    getInt: function (str, ruleConfig) {
        if (str == null || str.length == 0) return null;
        var value = parseInt(str);
        if (isNaN(value)) return null;
        value = ruleConfig && ruleConfig.max ? Math.min(ruleConfig.max, value) : value;
        value = ruleConfig && ruleConfig.min ? Math.max(ruleConfig.min, value) : value;
        return ruleConfig.values != null && !_.includes(ruleConfig.values, value)
            ? this.getDefault(ruleConfig)
            : value;
    }
};
},{}],59:[function(require,module,exports){
var _ = window._;

function getDelimiterConfig(config){
    var delimiter = config.delimiter != null ? config.delimiter : '.';
    var escapeChar = delimiter === '.' ? '~' : '.';
    return { delimiter: delimiter, escapeChar: escapeChar };
};

function getParsedList(str, config) {
    var output;
    if (str == null || str.length === 0) {
        output = [];
    }
    else {
        var delimiterConfig = getDelimiterConfig(config);

        // Split by the escaped escape character.  If the escaped escape character is not used there will only
        // be a single element.  Otherwise there will be multiple that will need to be combined later adding back in
        // the escape character between.
        // e.g. Split on the escaped escape char like ".." where "." is the escape char
        var list = str.split(delimiterConfig.escapeChar + delimiterConfig.escapeChar);
        // Separate out the components by the delimiter
        list = _.map(list, function (value) {
            // split it by the escaped delimiter next
            return value.split(delimiterConfig.escapeChar + delimiterConfig.delimiter);
        });
        // Recombine the component values that were separated by the escaped escape character
        list = _.reduce(list, function (prev, curr) {
            var firstElementOfCurrentArr = curr.splice(0, 1)[0];
            // Add delimiter back into the param value
            prev[prev.length - 1] = prev[prev.length - 1] + delimiterConfig.escapeChar + firstElementOfCurrentArr;
            return prev.concat(curr);
        });
        // Separate out the components by the delimiter
        list = _.map(list, function (value) {
            return value.split(delimiterConfig.delimiter);
        });
        // Recombine the component values that were separated by the escaped delimiter
        list = _.reduce(list, function (prev, curr) {
            var firstElementOfCurrentArr = curr.splice(0, 1)[0];
            // Add delimiter back into the param value
            prev[prev.length - 1] = prev[prev.length - 1] + delimiterConfig.delimiter + firstElementOfCurrentArr;
            return prev.concat(curr);
        });
        var listWithEmptyElements = _.filter(list, function (el) {
            return el != null && el.length > 0;
        });
        output = listWithEmptyElements
    }
    return output;
}

var listRegex = /^([a-z]+)\[\]$/i;

module.exports = {
    isListType: function(typeStr) {
        return typeStr != null && listRegex.test(typeStr);
    },
    getListInfo: function(typeStr) {
        var listMatch = typeStr.match(listRegex);
        return {
            isListType: listMatch != null,
            listType: listMatch != null ? listMatch[1] : null
        };
    },
    parse: function(str, config, context, callback){
        var output = getParsedList(str, config);
        callback(null, output);
    },
    compose: function(arr, config, context){
        var delimiterConfig = getDelimiterConfig(config);
        var escapedArr = [];
        var escapeRegex = new RegExp(_.escapeRegExp(delimiterConfig.escapeChar), "g");
        var delimiterRegex = new RegExp(_.escapeRegExp(delimiterConfig.delimiter), "g");
        for (var i = 0; i < arr.length; ++i) {
            var value = arr[i];
            if (value == null || value.length === 0) continue;
            value = value.replace(escapeRegex, delimiterConfig.escapeChar + delimiterConfig.escapeChar);
            value = value.replace(delimiterRegex, delimiterConfig.escapeChar + delimiterConfig.delimiter);
            escapedArr.push(value);
        }
        return escapedArr.join(delimiterConfig.delimiter);
    },
    getDefault: function(config){
        var str = (config && config.default != null) ? config.default : "";
        return getParsedList(str, config);
    }
};
},{}],60:[function(require,module,exports){
var _ = window._;

function getParsedString(str) {
    if (str == null) return '';
    if (_.isObject(str)) return '';
    return str.toString();
}
module.exports = {
    parse: function (str, ruleConfig, context, callback) {
        var output = getParsedString(str);

        if (ruleConfig.values != null && !_.includes(ruleConfig.values, output)) {
            callback(null, this.getDefault(ruleConfig));
        }
        else {
            callback(null, output);
        }
    },
    compose: function (obj, ruleConfig, context) {
        if (_.isObject(obj)) return '';
        return obj.toString();
    },
    getDefault: function (ruleConfig) {
        var str = ruleConfig.default != null ? ruleConfig.default : "";
        return getParsedString(str, ruleConfig);
    }
};
},{}],61:[function(require,module,exports){
'use strict';

var _ = window._;
var queryComposer = require('./lib/queryComposer');
var queryParser = require('./lib/queryParser');
var configProvider = require('./lib/configProvider');

function QueryParamNormalizer(){
    this.addConfig = function(config){
        return configProvider.addConfig(config);
    };

    this.getDataModel = function (queryStringObj, querySetName, context, callback){
        return queryParser.getDataModel(queryStringObj, querySetName, context, callback);
    };

    this.toQueryParams = function(dataModel, querySetName, otherParams, context) {
        return queryComposer.toQueryParams(dataModel, querySetName, otherParams, context);
    };

    this.getUnknownParams = function(queryStringObj, querySetName){
        if (querySetName == null) querySetName = 'topLevelTypes';
        var querySet = configProvider.getQuerySetConfig(querySetName);
        if (querySet == null)
            return {};
        return _.pickBy(queryStringObj, function(paramValue, paramKey){
            var match = configProvider.getParamRegexMatch(paramKey, querySet);
            return match == null;
        });
    };

    this.normalizers = require('./lib/normalizers');

    this.paramValueSplitter = require('./lib/paramValueSplitter');
}

module.exports = new QueryParamNormalizer();

},{"./lib/configProvider":45,"./lib/normalizers":48,"./lib/paramValueSplitter":49,"./lib/queryComposer":50,"./lib/queryParser":51}],62:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

},{}],63:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};

},{}],64:[function(require,module,exports){
'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');

},{"./decode":62,"./encode":63}],65:[function(require,module,exports){
'use strict';

var has = Object.prototype.hasOwnProperty
  , undef;

/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String} The decoded string.
 * @api private
 */
function decode(input) {
  return decodeURIComponent(input.replace(/\+/g, ' '));
}

/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */
function querystring(query) {
  var parser = /([^=?&]+)=?([^&]*)/g
    , result = {}
    , part;

  while (part = parser.exec(query)) {
    var key = decode(part[1])
      , value = decode(part[2]);

    //
    // Prevent overriding of existing properties. This ensures that build-in
    // methods like `toString` or __proto__ are not overriden by malicious
    // querystrings.
    //
    if (key in result) continue;
    result[key] = value;
  }

  return result;
}

/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */
function querystringify(obj, prefix) {
  prefix = prefix || '';

  var pairs = []
    , value
    , key;

  //
  // Optionally prefix with a '?' if needed
  //
  if ('string' !== typeof prefix) prefix = '?';

  for (key in obj) {
    if (has.call(obj, key)) {
      value = obj[key];

      //
      // Edge cases where we actually want to encode the value to an empty
      // string instead of the stringified value.
      //
      if (!value && (value === null || value === undef || isNaN(value))) {
        value = '';
      }

      pairs.push(encodeURIComponent(key) +'='+ encodeURIComponent(value));
    }
  }

  return pairs.length ? prefix + pairs.join('&') : '';
}

//
// Expose the module.
//
exports.stringify = querystringify;
exports.parse = querystring;

},{}],66:[function(require,module,exports){
'use strict';

/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */
module.exports = function required(port, protocol) {
  protocol = protocol.split(':')[0];
  port = +port;

  if (!port) return false;

  switch (protocol) {
    case 'http':
    case 'ws':
    return port !== 80;

    case 'https':
    case 'wss':
    return port !== 443;

    case 'ftp':
    return port !== 21;

    case 'gopher':
    return port !== 70;

    case 'file':
    return false;
  }

  return port !== 0;
};

},{}],67:[function(require,module,exports){
// Generated by CoffeeScript 1.8.0
(function() {
  var ValueError, create, explicitToImplicit, format, implicitToExplicit, lookup, resolve,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    __slice = [].slice;

  ValueError = (function(_super) {
    __extends(ValueError, _super);

    function ValueError(message) {
      this.message = message;
    }

    ValueError.prototype.name = 'ValueError';

    return ValueError;

  })(Error);

  implicitToExplicit = 'cannot switch from implicit to explicit numbering';

  explicitToImplicit = 'cannot switch from explicit to implicit numbering';

  create = function(transformers) {
    if (transformers == null) {
      transformers = {};
    }
    return function() {
      var args, explicit, idx, implicit, message, template;
      template = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      idx = 0;
      explicit = implicit = false;
      message = 'cannot switch from {} to {} numbering';
      return template.replace(/([{}])\1|[{](.*?)(?:!(.+?))?[}]/g, function(match, literal, key, transformer) {
        var value, _ref, _ref1;
        if (literal) {
          return literal;
        }
        if (key.length) {
          if (implicit) {
            throw new ValueError(implicitToExplicit);
          }
          explicit = true;
          value = (_ref = lookup(args, key)) != null ? _ref : '';
        } else {
          if (explicit) {
            throw new ValueError(explicitToImplicit);
          }
          implicit = true;
          value = (_ref1 = args[idx++]) != null ? _ref1 : '';
        }
        if (Object.prototype.hasOwnProperty.call(transformers, transformer)) {
          return transformers[transformer](value);
        } else {
          return value;
        }
      });
    };
  };

  lookup = function(object, key) {
    var match;
    if (!/^(\d+)([.]|$)/.test(key)) {
      key = '0.' + key;
    }
    while (match = /(.+?)[.](.+)/.exec(key)) {
      object = resolve(object, match[1]);
      key = match[2];
    }
    return resolve(object, key);
  };

  resolve = function(object, key) {
    var value;
    value = object[key];
    if (typeof value === 'function') {
      return value.call(object);
    } else {
      return value;
    }
  };

  format = create({});

  format.create = create;

  format.extend = function(prototype, transformers) {
    var $format;
    $format = create(transformers);
    prototype.format = function() {
      return $format.apply(null, [this].concat(__slice.call(arguments)));
    };
  };

  if (typeof module !== 'undefined') {
    module.exports = format;
  } else if (typeof define === 'function' && define.amd) {
    define(format);
  } else {
    window.format = format;
  }

}).call(this);

},{}],68:[function(require,module,exports){
(function (setImmediate,clearImmediate){
var nextTick = require('process/browser.js').nextTick;
var apply = Function.prototype.apply;
var slice = Array.prototype.slice;
var immediateIds = {};
var nextImmediateId = 0;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) { timeout.close(); };

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// That's not how node.js implements it but the exposed api is the same.
exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
  var id = nextImmediateId++;
  var args = arguments.length < 2 ? false : slice.call(arguments, 1);

  immediateIds[id] = true;

  nextTick(function onNextTick() {
    if (immediateIds[id]) {
      // fn.call() is faster so we optimize for the common use-case
      // @see http://jsperf.com/call-apply-segu
      if (args) {
        fn.apply(null, args);
      } else {
        fn.call(null);
      }
      // Prevent ids from leaking
      exports.clearImmediate(id);
    }
  });

  return id;
};

exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
  delete immediateIds[id];
};
}).call(this,require("timers").setImmediate,require("timers").clearImmediate)
},{"process/browser.js":42,"timers":68}],69:[function(require,module,exports){
'use strict';

var _ = window._;
var urlModule = require('url');
var pathToRegexp = require('path-to-regexp');
var urlSanitizer = require('./lib/urlSanitizer');
var queryParamNormalizer = require('query-param-normalizer');

function Canonicalizer(config){
	// Private variables
	config = config || {};
	var pathRoutes = [];

	this.setConfig = function(newConfig){
		config = newConfig;
		queryParamNormalizer.addConfig(config);
		populatePathRoutes();
	};

	function getPathParams(path, pathConfig) {
		var matches = path.match(pathConfig.regexp);
		if (matches.length == 1)
			return null;
		matches = _.takeRight(matches, matches.length-1);
		var output = _.zipObject(pathConfig.pathParamNames, matches);
		return output;
	}

	function insertPathParams(path, params){
		_.each(params, function(paramValue, paramKey){
			path = path.replace("/:" + paramKey, "/" + paramValue);
		});
		return path;
	}

	this.canonicalize = function(url, context, callback) {
		var pathConfig = getPathConfig(url);
		var expectTrailingSlash = pathConfig == null ? null : pathConfig.requiresTrailingSlash;
		var cleanUrl = urlSanitizer.cleanUrl(url, { expectTrailingSlash: expectTrailingSlash });

		if (!pathConfig) {
			return callback(null, { 
				redirect: (cleanUrl !== url), 
				found: false, 
				cleanUrl: cleanUrl,  
			});
		}

		var cleanUrlObj = urlModule.parse(cleanUrl, true);
		queryParamNormalizer.getDataModel(pathConfig.pathParams, null, context, function(pathErr, pathModel){
			if (pathErr) {
				// Note that usually a path error suggests a 404
				return callback(null, {
					pathName: pathConfig.pathName,
					redirect: false,
					found: true,
					pathErr: pathErr
				});
			}

			queryParamNormalizer.getDataModel(cleanUrlObj.query, pathConfig.querySet, context, function(queryErr, dataModel){
				if (queryErr) {
					return callback(null, {
						pathName: pathConfig.pathName,
						redirect: false,
						found: true,
						queryErr: queryErr
					});
				}

				_.assign(dataModel, pathModel);

				var pathParams = queryParamNormalizer.toQueryParams(pathModel, null, null, context);
				var queryParams = queryParamNormalizer.toQueryParams(dataModel, pathConfig.querySet, null, context);

				var path = insertPathParams(pathConfig.pathRoute, pathParams.params);
				var absoluteUrl = cleanUrlObj.protocol + "//" + cleanUrlObj.host + path;

				var unknownParams = queryParamNormalizer.getUnknownParams(cleanUrlObj.query, pathConfig.querySet);
				var unknownParamsQueryString = objToQueryString(unknownParams);
				cleanUrl = getAbsoluteUrlWithQuery(absoluteUrl, queryParams.queryString, unknownParamsQueryString);
				var canonicalUrl = getAbsoluteUrlWithQuery(absoluteUrl, queryParams.queryString);

				callback(null, {
					pathName: pathConfig.pathName,
					redirect: (cleanUrl !== url),
					found: true,
					cleanUrl: cleanUrl,
					canonicalUrl: canonicalUrl,
					dataModel: dataModel
				});
			});
		});
	};

	var whitespaceRegex = /^ *$/;
	function objToQueryString(obj) {
		var keys = _.filter(Object.keys(obj), function(key){
			return !whitespaceRegex.test(obj[key]);
		});;
		keys.sort();
		return _.map(keys, function(key) {
			var encodedKey = encodeURIComponent(key).replace(/%20/g, '+');
			var encodedValue = encodeURIComponent(obj[key]).replace(/%20/g, '+');
			return encodedKey + '=' + encodedValue;
		}).join('&');
	}

	function getAbsoluteUrlWithQuery(absoluteUrl){
		var hook = '?';
		var queryStrings = _.tail(arguments);
		var fullUrl = absoluteUrl;
		_.each(queryStrings, function(queryString){
			if (queryString != null && queryString.length > 0) {
				fullUrl += hook + queryString;
				hook = '&';
			}
		});
		return fullUrl;
	};

	function populatePathRoutes() {
		var paths = config.paths || {};
		_.each(paths, function(pathConfig, pathName){
			var path = pathConfig.path;
			pathConfig.requiresTrailingSlash = path.length > 0 && path[path.length - 1] === '/';
			var keys = [];
			var regexp = pathToRegexp(path, keys);
			keys = _.map(keys, "name");
			pathRoutes.push({
				pathName: pathName,
				regexp: regexp,
				pathConfig: pathConfig,
				pathParamNames: keys
			})
		});
	}

	function getPathConfig(url){
		var path = urlModule.parse(url, false).pathname.replace(/\/\//g, '/');  // de-dupe slashes
		var matchedPathRoute = _.find(pathRoutes, function(pathRoute){
			return path.match(pathRoute.regexp) != null;
		});
		if (matchedPathRoute == null)
			return null;
		var output = matchedPathRoute.pathConfig;
		output.pathParams = getPathParams(path, matchedPathRoute);
		output.pathRoute = matchedPathRoute.pathConfig.path;
		output.pathName = matchedPathRoute.pathName;
		return output;
	}
}

var canonicalizer = new Canonicalizer();
canonicalizer.setConfig({});

module.exports = {
	canonicalize: function(inputUrl, context, callback) {
		return canonicalizer.canonicalize(inputUrl, context, callback);
	},
	setConfig: function(config) {
		canonicalizer.setConfig(config);
	},
	queryParamNormalizer: queryParamNormalizer
};
},{"./lib/urlSanitizer":71,"path-to-regexp":73,"query-param-normalizer":61,"url":75}],70:[function(require,module,exports){
'use strict';
var urlParse = require('url-parse');

module.exports = function (url) {
	var urlWithPlusConvertedToSpace = url;
	var queryIndex = url.indexOf('?');
	if (queryIndex >= 0) {
		urlWithPlusConvertedToSpace = urlWithPlusConvertedToSpace.substring(0, queryIndex) +
			urlWithPlusConvertedToSpace.substring(queryIndex).replace(/[+]/g, '%20');
	}
	return urlParse(urlWithPlusConvertedToSpace, null, parseQueryString);
};

function parseQueryString(queryStr) {
	if (queryStr.length < 0 || queryStr[0] !== '?') return {};
	queryStr = queryStr.substring(1);
	var pairs = queryStr.split('&');
	var queryObj = {};
	pairs.forEach(function(pair){
		if (pair.length === 0) return;
		var equalsIndex = pair.indexOf('=');
		if (equalsIndex < 0) return;
		var key = pair.substring(0, equalsIndex);
		var value = pair.substring(equalsIndex + 1);
		queryObj[decodeURIComponent(key)] = decodeURIComponent(value);
	});
	return queryObj;
};

},{"url-parse":74}],71:[function(require,module,exports){
var _ = window._;
var urlParse = require('./url-parse');

var percentEncodingRegex = /%[0-9a-f][0-9a-f]/g;
var possibleUnnecessaryPercentEncodingRegex = /%[234][0-9a-z]/gi;
var apostropheRegex = /'/g;
var unnecessaryEncodingMap = {
	"%20": '+',
	"%24": '$',
	"%2C": ',',
	"%2F": '/',
	"%3A": ':',
	"%3B": ';',
	"%3F": '?',
	"%40": '@'
};

function upperCasePercentEncodings(url) {
	return url.replace(percentEncodingRegex, function (match) {
		return match.toUpperCase();
	});
}

function encodeQueryComponent(str) {
	// Note: Chrome and Internet Explorer will convert apostrophes to %27, so to prevent
	//       canonicalizer redirection wars with the browser we will allow this to be 
	//       encoded even though by the URI spec it doesn't need to be.
	return encodeURIComponent(str)
		.replace(possibleUnnecessaryPercentEncodingRegex, function (str) {
			return unnecessaryEncodingMap[str] || str;
		}).replace(apostropheRegex, "%27");
}

function toQueryString(obj) {
	return _.map(obj, function (v, k) {
		return encodeQueryComponent(k) + '=' + encodeQueryComponent(v);
	}).join('&');
}

module.exports = {
	cleanUrl: function (url, options) {
		options = options == null || !_.isObject(options) ? {} : options;
		var urlFixedEncodings = upperCasePercentEncodings(url);
		var urlParts = urlParse(urlFixedEncodings, true);
		// de-dupe slashes and make path lowercase
		var path = upperCasePercentEncodings(urlParts.pathname.replace(/\/\//g, '/').toLowerCase());
		var requiresTrailingSlash = options.expectTrailingSlash != null
			? options.expectTrailingSlash === true
			: path.length > 0 && path[path.length - 1] === '/';
		if (requiresTrailingSlash) {
			// if path is empty or doesn't end with a slash
			if (path.length == 0 || (path.length > 0 && path[path.length - 1] !== '/')) {
				path += '/';
			}
		} else if (path.length > 0 && path[path.length - 1] === '/') {
			path = path.substr(0, path.length - 1);
		}
		var fullPath = urlParts.protocol + '//' + urlParts.host + path;
		var queryString = toQueryString(urlParts.query);
		// remove query string "?" if query string is empty
		queryString = queryString.length == 0 ? '' : '?' + queryString;
		var resolvedUrl = fullPath + queryString;
		return resolvedUrl;
	}
};
},{"./url-parse":70}],72:[function(require,module,exports){
module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

},{}],73:[function(require,module,exports){
var isarray = require('isarray')

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

},{"isarray":72}],74:[function(require,module,exports){
(function (global){
'use strict';

var required = require('requires-port')
  , qs = require('querystringify')
  , protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i
  , slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//;

/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */
var rules = [
  ['#', 'hash'],                        // Extract from the back.
  ['?', 'query'],                       // Extract from the back.
  function sanitize(address) {          // Sanitize what is left of the address
    return address.replace('\\', '/');
  },
  ['/', 'pathname'],                    // Extract from the back.
  ['@', 'auth', 1],                     // Extract from the front.
  [NaN, 'host', undefined, 1, 1],       // Set left over value.
  [/:(\d+)$/, 'port', undefined, 1],    // RegExp the back.
  [NaN, 'hostname', undefined, 1, 1]    // Set left over.
];

/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */
var ignore = { hash: 1, query: 1 };

/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */
function lolcation(loc) {
  var globalVar;

  if (typeof window !== 'undefined') globalVar = window;
  else if (typeof global !== 'undefined') globalVar = global;
  else if (typeof self !== 'undefined') globalVar = self;
  else globalVar = {};

  var location = globalVar.location || {};
  loc = loc || location;

  var finaldestination = {}
    , type = typeof loc
    , key;

  if ('blob:' === loc.protocol) {
    finaldestination = new Url(unescape(loc.pathname), {});
  } else if ('string' === type) {
    finaldestination = new Url(loc, {});
    for (key in ignore) delete finaldestination[key];
  } else if ('object' === type) {
    for (key in loc) {
      if (key in ignore) continue;
      finaldestination[key] = loc[key];
    }

    if (finaldestination.slashes === undefined) {
      finaldestination.slashes = slashes.test(loc.href);
    }
  }

  return finaldestination;
}

/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */

/**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @return {ProtocolExtract} Extracted information.
 * @private
 */
function extractProtocol(address) {
  var match = protocolre.exec(address);

  return {
    protocol: match[1] ? match[1].toLowerCase() : '',
    slashes: !!match[2],
    rest: match[3]
  };
}

/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */
function resolve(relative, base) {
  var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/'))
    , i = path.length
    , last = path[i - 1]
    , unshift = false
    , up = 0;

  while (i--) {
    if (path[i] === '.') {
      path.splice(i, 1);
    } else if (path[i] === '..') {
      path.splice(i, 1);
      up++;
    } else if (up) {
      if (i === 0) unshift = true;
      path.splice(i, 1);
      up--;
    }
  }

  if (unshift) path.unshift('');
  if (last === '.' || last === '..') path.push('');

  return path.join('/');
}

/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */
function Url(address, location, parser) {
  if (!(this instanceof Url)) {
    return new Url(address, location, parser);
  }

  var relative, extracted, parse, instruction, index, key
    , instructions = rules.slice()
    , type = typeof location
    , url = this
    , i = 0;

  //
  // The following if statements allows this module two have compatibility with
  // 2 different API:
  //
  // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
  //    where the boolean indicates that the query string should also be parsed.
  //
  // 2. The `URL` interface of the browser which accepts a URL, object as
  //    arguments. The supplied object will be used as default values / fall-back
  //    for relative paths.
  //
  if ('object' !== type && 'string' !== type) {
    parser = location;
    location = null;
  }

  if (parser && 'function' !== typeof parser) parser = qs.parse;

  location = lolcation(location);

  //
  // Extract protocol information before running the instructions.
  //
  extracted = extractProtocol(address || '');
  relative = !extracted.protocol && !extracted.slashes;
  url.slashes = extracted.slashes || relative && location.slashes;
  url.protocol = extracted.protocol || location.protocol || '';
  address = extracted.rest;

  //
  // When the authority component is absent the URL starts with a path
  // component.
  //
  if (!extracted.slashes) instructions[3] = [/(.*)/, 'pathname'];

  for (; i < instructions.length; i++) {
    instruction = instructions[i];

    if (typeof instruction === 'function') {
      address = instruction(address);
      continue;
    }

    parse = instruction[0];
    key = instruction[1];

    if (parse !== parse) {
      url[key] = address;
    } else if ('string' === typeof parse) {
      if (~(index = address.indexOf(parse))) {
        if ('number' === typeof instruction[2]) {
          url[key] = address.slice(0, index);
          address = address.slice(index + instruction[2]);
        } else {
          url[key] = address.slice(index);
          address = address.slice(0, index);
        }
      }
    } else if ((index = parse.exec(address))) {
      url[key] = index[1];
      address = address.slice(0, index.index);
    }

    url[key] = url[key] || (
      relative && instruction[3] ? location[key] || '' : ''
    );

    //
    // Hostname, host and protocol should be lowercased so they can be used to
    // create a proper `origin`.
    //
    if (instruction[4]) url[key] = url[key].toLowerCase();
  }

  //
  // Also parse the supplied query string in to an object. If we're supplied
  // with a custom parser as function use that instead of the default build-in
  // parser.
  //
  if (parser) url.query = parser(url.query);

  //
  // If the URL is relative, resolve the pathname against the base URL.
  //
  if (
      relative
    && location.slashes
    && url.pathname.charAt(0) !== '/'
    && (url.pathname !== '' || location.pathname !== '')
  ) {
    url.pathname = resolve(url.pathname, location.pathname);
  }

  //
  // We should not add port numbers if they are already the default port number
  // for a given protocol. As the host also contains the port number we're going
  // override it with the hostname which contains no port number.
  //
  if (!required(url.port, url.protocol)) {
    url.host = url.hostname;
    url.port = '';
  }

  //
  // Parse down the `auth` for the username and password.
  //
  url.username = url.password = '';
  if (url.auth) {
    instruction = url.auth.split(':');
    url.username = instruction[0] || '';
    url.password = instruction[1] || '';
  }

  url.origin = url.protocol && url.host && url.protocol !== 'file:'
    ? url.protocol +'//'+ url.host
    : 'null';

  //
  // The href is just the compiled result.
  //
  url.href = url.toString();
}

/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */
function set(part, value, fn) {
  var url = this;

  switch (part) {
    case 'query':
      if ('string' === typeof value && value.length) {
        value = (fn || qs.parse)(value);
      }

      url[part] = value;
      break;

    case 'port':
      url[part] = value;

      if (!required(value, url.protocol)) {
        url.host = url.hostname;
        url[part] = '';
      } else if (value) {
        url.host = url.hostname +':'+ value;
      }

      break;

    case 'hostname':
      url[part] = value;

      if (url.port) value += ':'+ url.port;
      url.host = value;
      break;

    case 'host':
      url[part] = value;

      if (/:\d+$/.test(value)) {
        value = value.split(':');
        url.port = value.pop();
        url.hostname = value.join(':');
      } else {
        url.hostname = value;
        url.port = '';
      }

      break;

    case 'protocol':
      url.protocol = value.toLowerCase();
      url.slashes = !fn;
      break;

    case 'pathname':
    case 'hash':
      if (value) {
        var char = part === 'pathname' ? '/' : '#';
        url[part] = value.charAt(0) !== char ? char + value : value;
      } else {
        url[part] = value;
      }
      break;

    default:
      url[part] = value;
  }

  for (var i = 0; i < rules.length; i++) {
    var ins = rules[i];

    if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
  }

  url.origin = url.protocol && url.host && url.protocol !== 'file:'
    ? url.protocol +'//'+ url.host
    : 'null';

  url.href = url.toString();

  return url;
}

/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */
function toString(stringify) {
  if (!stringify || 'function' !== typeof stringify) stringify = qs.stringify;

  var query
    , url = this
    , protocol = url.protocol;

  if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';

  var result = protocol + (url.slashes ? '//' : '');

  if (url.username) {
    result += url.username;
    if (url.password) result += ':'+ url.password;
    result += '@';
  }

  result += url.host + url.pathname;

  query = 'object' === typeof url.query ? stringify(url.query) : url.query;
  if (query) result += '?' !== query.charAt(0) ? '?'+ query : query;

  if (url.hash) result += url.hash;

  return result;
}

Url.prototype = { set: set, toString: toString };

//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
Url.extractProtocol = extractProtocol;
Url.location = lolcation;
Url.qs = qs;

module.exports = Url;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"querystringify":65,"requires-port":66}],75:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var punycode = require('punycode');
var util = require('./util');

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = require('querystring');

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};

},{"./util":76,"punycode":38,"querystring":64}],76:[function(require,module,exports){
'use strict';

module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};

},{}],77:[function(require,module,exports){
module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}
},{}],78:[function(require,module,exports){
(function (process,global){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = require('./support/isBuffer');

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = require('inherits');

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./support/isBuffer":77,"_process":42,"inherits":40}],79:[function(require,module,exports){
module.exports = Yallist

Yallist.Node = Node
Yallist.create = Yallist

function Yallist (list) {
  var self = this
  if (!(self instanceof Yallist)) {
    self = new Yallist()
  }

  self.tail = null
  self.head = null
  self.length = 0

  if (list && typeof list.forEach === 'function') {
    list.forEach(function (item) {
      self.push(item)
    })
  } else if (arguments.length > 0) {
    for (var i = 0, l = arguments.length; i < l; i++) {
      self.push(arguments[i])
    }
  }

  return self
}

Yallist.prototype.removeNode = function (node) {
  if (node.list !== this) {
    throw new Error('removing node which does not belong to this list')
  }

  var next = node.next
  var prev = node.prev

  if (next) {
    next.prev = prev
  }

  if (prev) {
    prev.next = next
  }

  if (node === this.head) {
    this.head = next
  }
  if (node === this.tail) {
    this.tail = prev
  }

  node.list.length--
  node.next = null
  node.prev = null
  node.list = null
}

Yallist.prototype.unshiftNode = function (node) {
  if (node === this.head) {
    return
  }

  if (node.list) {
    node.list.removeNode(node)
  }

  var head = this.head
  node.list = this
  node.next = head
  if (head) {
    head.prev = node
  }

  this.head = node
  if (!this.tail) {
    this.tail = node
  }
  this.length++
}

Yallist.prototype.pushNode = function (node) {
  if (node === this.tail) {
    return
  }

  if (node.list) {
    node.list.removeNode(node)
  }

  var tail = this.tail
  node.list = this
  node.prev = tail
  if (tail) {
    tail.next = node
  }

  this.tail = node
  if (!this.head) {
    this.head = node
  }
  this.length++
}

Yallist.prototype.push = function () {
  for (var i = 0, l = arguments.length; i < l; i++) {
    push(this, arguments[i])
  }
  return this.length
}

Yallist.prototype.unshift = function () {
  for (var i = 0, l = arguments.length; i < l; i++) {
    unshift(this, arguments[i])
  }
  return this.length
}

Yallist.prototype.pop = function () {
  if (!this.tail) {
    return undefined
  }

  var res = this.tail.value
  this.tail = this.tail.prev
  if (this.tail) {
    this.tail.next = null
  } else {
    this.head = null
  }
  this.length--
  return res
}

Yallist.prototype.shift = function () {
  if (!this.head) {
    return undefined
  }

  var res = this.head.value
  this.head = this.head.next
  if (this.head) {
    this.head.prev = null
  } else {
    this.tail = null
  }
  this.length--
  return res
}

Yallist.prototype.forEach = function (fn, thisp) {
  thisp = thisp || this
  for (var walker = this.head, i = 0; walker !== null; i++) {
    fn.call(thisp, walker.value, i, this)
    walker = walker.next
  }
}

Yallist.prototype.forEachReverse = function (fn, thisp) {
  thisp = thisp || this
  for (var walker = this.tail, i = this.length - 1; walker !== null; i--) {
    fn.call(thisp, walker.value, i, this)
    walker = walker.prev
  }
}

Yallist.prototype.get = function (n) {
  for (var i = 0, walker = this.head; walker !== null && i < n; i++) {
    // abort out of the list early if we hit a cycle
    walker = walker.next
  }
  if (i === n && walker !== null) {
    return walker.value
  }
}

Yallist.prototype.getReverse = function (n) {
  for (var i = 0, walker = this.tail; walker !== null && i < n; i++) {
    // abort out of the list early if we hit a cycle
    walker = walker.prev
  }
  if (i === n && walker !== null) {
    return walker.value
  }
}

Yallist.prototype.map = function (fn, thisp) {
  thisp = thisp || this
  var res = new Yallist()
  for (var walker = this.head; walker !== null;) {
    res.push(fn.call(thisp, walker.value, this))
    walker = walker.next
  }
  return res
}

Yallist.prototype.mapReverse = function (fn, thisp) {
  thisp = thisp || this
  var res = new Yallist()
  for (var walker = this.tail; walker !== null;) {
    res.push(fn.call(thisp, walker.value, this))
    walker = walker.prev
  }
  return res
}

Yallist.prototype.reduce = function (fn, initial) {
  var acc
  var walker = this.head
  if (arguments.length > 1) {
    acc = initial
  } else if (this.head) {
    walker = this.head.next
    acc = this.head.value
  } else {
    throw new TypeError('Reduce of empty list with no initial value')
  }

  for (var i = 0; walker !== null; i++) {
    acc = fn(acc, walker.value, i)
    walker = walker.next
  }

  return acc
}

Yallist.prototype.reduceReverse = function (fn, initial) {
  var acc
  var walker = this.tail
  if (arguments.length > 1) {
    acc = initial
  } else if (this.tail) {
    walker = this.tail.prev
    acc = this.tail.value
  } else {
    throw new TypeError('Reduce of empty list with no initial value')
  }

  for (var i = this.length - 1; walker !== null; i--) {
    acc = fn(acc, walker.value, i)
    walker = walker.prev
  }

  return acc
}

Yallist.prototype.toArray = function () {
  var arr = new Array(this.length)
  for (var i = 0, walker = this.head; walker !== null; i++) {
    arr[i] = walker.value
    walker = walker.next
  }
  return arr
}

Yallist.prototype.toArrayReverse = function () {
  var arr = new Array(this.length)
  for (var i = 0, walker = this.tail; walker !== null; i++) {
    arr[i] = walker.value
    walker = walker.prev
  }
  return arr
}

Yallist.prototype.slice = function (from, to) {
  to = to || this.length
  if (to < 0) {
    to += this.length
  }
  from = from || 0
  if (from < 0) {
    from += this.length
  }
  var ret = new Yallist()
  if (to < from || to < 0) {
    return ret
  }
  if (from < 0) {
    from = 0
  }
  if (to > this.length) {
    to = this.length
  }
  for (var i = 0, walker = this.head; walker !== null && i < from; i++) {
    walker = walker.next
  }
  for (; walker !== null && i < to; i++, walker = walker.next) {
    ret.push(walker.value)
  }
  return ret
}

Yallist.prototype.sliceReverse = function (from, to) {
  to = to || this.length
  if (to < 0) {
    to += this.length
  }
  from = from || 0
  if (from < 0) {
    from += this.length
  }
  var ret = new Yallist()
  if (to < from || to < 0) {
    return ret
  }
  if (from < 0) {
    from = 0
  }
  if (to > this.length) {
    to = this.length
  }
  for (var i = this.length, walker = this.tail; walker !== null && i > to; i--) {
    walker = walker.prev
  }
  for (; walker !== null && i > from; i--, walker = walker.prev) {
    ret.push(walker.value)
  }
  return ret
}

Yallist.prototype.reverse = function () {
  var head = this.head
  var tail = this.tail
  for (var walker = head; walker !== null; walker = walker.prev) {
    var p = walker.prev
    walker.prev = walker.next
    walker.next = p
  }
  this.head = tail
  this.tail = head
  return this
}

function push (self, item) {
  self.tail = new Node(item, self.tail, null, self)
  if (!self.head) {
    self.head = self.tail
  }
  self.length++
}

function unshift (self, item) {
  self.head = new Node(item, null, self.head, self)
  if (!self.tail) {
    self.tail = self.head
  }
  self.length++
}

function Node (value, prev, next, list) {
  if (!(this instanceof Node)) {
    return new Node(value, prev, next, list)
  }

  this.list = list
  this.value = value

  if (prev) {
    prev.next = this
    this.prev = prev
  } else {
    this.prev = null
  }

  if (next) {
    next.prev = this
    this.next = next
  } else {
    this.next = null
  }
}

},{}]},{},[7]);
